/*eslint no-unused-vars: ["error", { "argsIgnorePattern": "^state" }]*/
import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import console from 'console'
import router from '../../router'
// eslint-disable-next-line
import domtoimage from 'dom-to-image'
// eslint-disable-next-line
import { toPng } from 'html-to-image'

// eslint-disable-next-line
import store from '../store'
//import html2canvas from "html2canvas";


const state = {
	comment_html: '',
	export_progress: 0,
	export_progress_visible: false,
	DialogMessageDocuments: false,
	loading_foncier: false,
	parcelle: false,
	parcelle_risques: false,
	parcelle_zone_urbaine: false,
	parcelle_documents_urbanisme: false,
	module_ancien_adequation : true,
	load_offre_ancien_bi_url: '',
	load_offre_locatif_bi_url: '',
	load_rpls_url: false,

	ancien_iris: false,
	ancien_rayon: false,
	ancien_ville: false,

	ancien_iris_flat: false,
	ancien_rayon_flat: false,
	ancien_ville_flat: false,

	ancien_iris_house: false,
	ancien_rayon_house: false,
	ancien_ville_house: false,

	locatif_iris: false,
	locatif_rayon: false,
	locatif_ville: false,

	locatif_iris_flat: false,
	locatif_rayon_flat: false,
	locatif_ville_flat: false,

	locatif_iris_house: false,
	locatif_rayon_house: false,
	locatif_ville_house: false,

	ancien_rayon_loading: false,
	ancien_rayon_distance: 500,
	contour_prix_ancien: false,

	locatif_rayon_loading: false,
	locatif_rayon_distance: 500,
	contour_prix_locatif: false,
	cdchinurl: false,
	module_estimmo: true,
	module_histo_prog: true,
	estimmo: {
		programme_size: 30,
		superficies: [
			{
				typology: "T1",
				surface: 29,
				nb: 2,
				per: 0.6
			},
			{
				typology: "T2",
				surface: 44,
				nb: 11,
				per: 3.5
			},
			{
				typology: "T3",
				surface: 65,
				nb: 11,
				per: 3.7
			},
			{
				typology: "T4",
				surface: 87,
				nb: 5,
				per: 1.8
			},
			{
				typology: "T5",
				surface: 114,
				nb: 1,
				per: 0.4
			}
		],
	},
	loading_estimmo: false,
	kpi_fil_volume_loading: false,
	kpi_fil_volume_libelle: '',
	kpi_fil_volume: false,
	active_gisement: false,
	active_gisement_loading: false,
	loyer_tranches_typo_geo_time: false,
	GraphPrix_irisIds: false,
	GraphPrix_cityIds: false,	

	heatmap_irisIds: false,
	heatmap_cityIds: false,	
	chartVolumePromo: false,
	chartRythmePromo: false,
	chartPrixPromo: false, 
	chartPrixPromoHP: false,
	chartPrixAncien: false,
	grp_repart_forme: false,
	graide: false,
	grde: false,
	grp_repart_dest: false,

	bi_locatif: {
		"insee_code": {
			"nom": "",
			"code": ""
		},
		"code_iris": {
			"nom": "",
			"code": ""
		},
	},
	filtre_gisement : {
		bati: true,
		nonbati: true,
		biodiversite: false,
		patrimoine: false,
		risques_humains: false,
		risques_industriels: false,
		risques_naturels: false,
		area_min: 0,
		area_max: 999999999999,
		scoreeconomie_min: 0,
		scoreeconomie_max: 100,
		scorehabitat_min: 0,
		scorehabitat_max: 100,
	},
	filtre_gisement_time: false,
	listepoi: '',
	rpls_commune: false,
	loading_mutations: false,
	loading_gisements: false,
	loading_offre: false,
	BaseUrlBackend: process.env.VUE_APP_API_URL,
	rss_references: false,
	user: false,
	mrktime: false,
	onglet: 'onglet_prog',
	efocus_type: 'A',
	uniquementselection: false,
	loadingAll: false,
	progress_bar: false,
	list_secteur: false,
	secteurs: [],
	secteurs_lib: [],
	ref_secteurs: [],
	territoires_neuf: [],
	insee: false,
	insee_kpi: false,
	insee_sitadel: false,
	insee_sne: false,
	insee_offre_locative: false,
	insee_offre_vente: false,
	locatifajour: false,
	mod_loc_adeq_uptodate: false,
	mod_vte_adeq_uptodate: false,
	mod_res_adeq_uptodate: false,
	mod_csn_adeq_uptodate: false,
	yanport_typo_graph_prix_geo_time: false,
	yanport_typo_graph_prix_time: false,
	yanport_typo_graph_jour_geo_time: false,
	yanport_typo_graph_jour_time: false,
	lastMonday: false,
	lastMondayMinusOneYear: false,
	lastMondayMinusThreeYears: false,
	lastMondayMinusFiveYears: false,
	cityscanprixtime: false,
	preferences_init: false,
	imggooglestreetview : false,
	parcours_sans_neuf: ['efocus-parcours-personnalises-tous', 'efocus-parcours-personnalises-senior', 'efocus-parcours-personnalises-etudiant', 'efocus-parcours-personnalises-tourisme', 'efocus-parcours-personnalises-tout-age'],
	parcours_perso_rs: ['efocus-parcours-personnalises-tous', 'efocus-parcours-personnalises-senior', 'efocus-parcours-personnalises-etudiant', 'efocus-parcours-personnalises-tourisme', 'efocus-parcours-personnalises-tout-age'],
	preferences_defaut: {
		neuf: {
			filtres : {
				fu: ['collectif', 'individuel'],
				etat: ['actifs', 'projets', 'termines'],
				tva: ['reduite', 'pleine'],
				financements: ['psla', 'lli', 'brs', 'anru', 'autres', 'aucun'],
				anciennete : 3,
			},
			legende : 'prix', // gamme, etat
			listing: {
				etat : 'tout', // tout, vente, offre
				tva : 'reduite', // pleine, reduite
				parking: 'inclus', // inclus, sans
			}
		},
		rs: {
			filtres : {
				cible: ['seniors'], // seniors, etudiants, jeunes, sociales, tourisme, toutage
				nature: [
					'beguinage', 'copropriete', 'ephad', 'maison_repos', 'maison_repos_soin', 'res_autonomie', 'rss_libre', 'village_senior_prive', 'village_senior_social', 'marpa',
					//'rse_social', 'rse_mixte', 'rse_libre',
					//'fjt',
					//'chrs',
					//'hotel', 'res_tourisme', 'hotel_residence',
					//'coliving', 'habitat_partage', 'colocation'
				],
			},
		},
		ancien: {
			estimation: {
				typeId: 2,
				area: 60, 
				rooms: 3,
				condition: 3,
			}
		},
		locatif: {
			geo: 'iris' // iris, ville, epci
		},
		adresse_niv1: ['transports', 'education', 'commerces', 'vie', 'loisirs', 'numerique', 'services'],
		adresse_niv2: [
			'bus', 'metro', 'tramway', 'rapide', 'parking', 'gare', 'aeroport', 'port', 'velo', 'auto', 'borne' ,
			'creche', 'maternelle', 'elementaire', 'college', 'lycee_general', 'lycee_pro', 'universite', 'ecole_sup', 'formation_pro',
			'alimentation', 'bouche', 'utilitaire', 'shopping', 'soins', 'logement', 'vehicule',
			'sonore', 'olfactive', 'saturation_population', 'saturation_auto', 'polution_air', 'polution_electro', 'polution_radon',
			'bibliotheque', 'theatre', 'musee', 'cinema', 'bar', 'restaurant', 'discotheque', 'parc', 'sport_collectif', 'sport_individuel', 'hotel', 'hebergement',
			'haut_debit', 'fibre', '4g', '3g',
			'commissariat', 'gendarmerie', 'pompier', 'hopital', 'laboratoire', 'personnes_agees', 'pharmacie', 'generaliste', 'specialiste', 'poste', 'recyclage', 'dechet',
		],
		carto: {
			fond: 'couleurs', // couleurs, gris, satellite
			layers : [], // zac, qpv, qpv_300, communes
			poi : [],
		},
		livedata: ['statistiques_secteur', 'synoptique_programmes', 'synoptique_projets', 'optimisation', 'rs', 'ancien', 'locatif', 'adresse'],
	},
	preferences: {
		neuf: {
			filtres : {
				fu: ['collectif', 'individuel'],
				etat: ['actifs', 'projets', 'termines'],
				tva: ['reduite', 'pleine'],
				financements: ['psla', 'lli', 'brs', 'anru', 'autres', 'aucun'],
				anciennete : 10,
			},
			legende : 'prix', // gamme, etat
			listing: {
				etat : 'tout', // tout, vente, offre
				tva : 'reduite', // pleine, reduite
				parking: 'inclus', // inclus, sans
			}
		},
		rs: {
			filtres : {
				cible: ['seniors'], // seniors, etudiants, jeunes, sociales, tourisme, toutage
				nature: [
					'beguinage', 'copropriete', 'ephad', 'maison_repos', 'maison_repos_soin', 'res_autonomie', 'rss_libre', 'village_senior_prive', 'village_senior_social', 'marpa',
					//'rse_social', 'rse_mixte', 'rse_libre',
					//'fjt',
					//'chrs',
					//'hotel', 'res_tourisme', 'hotel_residence',
					//'coliving', 'habitat_partage', 'colocation'
				],
			},
		},
		ancien: {
			estimation: {
				typeId: 2,
				area: 60, 
				rooms: 3,
				condition: 3,
			}
		},
		locatif: {
			geo: 'iris' // iris, ville, epci
		},
		adresse_niv1: ['transports', 'education', 'commerces', 'vie', 'loisirs', 'numerique', 'services'],
		adresse_niv2: [
			'bus', 'metro', 'tramway', 'rapide', 'parking', 'gare', 'aeroport', 'port', 'velo', 'auto', 'borne' ,
			'creche', 'maternelle', 'elementaire', 'college', 'lycee_general', 'lycee_pro', 'universite', 'ecole_sup', 'formation_pro',
			'alimentation', 'bouche', 'utilitaire', 'shopping', 'soins', 'logement', 'vehicule',
			'sonore', 'olfactive', 'saturation_population', 'saturation_auto', 'polution_air', 'polution_electro', 'polution_radon',
			'bibliotheque', 'theatre', 'musee', 'cinema', 'bar', 'restaurant', 'discotheque', 'parc', 'sport_collectif', 'sport_individuel', 'hotel', 'hebergement',
			'haut_debit', 'fibre', '4g', '3g',
			'commissariat', 'gendarmerie', 'pompier', 'hopital', 'laboratoire', 'personnes_agees', 'pharmacie', 'generaliste', 'specialiste', 'poste', 'recyclage', 'dechet',
		],
		carto: {
			fond: 'couleurs', // couleurs, gris, satellite
			layers : [], // zac, qpv, qpv_300, communes
			poi : [],
		},
		livedata: ['statistiques_secteur', 'synoptique_programmes', 'synoptique_projets', 'optimisation', 'rs', 'ancien', 'locatif', 'adresse'],
	},
	modules_adresse: {
		adresse_services : false,
		adresse_numerique : false,
		adresse_loisirs : false,
		adresse_vie : false,
		adresse_commerces : false,
		adresse_education : false,
		adresse_transport : false,	
		adresse_transport_bus: false,
		adresse_transport_metro: false,
		adresse_transport_tram: false,
		adresse_transport_route_rapide: false,
		adresse_transport_parking: false,
		adresse_transport_gare: false,
		adresse_transport_aeroport: false,
		adresse_transport_port: false,
		adresse_transport_velo: false,
		adresse_transport_auto: false,
		adresse_transport_borne: false,

		adresse_ecole_creche: false,
		adresse_ecole_maternelle: false,
		adresse_ecole_elementaire: false,
		adresse_ecole_college: false,
		adresse_ecole_lycee: false,
		adresse_ecole_lycee_pro: false,
		adresse_ecole_universite: false,
		adresse_ecole_superieur: false,
		adresse_ecole_formation: false,
		
		adresse_commerce_alimentation: false,
		adresse_commerce_bouche: false,
		adresse_commerce_utilitaire: false,
		adresse_commerce_shopping: false,
		adresse_commerce_soin: false,
		adresse_commerce_logement: false,
		adresse_commerce_vehicule: false,

		adresse_sonore: false,
		adresse_olfactive: false,
		adresse_saturation_population: false,
		adresse_saturation_vehicule: false,
		adresse_air: false,
		adresse_electromagnetique: false,
		adresse_radon: false,

		adresse_haut_debit: false,
		adresse_fibre: false,
		adresse_mobile_4G: false,
		adresse_mobile_3G: false,

		adresse_loisir_bibliotheque: false,
		adresse_loisir_theatre: false,
		adresse_loisir_musee: false,
		adresse_loisir_cinema: false,
		adresse_loisir_bar: false,
		adresse_loisir_restaurant: false,
		adresse_loisir_discotheque: false,
		adresse_loisir_jardin: false,
		adresse_loisir_sport_collectif: false,
		adresse_loisir_sport_individuel: false,
		adresse_loisir_hotel: false,
		adresse_loisir_hebergement: false,

		adresse_service_commissariat: false,
		adresse_service_gendarmerie: false,
		adresse_service_pompier: false,
		adresse_service_hopital: false,
		adresse_service_laboratoire: false,
		adresse_service_agees: false,
		adresse_service_pharmacie: false,
		adresse_service_medecin: false,
		adresse_service_specialiste: false,
		adresse_service_poste: false,
		adresse_service_recyclage: false,
		adresse_service_dechet: false,
	},
	loyer_tranches: [],
	geo_init: false,
	activeSection2: '',
	viewlayer_promo: true,
	viewlayer_rs: false,
	viewlayer_rpls: false,
	viewlayer_offre: false,
	viewlayer_poi: false,
	viewlayer_pc: true,
	source_view: 'neuf',
	measurementId: 'G-9H7JBK5CC8',
	territoires_module:false,
	module_actif: null,
	refresh_prog: false,
	refresh_rs: false,
	refresh_annonce: false,
	refresh_offre: false,
	ModuleAdresse: false,
	nouveaute : [],
	bienslocatifs: false,
	parambienslocatifs: false,
	filter_ancien_time: false,
	filter_ancien_offre_time: false,
	filter_rpls_time: false,
	locatif: {
		loyer_tranches_geo: { irisIds : [], cityIds: [], agglomerationIds: [] },
		loyer_tranches_typo: [null, null, null, null, null, null],
		loyer_tranches_typo_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
		yanport_typo_ref: [null, null, null, null, null, null],
		yanport_typo_ref_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
		yanport_typo_prix: [null, null, null, null, null, null],
		yanport_typo_prix_geo : { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
		yanport_typo_graph_prix: [null, null, null, null, null, null],
		yanport_typo_graph_prix_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
		yanport_typo_jour: [null, null, null, null, null, null],
		yanport_typo_jour_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
		yanport_typo_graph_jour: [null, null, null, null, null, null],
		yanport_typo_graph_jour_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
		loyer_yanport_geo: {
			irisIds : {
				appel_biens: false,
				id: '',
				type: '',
				type_label: '',
				label: false,
				values: false,
				duration_values: false,
				mediane: false,
				count: false,
				value: false,
			}, cityIds: {
				appel_biens: false,
				id: '',
				type: '',
				type_label: '',
				label: false,
				values: false,
				duration_values: false,
				mediane: false,
				count: false,
				value: false,
			}, agglomerationIds: {
				appel_biens: false,
				id: '',
				type: '',
				type_label: '',
				label: false,
				values: false,
				duration_values: false,
				mediane: false,
				count: false,
				value: false,
			}
		}
	},
	loyer_yanport_date: [],
	filtre_locatif: {
		MeubleOui: true,
		MeubleNon: true,
		MeubleNC: true,
		price_min: 0 ,
		price_max: 999999999,
		area_min: 0,
		area_max: 999999999,
		t1 : true,
		t2 : true,
		t3 : true,
		t4 : true,
		t5 : true,
		A : true,
		B : true,
		C : true,
		D : true,
		E : true,
		F : true,
		G : true,
		NC : true,
		distance: 200,
	},
	filtre_offre_locatif: {
		MeubleOui: true,
		MeubleNon: true,
		MeubleNC: true,
		price_min: 0 ,
		price_max: 999999999,
		area_min: 0,
		area_max: 999999999,
		t1 : true,
		t2 : true,
		t3 : true,
		t4 : true,
		t5 : true,
		A : true,
		B : true,
		C : true,
		D : true,
		E : true,
		F : true,
		G : true,
		NC : true,
		distance: 200,
	},
	filtre_rs: {
		MeubleOui: true,
		MeubleNon: true,
		MeubleNC: true,
		ServiceOui: true,
		ServiceNon: true,
		ServiceNC: true,
		E1: true ,
		E2: true ,
		E3: true ,
		E4: true ,
		E5: true ,
		ENC: true ,
		etudiant: false,
		senior: true,
		jeune: false,
		inter: false,
		social: false,
		touriste: false,
		tout: false,
		natures: [],
		cible: [],
		nature: {
			BEGUINAGE: true,
			CHRS: false,
			COPROPRIETE: true,
			EHPAD: true,
			FJT: false,
			REPOS: true,
			REPOS_SOINS: true,
			AUTONOMIE: true,
			RSE_LIBRE: false,
			RSE_MIXTE: false,
			RSE_SOCIAL: false,
			RSS: true,
			VILLAGE_PRIVE: true,
			VILLAGE_SOCIAL: true,
			MARPA: true,
			HOTEL: false,
			RESIDENCE_DE_TOURISME: false,
			HOTEL_ET_RÉSIDENCE: false,
			COLIVING: false,
			COLIVING_HABITAT_PARTAGE: false,
			COLOCATION: false,
		}
	},
	mapdistance:200,
	mapdistancetime: false,
	mapdistanceoffre:200,
	mapdistanceoffretime: false,
	mapdistanceoffrelocatif:200,
	mapdistanceoffrelocatiftime: false,
	mapdistancerpls:200,
	mapdistancerplstime: false,
	filtre_ancien: {
		price_min: 0 ,
		price_max: 999999999,
		area_min: 0,
		area_max: 999999999,
		t1 : true,
		t2 : true,
		t3 : true,
		t4 : true,
		t5 : true,
		nbmois: 60,
		distance: 200,
		col : true,
		ind : true,
		cdh: '2017-01-01'
	},
	filtre_ancien_offre: {
		price_min: 0 ,
		price_max: 999999999,
		area_min: 0,
		area_max: 999999999,
		t1 : true,
		t2 : true,
		t3 : true,
		t4 : true,
		t5 : true,
		appartement: true,
		maison: true,
		A : true,
		B : true,
		C : true,
		D : true,
		E : true,
		F : true,
		G : true,
		NC : true,
		distance: 200,
	},
	filtre_rpls: {
		distance: 200,
	},
	_deleteDateMax: "",
	_deleteDateMin: "",
	liste_biens_locatifs: false,
	loyer_yanport_time:'',
	yanport_jwt : 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOjU4NzU0MDc5NzAzMjI0MzIsInR5cCI6IkFQSSIsImlzcyI6InlhbnBvcnQiLCJzdWIiOiJhZGVxdWF0aW9uLWVmb2N1cy1kZXYiLCJpYXQiOiIyMDIyLTAzLTE2VDE0OjM2OjU4LjE1OFoiLCJleHAiOiIyMTAwLTAxLTAxVDAwOjAwOjAwWiIsIm9yZyI6NDExOTgwMjk0NDU0NDc2OCwic3JjIjpbIkFEIiwiRFZGIl19.wGElcKVLxIXRA_rDMeV2POhWGQnvC0tNAIichmeaenU=',
	loyer_yanport: {
		appel_biens: false,
		id: '',
		type: '',
		type_label: '',
		label: false,
		values: false,
		duration_values: false,
		mediane: false,
		count: false,
		value: false,
	},
	active_segmentation: false,
	gestionhistorique: true,
	histo_program: false,
	idf: false,
	aide: false,
	aide_rs: false,
	aide_prog: false,
	aide_live: false,
	filters_promotion: false,
	preferences_promotion: false,
	filters_rs: false,
	filters_ancien: false,
	theme:false,
	autolog: false,
	dateheure_recharge:false,
	loading_cityscan_item: {
		_12: false,
		_14: false,
		_21: false,
		_10: false,
		_22: false,
		_15: false,
		_23: false
	},
	listeicons: ['82A-02','44243','82B-02','1601-02','82C-02','1624-02','84A-02','16240-02','84B-02','1622-02','84C-02','1623-02','85-02','16220-02','cached','date_range','trending_down','trending_flat','trending_up','44237','16221-02','44238','16222-02','44208','44239','16230-02','44209','44240','16231-02','44210','44241','16232-02','44211','44242','1650-02','160-02','44228','44213','44244','165-02','44245','44252','44246','44251','100-01','100-02','101-01','101-02','102-01','102-02','110-02','111-02','112-02','113-02','120-02','121-01','121-02','122-01','122-02','130-01','130-02','131-01','131-02','132-01','132-02','133-01','133-02','134-01','134-02','140-01','140-02','141-01','141-02','142-01','142-02','143-01','143-02','144-01','144-02','150-01','150-02','151-01','151-02','152-01','152-02','153-01','153-02','1611-02','170-01','170-02','171-01','171-02','172-01','172-02','173-01','173-02','174-01','174-02','175-01','175-02','180-02','181-02','182-02','184-02','185-02','186-02','190-02','191-02','192-02','193-01','193-02','1000-01','1000-02','1001-01','1001-02','1010-01','1010-02','1011-01','1011-02','1020-01','1020-02','1021-01','1021-02','1022-02','1100-02','1101-02','1102-02','1110-02','1111-02','1112-02','1120-02','1121-02','1122-02','1123-02','1130-02','1131-02','1132-02','1200-01','1200-02','1201-01','1201-02','1202-01','1202-02','1210-02','1220-01','1220-02','1221-01','1221-02','1222-01','1222-02','1300-01','1300-02','1301-01','1301-02','1310-01','1310-02','1311-01','1311-02','1320-01','1320-02','1321-01','1321-02','1330-01','1330-02','1331-01','1331-02','1340-01','1340-02','1341-01','1341-02','1342-01','1342-02','1400-01','1400-02','1410-01','1410-02','1420-01','1420-02','1430-01','1430-02','1440-01','1440-02','1500-01','1500-02','1510-01','1510-02','1520-01','1520-02','1530-01','1530-02','1600-02','1610-02','1700-01','1700-02','1701-01','1701-02','1710-01','1710-02','1720-01','1720-02','1730-01','1730-02','1740-01','1740-02','1750-01','1750-02','1840-02','1841-02','1900-02','1901-02','1902-02','1903-02','1905-02','1910-02','1911-02','1912-02','1913-02','1914-02','1915-02','1920-02','1921-02','1922-02','1923-02','1924-02','1930-01','1930-02','1931-01','1931-02','1932-01','1932-02','1933-01','1933-02','1934-01','1934-02','1935-01','1935-02','10000-01','10000-02','10001-01','10001-02','10011-01','10011-02','11210-02','11211-02','11230-02','11231-02','11232-02','18400-02','18401-02','18402-02','18403-02','18404-02','18410-02','18411-02','18412-02','18413-02','18414-02','18415-02','18416-02','18417-02','18418-02','110001-02','110002-02','110003-02','110004-02','110005-02','110006-02','110007-02','110008-02','110009-02','110010-02','110011-02','110012-02','110013-02','110014-02','110015-02','110016-02','110017-02','110018-02','110019-02','110101-02','110102-02','110103-02','110104-02','110105-02','110106-02','110107-02','110108-02','110109-02','110110-02','110111-02','110112-02','110113-02','110114-02','110115-02','110116-02','110117-02','110118-02','110119-02','110120-02','110121-02','110122-02','110123-02','112001-02','112002-02','112003-02','112004-02','112005-02','112006-02','sp07-01','sp07-02','sp19-01','sp19-02','sp20-01','sp20-02','sp21-01','sp21-02','sp87-02','sp88-02','sp89-02','sp105-02','sp123-02','1904-02','100000-01','100000-02','100001-02','100002-01','100002-02','100003-01','100003-02','100011-02','100020-02','100100-01','100100-02','100101-02','100102-01','100102-02','100110-01','100110-02','100111-02','100120-02','122200-02','122210-02','122211-02','112300-02','112301-01','112301-02','112310-02','112320-02','44254','176-02','1380-02','241-02','1231-02','1370-02','240-02','2011-02','2010-02','201-02','2002-02','2001-02','2000-02','200-02','44247','155-02','154-02','251-02','1373-02','1371-02','250-02','1334-02','1333-02','211-02','1332-02','210-02','44248','1323-02','230-02','1372-02','1322-02','44250','1361-02','1360-02','222-02','1344-02','1343-02','1353-02','221-02','1352-02','1351-02','1350-02','220-02','44249','1230-02','1460-02','1450-02','148-02','147-02','146-02','145-02','162-02','1621-02','261-02','1620-02','16210-02','16211-02','16212-02','1470-02','1441-02','1630-02','163-02'],
	optimisation: {
		entree: 'typologie',
		ryhtme: 'te',
		destination: 'toute',
		financement: 'tva_pleine_libre',
		prix: 'prix_sp'
	},
	menuvisible: true,
	headers_Kinaxia : {
		'Content-Type': 'application/json',
		'ApiKey': 'u</{8rH^(rdR:SH',
	},
	loading_cityscan: false,
	cityscan_scalesData: false,
	isochrone : {
		transportType:'DRIVING',
		duration:10,
	},
	cityscan: {
		scalesData: false,
		isochrone : {
			transportType:'DRIVING',
			duration:10,
		},
		clientKey: '89e8fa036068c960d0b47d50e7b2d3',
		realty : {name: "Estimation de prix", typeId: 3, area: 60, areaOther: null, rooms: 3, bedrooms: null,
		amenityProximity: null,  areaBalcony: null, areaCellar: null, areaGardenPrivate: null,
		areaGardenShared: null, areaLoggia: null, areaTerrace: null, bathrooms: null,					
		buildingConstruction: null, buildingDpe: null, buildingFloors: null,
		chargesMaintenance: null, chargesPropertyTax: null, condition: 3, condominiumCondition: null, 
		condominiumFacade: null, condominiumLots: null, condominiumStanding: null, detaxation: null,
		dualAspect: null, easement: null, elevator: null, floor: null, garden: null, light: null,
		noise: null, occupation: null, orientation: null, parkingBoxed: 0, parkingOpen: 0, pool: null,
		vista: null, walls: null},
		addressId : 0,
		activationId : 0,
		lat : 0,
		lon : 0,
		evaluationAdresse: false,
		adresse : {
			priceTrends: [],
			pm2 : 0,
			priceStandard : 0,
			priceLow : 0,
			priceHigh : 0,
			pm2_0: 0,
			pm2_12: 0,
			pm2_24: 0,
			pm2_36: 0,
			pm2_48: 0,
			loyer : 0,
			loyer12: 0,
			loyer24: 0,
			nb_biens:0,
			limite:'0',
			biens_comparables:[],
			route_rapide : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1210-02', duration:'', transportType:''},
			gare : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1220-02', duration:'', transportType:''},
			aeroport : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1221-02', duration:'', transportType:''},
			port : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1222-02', duration:'', transportType:''},
			parking : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1230-02', duration:'', transportType:''},
			services_vehicule : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1231-02', duration:'', transportType:''},
			services_logement : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1270-02', duration:'', transportType:''},
			commissariat : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1300-02', duration:'', transportType:''},
			gendarmerie : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1301-02', duration:'', transportType:''},
			pompiers : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1310-02', duration:'', transportType:''},
			urgences : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1311-02', duration:'', transportType:''},
			medecin : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1320-02', duration:'', transportType:''},
			pharmacie : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1321-02', duration:'', transportType:''},
			laboratoires : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1322-02', duration:'', transportType:''},
			specialistes : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1323-02', duration:'', transportType:''},
			alimentation : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1330-02', duration:'', transportType:''},
			shopping : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1331-02', duration:'', transportType:''},
			commerces_bouche : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1332-02', duration:'', transportType:''},
			commerces_utilitaires : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1333-02', duration:'', transportType:''},
			soins_beaute : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1334-02', duration:'', transportType:''},
			restaurant : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1340-02', duration:'', transportType:''},
			bar : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1341-02', duration:'', transportType:''},
			jardin : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1342-02', duration:'', transportType:''},
			plaisance : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			bibliotheques : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1350-02', duration:'', transportType:''},
			theatre : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1351-02', duration:'', transportType:''},
			musees : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1352-02', duration:'', transportType:''},
			cinema : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1353-02', duration:'', transportType:''},
			sport_collectif : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1360-02', duration:'', transportType:''},
			sport_individuel : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1361-02', duration:'', transportType:''},
			bus : {titre: 'Transport', score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1200-02', duration:'', transportType:''},
			metro : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1201-02', duration:'', transportType:''},
			tramway : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1202-02', duration:'', transportType:''},
			creche : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1400-02', duration:'', transportType:''},
			maternelle : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1410-02', duration:'', transportType:''},
			elementaire : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1420-02', duration:'', transportType:''},
			college : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1430-02', duration:'', transportType:''},
			lycee : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1440-02', duration:'', transportType:''},
			lycee_pro : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1441-02', duration:'', transportType:''},
			formation_pro : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1470-02', duration:'', transportType:''},
			universite : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1450-02', duration:'', transportType:''},
			superieures : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1460-02', duration:'', transportType:''},
			sonore : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			olfactive : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			air : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			electromagnetique : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			saturation_population : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			saturation_vehicules : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			haut_debit : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			mobile_4G : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			mobile_3G : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			fibre : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			velo : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-2000-02', duration:'', transportType:''},
			auto : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-2001-02', duration:'', transportType:''},
			borne : {titre: 'Transport',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-2002-02', duration:'', transportType:''},
			discotheque : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1343-02', duration:'', transportType:''},
			hotel : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1371-02', duration:'', transportType:''},
			hebergement : {titre: 'Loisirs et tourisme',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1373-02', duration:'', transportType:''},
			poste : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1380-02', duration:'', transportType:''},
			recyclage : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-2010-02', duration:'', transportType:''},
			dechets : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-2011-02', duration:'', transportType:''},
			radon : {score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'', duration:'', transportType:''},
			personnes_agees : {titre: "Services publics & Santé",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},			
			transports : {titre: 'Transports',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},
			education : {titre: 'Education',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},
			commerces : {titre: 'Commerces',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},
			services : {titre: 'Services',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},
			vie : {titre: "Qualité de vie",score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},
			numerique : {titre: 'Numérique',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},
			loisirs : {titre: 'Loisirs',score: 0, note: 'F', nb: 0, temps: '', transport: '', factors: [], icone:'icon-1372-02', duration:'', transportType:''},
			note_transports:'',
			note_education:'',
			note_commerces:'',
			note_services:'',
			note_qualite:'',
			note_numerique:'',
			note_loisirs:'',	
		}
	},
	mrk: {
		lat: false,
		lng: false
	},
	nolive: false,
	livedata_id:0,
	url_report : '',
	report_dispo : false,
	pin_type: 'prix',
	livedata: false,
	echelleprix_1 : 0,
	echelleprix_2 : 0,
	fitBounds: false,
	map_osm: false,
	select_parcelle: false,
	zoom_B:8,
	zoom_default:16,
	zoom: 16,
	tab: 'mois',
	forme: 'tout',
	view: 'home', // home, list, report
	view_old: 'home', // home, list, report
	viewlayer: '', // home, list, report
	viewprog:'',
	route: '',
	forme_urbaine: 2,
	adr_query: {
		data: {
			name : '',
			postcode : '',
			city : ''
		}
	},
	adr_init: '',
	zonage: '',
	filters_pc: {
		pc_promoteur: true,
		pc_bailleur: true,
		pc_epl: true,
		pc_administration: true,
		pc_autre: true,
		pc_nc: true,
		pc_autorise: true,
		pc_annule: false,
		pc_commence: true,
		pc_termine: false,
		filter_date: false,
		filter_date_type : '',
		filter_date_date : [false, false],
	},
	filters: {
		veb_avec: true,
		veb_sans: true,
		nb_filtre: 0,
		annee_actif: (new Date()).getFullYear()-3,
		termine : true,
		actif : true,
		col: true,
		ind: true,
		nb_one: true,
		nb_two: true,
		nb_three: true,
		nb_four: true,
		forme: { collectif: true, individuel: true },
		commercialisation: { actif: true, termine: true },
		projet: { programme: true, permis_construire: true },
		prix: { min: 0, max: 90000 },
		nblot: { min: 0, max: 200 },
		tvap: true,
		tvar: true,
		psla: true,
		lli: true,
		brs: true,
		anru: true,
		aucun: true,
		autres: true,
		tva: { small: true, big: true },
	},
	avm: {
		heatmap: {
			data: false,m: false,
			diff: false,
			cpt: false,
			price: false,
			rayon: false,
		},		
		commune_ref_tous: {
			prix_min: false,
			prix_med: false,
			prix_max: false,
		},
		commune: {
			prix_min: false,
			prix_med: false,
			prix_max: false,
		},
		ref_t3: {
			prix_min: false,
			prix_med: false,
			prix_max: false,
		},
		ref_tous: {
			prix_min: false,
			prix_med: false,
			prix_max: false,
		},
		prix_marche: false,
		prix_avenir: false,
		prix_evol: false
	},
	enable_notification: true, // active ou désactive l'affichage des notifications en haut à droite
	notifications: [], // Liste des objects "notification" à afficher en haut à droite
	notificationone: [],
	obs: true,
	listeville: [],
	rs_secteurs: [],
	programs: [],
	rss: [],
	rplss: [],
	offre: [],
	offre_locatif: [],
	communes: [],
	codecommunes: [],
	rs_communes: [],
	rs_codecommunes: [],
	rpls_communes: [],
	rpls_codecommunes: [],
	offre_communes: [],
	offre_codecommunes: [],
	selected_programs_syno: [],
	selected_programs: [],
	selected_secteurs: [],
	selected_rss_syno: [],
	selected_rss: [],
	selected_rs_secteurs: [],
	selected_rplss_syno: [],
	selected_rplss: [],
	selected_offre_syno: [],
	selected_offre: [],
	selected_rpls_secteurs: [],
	selected_offre_secteurs: [],
	expanded_program: false,
	expanded_program_mrk: false,
	expanded_gisement: false,
	expanded_rs: false,
	expanded_annonce: false,
	expanded_rpls: false,
	expanded_offre: false,
	expanded_offre_locatif: false,
	expanded_parcelle: false,
	programs_filter : [],
	rss_filter : [],
	rplss_filter : [],
	offre_filter : [],
	offre_locatif_filter: [],
	loading: false,
	loading_pdf: false,
	loading_calc: false,
	loading_avm: false,
	print: false,
	authorized: true,
	api_calls: {
		load_programs: false,
		load_rss: false,
		load_rplss: false,
		load_offre_ancien_bi: false,
		load_offre_locatif_bi: false,
		load_locatif: false,
	},
	jwt:"",
	user_id:"",
	region: "",
	departements: "",
	departement: "",
	FormeUrbaine:3,
	etape_selection:0,
	communes_selectionnees:[],
	nbprog: 0,
	nbprogselect : 0,
	nbrplsselect : 0,
	nboffreselect : 0,
	nbpcselect : 0,
	nbresidenceselect : 0,
	fond_carte: 0,
	fond_carte_loyer:1,

	contour_parcelle: false,
	contour_r_innondation: false,
	contour_r_nappe_phreatique: false,
	contour_r_mouvement_argileux: false,
	contour_r_glissement_terrain: false,
	contour_r_site_industriel: false,
	contour_r_sol_pollue: false,

	contour_ligne_metro: false,
	contour_ligne_gpe: false,
	contour_iso: true,
	contour_iso_map: true,
	contour_commune: false,
	contour_zac: false,
	contour_qpv: false,
	contour_pnru: false,
	contour_npnru: false,
	contour_qpv_trois: false,
	contour_metro: false,
	contour_tramway: false,
	contour_train: false,
	contour_poi: false,
	contour_ecole: false,
	contour_transports: false,
	contour_education: false,
	contour_commerces: false,
	contour_services: false,
	contour_loisirs: false,
	commune_zoom: false,
	contour_loyer: false,
	contour_loyer_time: false,
	contour_prix: false,
	ReportList: false,
	module_cityscan: false,
	module_foncier: false,
	module_rs: false,
	module_rpls: true,
	module_offre: true,
	program_prix : {
		min: 0,
		max: 30000,
		tab: []
	},
	loading_yanport: false,
	HeaderEfocusBack : {
		'Content-Type': 'application/json',
		'Authorization': 'Bearer '
	},
	contours_time: false
}



// GETTERS
const getters = {
	app: function(state) { return state },
	selected_programs: function(state) {
		return _.filter(state.programs, function(program) {
			return _.indexOf(state.selected_programs, program.id) > -1
		})
	},
	selected_rss: function(state) {
		return _.filter(state.rss, function(rs) {
			return _.indexOf(state.selected_rss, rs.id) > -1
		})
	},
	biens_comparables: function(state) {
		let t = []
		for (let n=0; n<state.cityscan.adresse.biens_comparables.length;n++) {
			if (state.cityscan.adresse.biens_comparables[n].propertyType !='industrial_commercial_premise') {
				t.push(state.cityscan.adresse.biens_comparables[n])
			}
		}
		return t
	},	
	ventilationprix: function(state) {
		return state.program_prix;
	},	
	livedata: function(state) {
		return state.livedata
	},
	nbprogselect: function(state) {
		return state.nbprogselect
	},
	nbresidenceselect: function(state) {
		return state.nbresidenceselect
	},
	selected_programs_syno: function(state) {
		return state.selected_programs_syno
	},
	selected_secteurs: function(state) {
		return state.selected_secteurs
	},
	expanded_program: function(state) {
		if (state.expanded_program) {
			return _.find(state.programs, { id: state.expanded_program });
		}
		return false
	},
	selected_rss_syno: function(state) {
		return state.selected_rss_syno
	},
	selected_rs_secteurs: function(state) {
		return state.selected_rs_secteurs
	},
	expanded_rs: function(state) {
		if (state.expanded_rs) {
			return _.find(state.rss, { id: state.expanded_rs });
		}
		return false
	},
	expanded_annonce: function(state) {
		if (state.expanded_annonce) {
			return _.find(state.liste_biens_locatifs.hits, { id: state.expanded_annonce });
		}
		return false
	},
	expanded_rpls: function(state) {
		if (state.expanded_rpls) {
			return _.find(state.rplss, { residence: state.expanded_rpls });
		}
		return false
	},
	expanded_offre: function(state) {
		if (state.expanded_offre) {
			return _.find(state.offre, { id: state.expanded_offre });
		}
		return false
	},
	expanded_offre_locatif: function(state) {
		if (state.expanded_offre_locatif) {
			return _.find(state.offre_locatif, { id: state.expanded_offre_locatif });
		}
		return false
	},
	expanded_parcelle: function(state) {
		if (state.expanded_parcelle) {
			//return _.find(state.parcelle, { id: state.expanded_parcelle });
		}
		return state.expanded_parcelle
		//return false
	},
	headers: function(state) {
		return {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + state.jwt
		};
	},
}



// ACTIONS
const actions = {
	envoiemaildemande: function({ dispatch }, data) {
		const url = state.BaseUrlBackend + '/sendmaildemande'
		data.user_mail = state.user.email
		dispatch('log_console', {message : data})
		axios.post(url, data, { headers: state.HeaderEfocusBack })
		.then(function() {
			// Nothing
		})
		
	},
	applique_rgpd: function({ dispatch }, data) {
		let sujet = 'E-focus - RGPD utilisateur ' + data.from
		const url = state.BaseUrlBackend + '/sendmailrgpd?mail=' + 'support@adequation-prod2023.atlassian.net'  + '&subject=' + sujet + '&content=' + data.content
		dispatch('log_console', {message : data})
		axios.get(url, { headers: state.HeaderEfocusBack })
		.then(function() {
			// Nothing
		})
		
	},
	set_mapdistancetime: function({ commit }, data) {
		commit('SET_MAPDISTANCETIME', data)
	},
	set_mapdistance: function({ commit }, data) {
		commit('SET_MAPDISTANCE', data)
	},

	set_mapdistanceoffretime: function({ commit }, data) {
		commit('SET_MAPDISTANCEOFFRETIME', data)
	},
	set_mapdistanceoffre: function({ commit, dispatch }, data) {
		commit('SET_MAPDISTANCEOFFRE', data)
		dispatch('load_offre_ancien_bi', { autorayon: false })
	},

	set_mapdistanceoffrelocatiftime: function({ commit }, data) {
		commit('SET_MAPDISTANCEOFFRELOCATIFTIME', data)
	},
	set_mapdistanceoffrelocatif: function({ commit, dispatch }, data) {
		commit('SET_MAPDISTANCEOFFRELOCATIF', data)
		dispatch('load_offre_locatif_bi', { autorayon: false })
	},

	set_mapdistancerplstime: function({ commit }, data) {
		commit('SET_MAPDISTANCERPLSTIME', data)
	},
	set_mapdistancerpls: function({ commit, dispatch }, data) {
		commit('SET_MAPDISTANCERPLS', data)
		dispatch('load_rpls', { autorayon: false })
	},

	set_efocus_type: function({ commit }, data) {
		commit('SET_EFOCUS_TYPE', data)
	},

	set_load_yanport: function({ commit }, data) {
		commit('SET_LOADING_YANPORT', data)
	},

	set_liste_poi: function({ commit }, data) {
		commit('SET_LISTE_POI', data)
	},

	set_loadingall: function({ commit }, data) {
		commit('SET_LOADINGALL', data)
	},

	set_nbprogselect: function({ commit }, data) {
		commit('SET_NBPROGSELECT', data)
	},

	set_nbrplsselect: function({ commit }, data) {
		commit('SET_NBRPLSSELECT', data)
	},

	set_nboffreselect: function({ commit }, data) {
		commit('SET_NBOFFRESELECT', data)
	},

	set_nbpcselect: function({ commit }, data) {
		commit('SET_NBPCSELECT', data)
	},

	inc_nbprogselect: function({ commit }, data) {
		commit('INC_NBPROGSELECT', data)
	},

	dec_nbprogselect: function({ commit }, data) {
		commit('DEC_NBPROGSELECT', data)
	},

	inc_nbrplsselect: function({ commit }, data) {
		commit('INC_NBRPLSSELECT', data)
	},

	inc_nboffresselect: function({ commit }, data) {
		commit('INC_NBOFFRESELECT', data)
	},

	dec_nbrplsselect: function({ commit }, data) {
		commit('DEC_NBRPLSSELECT', data)
	},

	dec_nboffreselect: function({ commit }, data) {
		commit('DEC_NBOFFRESELECT', data)
	},

	inc_nbpcselect: function({ commit }, data) {
		commit('INC_NBPCSELECT', data)
	},

	dec_nbpcselect: function({ commit }, data) {
		commit('DEC_NBPCSELECT', data)
	},

	set_nbresidenceselect: function({ commit }, data) {
		commit('SET_NBRESIDENCESELECT', data)
	},

	inc_nbresidenceselect: function({ commit }, data) {
		commit('INC_NBRESIDENCESELECT', data)
	},

	dec_nbresidenceselect: function({ commit }, data) {
		commit('DEC_NBRESIDENCESELECT', data)
	},

	setContours: function({ commit }, data) {		
		commit('SET_CONTOURS', data)
	},
	
	setContoursTime: function({ commit }) {
		commit('SET_CONTOURS_TIME')
	},
	
	set_rss_references: function({ commit }, data) {
		commit('SET_RSS_REFERENCES', data)
	},

	pin_type: function({ commit }, data) {
		commit('SET_PIN_TYPE', data)
	},	

	set_territoires_module: function({ commit }, data) {
		commit('SET_TERRITOIRES_MODULE', data)
	},
	set_modules_adresse: function({ commit }, data) {
		commit('SET_MODULES_ADRESSE', data)
	},
	add_notification: function({ commit, state }, data) {
		if (state.enable_notification) {
			commit('ADD_NOTIFICATION', { notification: data })
			setTimeout(function() {
				commit('REMOVE_NOTIFICATION', { notification: data })
			}, 4000)
		}
	},

	add_nouveaute: function({ commit }, data) {
		commit('ADD_NOUVEAUTE', { url: data.url })
	},
	
	set_fond_carte: function({ commit }, data){
		commit('SET_FOND', data)
	},
	
	set_fond_carte_loyer: function({ commit }, data){
		commit('SET_FOND_LOYER', data)
	},

	remove_notification: function({ commit }, data) {
		commit('REMOVE_NOTIFICATION', { notification: data.notification })
	},	
	
	change_onglet: function({ commit }, data) {
		commit('CHANGE_ONGLET', data)
	},	
	
	add_notificationone: function({ commit, state }, data) {
		if (state.enable_notification) {
			commit('ADD_NOTIFICATIONONE', { notificationone: data })
			setTimeout(function() {
				commit('REMOVE_NOTIFICATIONONE', { notificationone: data })
			}, 15000)
		}
	},
	
	ExportToXls: function({ state, dispatch }, data){
		const moduleMap = {
			'report': 'livedata',
			'report_B': 'livedata_B',
			'home': 'recherche',
			'neuf': 'module_neuf',
			'locatif': 'module_locatif',
			'adresse': 'module_adresse',
			'ancien': 'module_ancien',
			'ancien-mutations': 'module_ancien',
			'ancien-offre': 'module_ancien',
			'rss': 'module_rss',
			'vie': 'adresse-qualite',
			'transport': 'adresse-transports',
			'education': 'adresse-education',
			'commerces': 'adresse-commerces',
			'loisirs': 'adresse-loisirs',
			'services': 'adresse-services',
			'numerique': 'adresse-numerique',
			'': 'module',
		};
	
		const module = moduleMap[state.view] || state.view;
	
		dispatch('send_event_backend', {module: module, action: 'export to xls', option: data}); 
	
		// Téléchargez ou utilisez le dataUrl selon vos besoins
		const link = document.createElement('a');
		link.download = data.name + '.xlsx';
		ExcellentExport.convert({ anchor: link, filename: data.name, format: 'xlsx'},[{name: data.id, from: {table: data.id}}]);
		link.click();
	}, 

	ExportToPngArray: function({ state, dispatch }, data) {
		const moduleMap = {
			'report': 'livedata',
			'report_B': 'livedata_B',
			'home': 'recherche',
			'neuf': 'module_neuf',
			'locatif': 'module_locatif',
			'adresse': 'module_adresse',
			'ancien': 'module_ancien',
			'ancien-mutations': 'module_ancien',
			'ancien-offre': 'module_ancien',
			'rss': 'module_rss',
			'vie': 'adresse-qualite',
			'transport': 'adresse-transports',
			'education': 'adresse-education',
			'commerces': 'adresse-commerces',
			'loisirs': 'adresse-loisirs',
			'services': 'adresse-services',
			'numerique': 'adresse-numerique',
			'': 'module',
		};
	
		const module = moduleMap[state.view] || state.view;
	
		dispatch('send_event_backend', {module: module, action: 'export to png', option: data});
	
		const ids = data.ids; // Assume data.ids is an array of IDs
		const base64Images = [];
	
		// Function to hide elements if necessary
		const hideElement = (id) => {
			if (id === 'map') {
				document.getElementsByClassName('leaflet-control-container')[0].style.visibility = 'hidden';
			}
			if (data.exportid) {
				document.getElementById(data.exportid).style.visibility = 'hidden';
			}
		};
	
		// Function to show elements if necessary
		const showElement = (id) => {
			if (id === 'map') {
				document.getElementsByClassName('leaflet-control-container')[0].style.visibility = 'visible';
			}
			if (data.exportid) {
				document.getElementById(data.exportid).style.visibility = 'visible';
			}
		};
	
		// Helper function to process each element
		const processElement = (id) => {
			return new Promise((resolve, reject) => {
				const elementToExport = document.getElementById(id);
				if (!elementToExport) {
					reject(`Element with ID ${id} not found`);
					return;
				}
	
				let options = {
					height: elementToExport.scrollHeight,
					width: elementToExport.scrollWidth,
					style: {
						'transform': 'scale(1)',
						'transformOrigin': 'top left',
					},
					filter: (node) => {
						try {
						// Exclure les <link> venant de zohocdn.com
						if (node.tagName === 'LINK' && node.href && node.href.includes('zohocdn.com')) {
							return false;
						}

						// Exclure les <style> dont la feuille provient de zohocdn.com
						if (node.tagName === 'STYLE' && node.sheet && node.sheet.ownerNode) {
							const href = node.sheet.ownerNode.href;
							if (href && href.includes('zohocdn.com')) {
							return false;
							}
						}
						} catch (e) {
						// Ne rien exclure par défaut en cas d'erreur
						return true;
						}

						return true; // Garder tout le reste
					}
				};
	
				if (id === 'map') {
					options.height = elementToExport.offsetHeight;
					options.width = elementToExport.offsetWidth;
				}
	
				hideElement(id);
/*
				toPng(elementToExport, options)
				.then((dataUrl) => {
					base64Images.push({ id: id, dataUrl: dataUrl });
					showElement(id);
					resolve();
				})
				.catch((error) => {
					console.error(`Erreur lors de la génération de l'image pour l'élément avec ID ${id}`, error);
					showElement(id);
					reject(error);
				});
				*/
/*	*/
				domtoimage.toPng(elementToExport, options)
					.then((dataUrl) => {
						base64Images.push({id: id, dataUrl: dataUrl});
						showElement(id);
						resolve();
					})
					.catch((error) => {
						console.error(`Erreur lors de la génération de l'image pour l'élément avec ID ${id}`, error);
						showElement(id);
						reject(error);
					});
/**/					
			});
		};
	
		// Process all elements
		Promise.all(ids.map(id => processElement(id)))
			.then(() => {
				// Here you can dispatch or return the base64Images as needed
				// For example, you could return the images:
				return base64Images;
			})
			.catch((error) => {
				console.error('Erreur lors de la génération des images', error);
			});
	},
	
	ExportToPng: function({ state, dispatch }, data){
		const moduleMap = {
			'report': 'livedata',
			'report_B': 'livedata_B',
			'home': 'recherche',
			'neuf': 'module_neuf',
			'locatif': 'module_locatif',
			'adresse': 'module_adresse',
			'ancien': 'module_ancien',
			'ancien-mutations': 'module_ancien',
			'ancien-offre': 'module_ancien',
			'rss': 'module_rss',
			'vie': 'adresse-qualite',
			'transport': 'adresse-transports',
			'education': 'adresse-education',
			'commerces': 'adresse-commerces',
			'loisirs': 'adresse-loisirs',
			'services': 'adresse-services',
			'numerique': 'adresse-numerique',
			'': 'module',
		};
	
		const module = moduleMap[state.view] || state.view;
	
		dispatch('send_event_backend', {module: module, action: 'export to png', option: data});
	
		const elementToExport = document.getElementById(data.id);
		let options = {
			height: elementToExport.scrollHeight,
			width: elementToExport.scrollWidth,
			style: {
				'transform': 'scale(1)',
				'transformOrigin': 'top left',
			},
			filter: (node) => {
				try {
				// Exclure les <link> venant de zohocdn.com
				if (node.tagName === 'LINK' && node.href && node.href.includes('zohocdn.com')) {
					return false;
				}

				// Exclure les <style> dont la feuille provient de zohocdn.com
				if (node.tagName === 'STYLE' && node.sheet && node.sheet.ownerNode) {
					const href = node.sheet.ownerNode.href;
					if (href && href.includes('zohocdn.com')) {
					return false;
					}
				}
				} catch (e) {
				// Ne rien exclure par défaut en cas d'erreur
				return true;
				}

				return true; // Garder tout le reste
			}
		
		};
	
		if (data.id === 'map') {
			options.height = elementToExport.offsetHeight;
			options.width = elementToExport.offsetWidth;
			document.getElementsByClassName('leaflet-control-container')[0].style.visibility = 'hidden';
		}
	
		if (data.exportid) {
			document.getElementById(data.exportid).style.visibility = 'hidden';
		}
/*
		toPng(elementToExport, options)
		.then((dataUrl) => {
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = (data.name ? data.name : data.id) + '.png';
			link.click();

			if (data.id === 'map') {
			document.getElementsByClassName('leaflet-control-container')[0].style.visibility = 'visible';
			}
			if (data.exportid) {
			document.getElementById(data.exportid).style.visibility = 'visible';
			}
		})
		.catch((error) => {
			console.error("Erreur lors de la génération de l'image", error);
		});		
*/
/*		*/
		domtoimage.toPng(elementToExport, options)
		.then((dataUrl) => {
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = (data.name ? data.name : data.id) + '.png';
			link.click();
	
			if (data.id === 'map') {
				document.getElementsByClassName('leaflet-control-container')[0].style.visibility = 'visible';
			}
			if (data.exportid) {
				document.getElementById(data.exportid).style.visibility = 'visible';
			}
		})
		.catch((error) => {
			console.error('Erreur lors de la génération de l\'image', error);
		});
/**/		
	},

	set_filters_gisement: function({ commit }, data){
		commit('SET_FILTER_GISEMENT', data)
	},

	set_filters: function({ commit }, data){
		commit('SET_FILTER', data)
	},

	set_filters_preferences: function({ commit }, data){
		commit('SET_FILTER_PREFERENCES', data)
	},

	set_filters_pc: function({ commit }, data){
		commit('SET_FILTER_PC', data)
	},

	set_filters_promotion: function({ commit }, data){
		commit('SET_FILTERS_PROMOTION', data)
	},

	set_preferences_promotion: function({ commit }, data){
		commit('SET_PREFERENCES_PROMOTION', data)
	},

	set_filters_promotion_pc: function({ commit }, data){
		commit('SET_FILTERS_PROMOTION_PC', data)
	},

	set_filters_rs: function({ commit }, data){
		commit('SET_FILTERS_RS', data)
	},

	set_filters_ancien: function({ commit }){
		commit('SET_FILTERS_ANCIEN')
	},
	
	remove_notificationone: function({ commit }, data) {
		commit('REMOVE_NOTIFICATIONONE', { notificationone: data.notificationone })
	},
	
	sendmail: function({ state, dispatch }, data){
		
		const url = state.BaseUrlBackend + '/sendmail?mail=' + data.mail + '&subject=' + data.subject + '&content=' + data.content
		dispatch('log_console', {message : data})
		axios.get(url, { headers: state.HeaderEfocusBack })
		.then(function() {
			// Nothing
		})
	},
	
	forgot_password: function({ state, dispatch }, data){
		const url = state.BaseUrlBackend + '/ResetPassword'
		dispatch('log_console', {message : data})
		axios.post(url, {email : data.email, callBackUrl:"https://efocus.adequation.fr/EFOCUS2_WEB/FR/setpassword.awp"}, { headers: state.HeaderEfocusBack})
		.then(function() {
			// Nothing
		})
	},
	
	change_periodicite: function({ commit }, data){
		commit('CHANGE_PERIODE', data)
	},
	
	list_secteur: function({ commit }, data){
		commit('LIST_SECTEUR', data)
	},
	
	export_bienslocatifs: function({ state }){
		if (state.parambienslocatifs) {
			const url = state.BaseUrlBackend + '/proxy/yanport/properties?' + state.parambienslocatifs
			axios.get(url, { headers: state.HeaderEfocusBack})
			.then(function() {
				// Nothing
			})	
		}
	},
	
	async set_bienslocatifs({ commit, state }, data) {
		commit('SET_BIENSLOCATIFS', data);
		if (data.value && !state.loyer_yanport.appel_biens) {
			let param = 'irisIds=' + state.loyer_yanport.id;
			let zoneType = '';
	
			switch (state.fond_carte_loyer) {
				case 2:
					zoneType = 'CITY';
					param = 'cityIds=' + state.loyer_yanport.id;
					break;
				//case 3:
				//	zoneType = 'AGGLOMERATION';
				//	param = 'agglomerationIds=' + state.loyer_yanport.id;
				//	break;
				case 4:
					zoneType = 'DEPARTMENT';
					param = 'departments=' + state.loyer_yanport.id;
					break;
			}
	
			const d = new Date();
			const deleteDateMax = `${d.toISOString().substring(0, 10)}T00%3A00%3A00.000Z`;
			const deleteDateMin = `${d.getFullYear() - 1}${d.toISOString().substring(4, 10)}T00%3A44%3A00.000Z`;
			
			const queryParams = `size=500&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT&zoneType=${zoneType}&active=false&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=${deleteDateMax}&${param}&marketingTypes=RENT&deleteDateMin=${deleteDateMin}&source=AD&sort=marketing.publicationStartDate%3Adesc`;
			const url = `${state.BaseUrlBackend}/proxy/yanport/properties?${queryParams}`;

			try {
				const response = await axios.get(url, { headers: state.HeaderEfocusBack});
				commit('SET_LISTEBIENSLOCATIFS', { liste_biens_locatifs: response.data, param });
				commit('EDIT_API_CALLS', { load_locatif: { state: 'success', date: _.now() } })
			} catch (error) {
				console.error('Erreur lors de la récupération des biens locatifs:', error);
				// Gestion de l'erreur
			}
		}
	},

	// A Optimiser
	async load_histo_loyer_geo({ commit, state, dispatch }, data){
//		let url = ''
		let param = data.geo_type + "=" + data.loyer_id
		let lib = data.geo_lib
		let label = data.loyer_name
		let f = data.geo
		

		if (!state.dateMonday) {
			commit('SET_YANPORT_DATE_REQUEST')
		}
		let d = state.lastMonday
		let datedujour = d.toISOString()
		let dateMonday = state.lastMonday
		let dateFormatMonday = new Date(dateMonday);
		let datemin = state.lastMondayMinusOneYear
		let datemin2 = state.lastMondayMinusFiveYears
		let dmin = state.lastMondayMinusThreeYears.toISOString().substring(0, 10)
		
		let t=[]

		// eslint-disable-next-line
		async function CallYanport2(loyer_mmin, loyer_mmax) {
			const urlHistoLoyerTrancheTypo = state.BaseUrlBackend + '/yanport_typo/distribution?datemax=' + datedujour.substring(0, 10) + '&zoneType=' + data.geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin.toISOString().substring(0, 10) + "&loyermin=" + loyer_mmin + '&loyermax=' + loyer_mmax
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlHistoLoyerTrancheTypo, { headers: state.HeaderEfocusBack})
			.then(function(response) {				
				commit('SET_HISTO_LOYER_TRANCHES_TYPOTAB', {geo_type: data.geo_type, data: response.data})
				dispatch('set_load_yanport', {v : -1});
				return response
			}))
		}

		async function CallYanport() {
			const param1 = 'datemax=' + datedujour.substring(0, 10) + '&zoneType=' + data.geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin.toISOString().substring(0, 10)
			const param2 = 'datemax=' + datedujour.substring(0, 10) + '&zoneType=' + data.geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin2.toISOString().substring(0, 10)
			
			// Nombre de référence et surface moyenne
			const urlRef = state.BaseUrlBackend + '/yanport_typo/refsurf?' + param1
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlRef,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_REFSURF) {				
				commit('SET_YANPORT_TYPOTAB_REFSURF', {geo_type: data.geo_type, data: responseTYPO_REFSURF.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_REFSURF
			}))

			// Prix au m² HC
			const urlPrix = state.BaseUrlBackend + '/yanport_typo/prix?' + param1
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlPrix,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_PRIX) {				
				commit('SET_YANPORT_TYPOTAB_PRIX', {geo_type: data.geo_type, data: responseTYPO_PRIX.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_PRIX
			}))

			// Graphique des prix
			const urlGrPrix = state.BaseUrlBackend + '/yanport_typo/graphprix?' + param2
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlGrPrix,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_GRAPH_PRIX) {				
				commit('SET_YANPORT_TYPOTAB_GRAPH_PRIX', {geo_type: data.geo_type, data: responseTYPO_GRAPH_PRIX.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_GRAPH_PRIX
			}))

			// Nombre de jours
			/*
			const urlJour = state.BaseUrlBackend + '/yanport_typo/jours?' + param1
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlJour,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_JOUR) {				
				commit('SET_YANPORT_TYPOTAB_JOUR', {geo_type: data.geo_type, data: responseTYPO_JOUR.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_JOUR
			}))
			*/

			// Graphique des jours
			/*
			const urlGrJour = state.BaseUrlBackend + '/yanport_typo/graphjours?' + param2
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlGrJour,{ headers: state.HeaderEfocusBack})
			.then(function(responseGRAPH_JOUR) {				
				commit('SET_YANPORT_TYPOTAB_GRAPH_JOUR', {geo_type: data.geo_type, data: responseGRAPH_JOUR.data})
				dispatch('set_load_yanport', {v : -1});
				return responseGRAPH_JOUR
			}))
			*/
		}


		const url3 = state.BaseUrlBackend + '/proxy/yanport/properties/percentiles?size=20&' + param + '&existingFields=marketing.priceM2HC&existingFields=features.geometry.roomCount&propertyTypes=APARTMENT&active=false&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + dateFormatMonday.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&marketingTypes=RENT&percentiles=3.0&deleteDateMin=' + dmin.substring(0, 10) + 'T00%3A00%3A00.000Z&reliability=true&field=PRICE_M2_HC&source=AD'
		t.push(axios.get(url3, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			let loyer_mmin = Math.floor(response.data.values["3.0"])
			const urlMinMax = state.BaseUrlBackend + '/proxy/yanport/properties/percentiles?size=20&' + param + '&existingFields=marketing.priceM2HC&existingFields=features.geometry.roomCount&propertyTypes=APARTMENT&active=false&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + dateFormatMonday.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&marketingTypes=RENT&percentiles=97.0&deleteDateMin=' + dmin.substring(0, 10) + 'T00%3A00%3A00.000Z&reliability=true&field=PRICE_M2_HC&source=AD'
			t.push(axios.get(urlMinMax, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				let loyer_mmax = Math.floor(response.data.values["97.0"])+1
				let ind = loyer_mmin
				let tranches = []
				while (ind <= loyer_mmax) {
					tranches.push(ind)
					ind++
				}
				commit('SET_HISTO_LOYER_TRANCHES', {geo_type: data.geo_type, tranches: tranches})
				CallYanport2(loyer_mmin, loyer_mmax);
			}))
			return response
		}))
		/*
		url = state.BaseUrlBackend + '/proxy/yanport/properties/evolution?size=20&existingFields=features.geometry.roomCount&existingFields=marketing.publicationDays&propertyTypes=HOUSE&propertyTypes=APARTMENT' + f + '&interval=1&' + param + '&active=false&intervalUnit=YEARS&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + dateFormatMonday.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&extendedBoundMin=' + dmin + '&marketingTypes=RENT&intervalField=DELETE_DATE&percentiles=50.0&deleteDateMin=' + dmin.substring(0, 10) + 'T00%3A00%3A00.000Z&reliability=true&field=DURATION_DAYS&source=AD&sort=marketing.publicationStartDate%3Adesc&roomCounts=1&extendedBoundMax=' + dateFormatMonday.toISOString().substring(0, 10)		
		dispatch('set_load_yanport', {v : 1});
		t.push(axios.get(url, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_HISTO_LOYER_DURATION', {geo_type: data.geo_type, type_label : lib, label: label, values: response.data, count: data.loyer_count, value: data.loyer_value, id: data.loyer_id, type: data.loyer_zoneType})
			dispatch('set_load_yanport', {v : -1});
			return response
		}))
		*/
		const url2 = state.BaseUrlBackend + '/proxy/yanport/properties/evolution?size=20&existingFields=features.geometry.roomCount&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT' + f + '&interval=1&' + param + '&active=false&intervalUnit=YEARS&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + dateFormatMonday.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&extendedBoundMin=' + dmin + '&marketingTypes=RENT&intervalField=DELETE_DATE&percentiles=50.0&deleteDateMin=' + dmin.substring(0, 10) + 'T00%3A00%3A00.000Z&field=PRICE_M2_HC&source=AD&sort=marketing.publicationStartDate%3Adesc&extendedBoundMax=' + dateFormatMonday.toISOString().substring(0, 10)
		t.push(axios.get(url2, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_HISTO_LOYER', {geo_type: data.geo_type, type_label : lib, label: label, values: response.data, count: data.loyer_count, value: data.loyer_value, id: data.loyer_id, type: data.loyer_zoneType})
			CallYanport();			
			return response
		}))

		const urlMedLoyer = state.BaseUrlBackend + '/proxy/yanport/properties/percentiles?size=20&existingFields=features.geometry.roomCount&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT' + f + '&active=false&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + d.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&' + param + '&marketingTypes=RENT&percentiles=50.0&deleteDateMin=' + dmin.substring(0, 10) + 'T00%3A00%3A00.000Z&field=PRICE_M2_HC&source=AD&sort=marketing.publicationStartDate%3Adesc'
		dispatch('set_load_yanport', {v : 1});
		t.push(axios.get(urlMedLoyer,{ headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_MEDIANE_LOYER', {geo_type: data.geo_type, mediane: response.data})
			dispatch('set_load_yanport', {v : -1});
			return response
		}))
		
		await Promise.all(t);
	},

	// A Optimiser
	async load_histo_loyer({ commit, state, dispatch }, data){
		let param = ''
		let lib=''
		let label=''
		if (data.loyer_zoneType=='IRIS') {
			param = 'irisIds=' + data.loyer_id
			lib = 'IRIS'
			label = data.loyer_name
		} else {
			if (data.loyer_zoneType=='CITY') {
				param = 'cityIds=' + data.loyer_id
				lib = 'Ville'
				label = data.loyer_name
			}
		}
		let f = ''
		let geo_type = ''
		switch (state.fond_carte_loyer) {
			case 2:
				f = "&zoneType=CITY"
				geo_type = "cityIds"
				param = 'cityIds=' + data.loyer_id
			lib = 'Ville'
			label = data.loyer_name
			break;
			//case 3:
			//	f = "&zoneType=AGGLOMERATION"
			//	geo_type = "agglomerationIds"
			//	param = 'agglomerationIds=' + data.loyer_id
			//lib = 'Agglomération'
			//label = data.loyer_name
			//break;
			case 4:
				f = "&zoneType=DEPARTMENT"
				geo_type = "departments"
				param = 'departments=' + data.loyer_id
			lib = 'Département'
			label = data.loyer_name
			break;
			default:
			param = 'irisIds=' + data.loyer_id
			geo_type = "irisIds"
			lib = 'IRIS'
			label = data.loyer_name
			break;
		}
		
		if (!state.dateMonday) {
			commit('SET_YANPORT_DATE_REQUEST')
		}

		let d = state.lastMonday
		let datedujour = d.toISOString()
		let dateMonday = state.lastMonday
		let dateFormatMonday = new Date(dateMonday);
		let datemin = state.lastMondayMinusOneYear
		let datemin2 = state.lastMondayMinusFiveYears
		let dmin = state.lastMondayMinusThreeYears.toISOString().substring(0, 10)

		let t=[]

		function CallYanportHisto() {
			// Nombre de référence et surface moyenne
			const urlRef = state.BaseUrlBackend + '/yanport_typo/refsurf?datemax=' + datedujour.substring(0, 10) + '&zoneType=' + geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin.toISOString().substring(0, 10)
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlRef,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_REFSURF) {				
				commit('SET_YANPORT_TYPOTAB_REFSURF', {data: responseTYPO_REFSURF.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_REFSURF;
			}))

			// Prix au m² HC
			const urlPrix = state.BaseUrlBackend + '/yanport_typo/prix?datemax=' + datedujour.substring(0, 10) + '&zoneType=' + geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin.toISOString().substring(0, 10)
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlPrix,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_PRIX) {				
				commit('SET_YANPORT_TYPOTAB_PRIX', {data: responseTYPO_PRIX.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_PRIX
			}))

			// Graphique des prix
			const urlGrPrix = state.BaseUrlBackend + '/yanport_typo/graphprix?datemax=' + datedujour.substring(0, 10) + '&zoneType=' + geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin2.toISOString().substring(0, 10)
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlGrPrix,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_GRAPH_PRIX) {				
				commit('SET_YANPORT_TYPOTAB_GRAPH_PRIX', {data: responseTYPO_GRAPH_PRIX.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_GRAPH_PRIX
			}))

			// Nombre de jours
			/*
			const urlJour = state.BaseUrlBackend + '/yanport_typo/jours?datemax=' + datedujour.substring(0, 10) + '&zoneType=' + geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin.toISOString().substring(0, 10)
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlJour,{ headers: state.HeaderEfocusBack})
			.then(function(responseTYPO_JOUR) {				
				commit('SET_YANPORT_TYPOTAB_JOUR', {data: responseTYPO_JOUR.data})
				dispatch('set_load_yanport', {v : -1});
				return responseTYPO_JOUR
			}))
			*/
			// Graphique des jours
			/*
			const urlGrJour = state.BaseUrlBackend + '/yanport_typo/graphjours?datemax=' + datedujour.substring(0, 10) + '&zoneType=' + geo_type + "&zoneid=" + data.loyer_id + '&datemin=' + datemin2.toISOString().substring(0, 10)
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(urlGrJour,{ headers: state.HeaderEfocusBack})
			.then(function(responseGRAPH_JOUR) {				
				commit('SET_YANPORT_TYPOTAB_GRAPH_JOUR', {data: responseGRAPH_JOUR.data})
				dispatch('set_load_yanport', {v : -1});
				return responseGRAPH_JOUR
			}))
				*/

		} 

		commit('YANPORT_DATE', [datemin2.getFullYear(), datemin2.getFullYear()+1, datemin2.getFullYear()+2, datemin2.getFullYear()+3, datemin2.getFullYear()+4])
		commit('RESET_YANPORT_TIME', {})
		
		/*
		const urlLoyerDuration = state.BaseUrlBackend + '/proxy/yanport/properties/evolution?size=20&existingFields=features.geometry.roomCount&existingFields=marketing.publicationDays&propertyTypes=HOUSE&propertyTypes=APARTMENT' + f + '&interval=1&' + param + '&active=false&intervalUnit=YEARS&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + dateFormatMonday.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&extendedBoundMin=' + dmin + '&marketingTypes=RENT&intervalField=DELETE_DATE&percentiles=50.0&deleteDateMin=' + dmin + 'T00%3A00%3A00.000Z&reliability=true&field=DURATION_DAYS&source=AD&sort=marketing.publicationStartDate%3Adesc&extendedBoundMax=' + dateFormatMonday.toISOString().substring(0, 10)
		dispatch('set_load_yanport', {v : 1});
		t.push(axios.get(urlLoyerDuration, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_HISTO_LOYER_DURATION', {type_label : lib, label: label, values: response.data, count: data.loyer_count, value: data.loyer_value, id: data.loyer_id, type: data.loyer_zoneType})
			dispatch('set_load_yanport', {v : -1});
			return response
		}))
*/

		let url1 = state.BaseUrlBackend + '/proxy/yanport/properties/evolution?size=20&existingFields=features.geometry.roomCount&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT' + f + '&interval=1&' + param + '&active=false&intervalUnit=YEARS&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + dateFormatMonday.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&extendedBoundMin=' + dmin + '&marketingTypes=RENT&intervalField=DELETE_DATE&percentiles=50.0&deleteDateMin=' + dmin + 'T00%3A00%3A00.000Z&field=PRICE_M2_HC&source=AD&sort=marketing.publicationStartDate%3Adesc&extendedBoundMax=' + dateFormatMonday.toISOString().substring(0, 10)
		url1 = url1 + '&reliability=true'
		t.push(axios.get(url1, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_HISTO_LOYER', {type_label : lib, label: label, values: response.data, count: data.loyer_count, value: data.loyer_value, id: data.loyer_id, type: data.loyer_zoneType})
			CallYanportHisto();
			return response
		}))	

		const urlMedLoyer = state.BaseUrlBackend + '/proxy/yanport/properties/percentiles?size=20&existingFields=features.geometry.roomCount&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT' + f + '&active=false&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + d.toISOString().substring(0, 10) + 'T00%3A00%3A00.000Z&' + param + '&marketingTypes=RENT&percentiles=50.0&deleteDateMin=' + dmin + 'T00%3A00%3A00.000Z&field=PRICE_M2_HC&source=AD&sort=marketing.publicationStartDate%3Adesc'
		dispatch('set_load_yanport', {v : 1});
		t.push(axios.get(urlMedLoyer,{ headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_MEDIANE_LOYER', {mediane: response.data})
			dispatch('set_load_yanport', {v : -1});
			return response
		}))

		await Promise.all(t);
	},
	
	set_preferences: function({ commit, dispatch }, data) {
		commit('SET_PREFERENCES', { preferences: data.preferences, init: data.init })
		dispatch('setContours', {type: 'poi', contours: state.preferences.carto.poi})
		dispatch('set_view_layer_poi', {view: true})
		dispatch('app_cityscan_realty', {})
	},

	record_pref: function({ commit, state }) {
		commit('RECORD_PREFERENCES')
		
		let url = state.BaseUrlBackend + '/user/setpreferences'

		axios.post(url, state.preferences, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			if (response && response.data) {
				//
			}
		})
	},

	// A Optimiser
	getavm: function({ commit, state, dispatch }, data){
		function enprix(str) {
			if (str) {
				let n = parseFloat(str)
				if (n)				
				n = Math.round(n/10)*10		 
				return n.toLocaleString('fr-FR', {style: "decimal", currency: "EUR", maximumFractionDigits : "0"}) + " €"
			}
			return ""
		}
		
		function linearRegression(x, y)
		{
			let xs = 0;  // sum(x)
			let ys = 0;  // sum(y)
			let xxs = 0; // sum(x*x)
			let xys = 0; // sum(x*y)
			let yys = 0; // sum(y*y)
			
			let n = 0;
			for (; n < x.length && n < y.length; n++)
			{
				xs += x[n];
				ys += y[n];
				xxs += x[n] * x[n];
				xys += x[n] * y[n];
				yys += y[n] * y[n];
			}
			
			let div = n * xxs - xs * xs;
			let gain = (n * xys - xs * ys) / div;
			let offset = (ys * xxs - xs * xys) / div;
			let correlation = Math.abs((xys * n - xs * ys) / Math.sqrt((xxs * n - xs * xs) * (yys * n - ys * ys)));
			
			return { gain: gain, offset: offset, correlation: correlation };
		}
		
		dispatch('set_loading_avm', { loading: true })
		dispatch('SendEvent', { action: "AVM", opt_label: 'lat=' + data.latlng.lat + '&lon=' + data.latlng.lng, opt_value: 0 })
		let url = ''
		url = state.BaseUrlBackend + '/avm/getCommuneAll?lat=' + data.latlng.lat + '&lon=' + data.latlng.lng
		axios.get(url, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			if (response.data && response.data._source)
				commit('SET_AVM_COMMUNE_ALL', {prix_min: response.data._source.marche.prix_min, prix_med: response.data._source.marche.prix_med, prix_max: response.data._source.marche.prix_max})
		})
		url = state.BaseUrlBackend + '/avm/getCommune?lat=' + data.latlng.lat + '&lon=' + data.latlng.lng
		
		commit('SET_AVM_HEATMAP', {data: false, m : false, diff: false, cpt: false, price: false, rayon: false })
		axios.get(url, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			if (response.data && response.data._source)
			{
				commit('SET_AVM_COMMUNE', {prix_min: response.data._source.marche.prix_min, prix_med: response.data._source.marche.prix_med, prix_max: response.data._source.marche.prix_max})
			let url2 = ''
			url2 = state.BaseUrlBackend + '/avm/getReferencesAuto?lat=' + data.latlng.lat + '&lon=' + data.latlng.lng + '&ref=ref_t3'
			axios.get(url2, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				dispatch('log_console', {message : "1"})
				dispatch('log_console', {message : response})
				let hits = response.data.hits.hits
				let t = []
				let n = 0
				for (let i in hits) {
					t.push(Math.round(hits[i]._source.prix_total / hits[i]._source.surface,0))
					n+=1
				}	
				//t.sort()
				t.sort((a, b) => a - b);
				
				if (n) {
					let z = response.data.hits.PrixMed
					commit('SET_AVM_REF_T3', {prix_min: response.data.hits.PrixMin, prix_med: response.data.hits.PrixMed, prix_max: response.data.hits.PrixMax})
					
					let url3 = ''
					url3 = state.BaseUrlBackend + '/avm/getReferencesAuto?lat=' + data.latlng.lat + '&lon=' + data.latlng.lng + '&ref=ref_all_typo'
					axios.get(url3, { headers: state.HeaderEfocusBack})
					.then(function(response) {
						dispatch('log_console', {message : "2"})
						dispatch('log_console', {message : response})
						let hits = response.data.hits.hits
						let tt = []
						let i
						for (i in hits) {
							tt.push(Math.round(hits[i]._source.prix_total / hits[i]._source.surface,0))
						}	
						tt.sort(function(a, b){
							return a - b;
						})
						commit('SET_AVM_REF_ALL', {prix_min: response.data.hits.PrixMin, prix_med: response.data.hits.PrixMed, prix_max: response.data.hits.PrixMax})
						let nDiff = 0
						nDiff = Math.round(((Math.round(tt[tt.length-1]/10, 0)*10) - (Math.round(tt[0]/10, 0)*10)) / 6, 0)
						let tabTabPrix = []
						tabTabPrix.push('< ' + enprix(Math.round(tt[0]/10, 0)*10 + nDiff))
						tabTabPrix.push('< ' + enprix(Math.round(tt[0]/10, 0)*10 + (nDiff*2)))
						tabTabPrix.push('< ' + enprix(Math.round(tt[0]/10, 0)*10 + (nDiff*3)))
						tabTabPrix.push('< ' + enprix(Math.round(tt[0]/10, 0)*10 + (nDiff*4)))
						tabTabPrix.push('> ' + enprix(Math.round(tt[0]/10, 0)*10 + (nDiff*4)))
						
						let vJsonData = []
						for (i=0; i<5; i++) {
							for (let j=0; j<5; j++) {
								vJsonData.push({type: i, quarter: j, count: 0, cle : i.toString() + '_' + j.toString()})
							}
						}
						let q=0
						for (i=0; i<hits.length-1; i++) {
							if (Math.round(hits[i]._source.prix_total / hits[i]._source.surface,0) < (Math.round(tt[0]/10, 0)*10 + nDiff)) {
								q = 0
							} else {
								if (Math.round(hits[i]._source.prix_total / hits[i]._source.surface,0) < (Math.round(tt[0]/10, 0)*10 + (nDiff*2))) {
									q = 1
								} else {
									if (Math.round(hits[i]._source.prix_total / hits[i]._source.surface,0) < (Math.round(tt[0]/10, 0)*10 + (nDiff*3))) {
										q = 2
									} else {
										if (Math.round(hits[i]._source.prix_total / hits[i]._source.surface,0) < (Math.round(tt[0]/10, 0)*10 + (nDiff*4))) {
											q = 3
										} else {
											q = 4
										}
									}
								}
							}
							
							let r=0
							switch(hits[i]._source.typo)
							{
								case 'STUDIO':
								r=0	
								break;
								case '2 PIECES':
								r=1	
								break;
								case '3 PIECES':
								r=2	
								break;
								case '4 PIECES':
								r=3	
								break;
								default:
								r=4	
							}
							let o = vJsonData.findIndex(x => x.cle === r.toString() + '_' + q.toString());
							if (o<0) {
								vJsonData.push({type: r, quarter: q, count: 1, cle : r.toString() + '_' + q.toString()})
							} else {
								vJsonData[o].count = vJsonData[o].count + 1
							}
						}
						commit('SET_AVM_HEATMAP', {data: vJsonData, m : Math.round(tt[1]/10, 0)*10, diff: nDiff, cpt: hits.length, price: tabTabPrix, rayon: response.data.hits.rayon })
						
						let url4 = state.BaseUrlBackend + '/avm/getReferencesCommunes?lat=' + data.latlng.lat + '&lon=' + data.latlng.lng
						axios.get(url4, { headers: state.HeaderEfocusBack})
						.then(function(response) {
							dispatch('log_console', {message : "3"})
							dispatch('log_console', {message : response})
							let tabLog = []
							let u
							let sLadate
							let tabTableauDeDate = []
							let tabTableauDePrix = []
							let tabTableauDeSomm = []
							let hits = response.data.hits.hits
							let nCpt
							for (nCpt in hits) {
								sLadate = hits[nCpt]._source.periode
								if (sLadate) {
									sLadate = sLadate.substring(sLadate.length - 4, sLadate.length) + sLadate.substring(0, 1)
									if (hits[nCpt]._source.ventes_brut.sigma_surf_pi > 0 && sLadate != "") {
										if (tabTableauDeDate.indexOf(sLadate) < 0) {
											tabTableauDeDate.push(sLadate)
											tabTableauDePrix.push(0)
											tabTableauDeSomm.push(0)
										}
									}
								}
							}
							for (nCpt in hits) {
								sLadate = hits[nCpt]._source.periode
								if (sLadate) {
									sLadate = sLadate.substring(sLadate.length - 4, sLadate.length) + sLadate.substring(0, 1)
									if (hits[nCpt]._source.ventes_brut.sigma_surf_pi > 0 && sLadate != "") {
										u = tabTableauDeDate.indexOf(sLadate)
										if (u > -1) {
											tabTableauDePrix[u] += hits[nCpt]._source.ventes_brut.sigma_prix_pi
											tabTableauDeSomm[u] += hits[nCpt]._source.ventes_brut.sigma_surf_pi
										}
									}
								}
							}
							
							let tabLe_X = []
							let tabLe_Y = []
							let i
							for (i=0;i<tabTableauDeDate.length;i++) {
								tabLog.push({ date : parseInt(tabTableauDeDate[i]), prix: Math.round(tabTableauDePrix[i] / tabTableauDeSomm[i],0)})
							}
							
							tabLog = _.sortBy(tabLog, [ 'date' ])
							
							for (i=0;i<tabLog.length;i++ ) {
								tabLe_X.push(i)
								tabLe_Y.push(tabLog[i].prix)
							}
							
							let v = linearRegression(tabLe_X,tabLe_Y)
							
							let p_marche = z
							let p_avenir = Math.round((z + 5*v.gain)/10,0)*10
							let prix_evol = Math.round(((p_avenir - p_marche) / p_marche)*100,0)
							commit('SET_AVM_MARCHE', {prix_marche: p_marche, prix_avenir: p_avenir, prix_evol: prix_evol })
							dispatch('set_loading_avm', { loading: false })
							$("#btnd").click()
						})
						
					})
				} else {
					dispatch('log_console', {message : "4"})
					dispatch('log_console', {message : response})
					commit('SET_AVM_HEATMAP', {data: false, m : false, diff: false, cpt: false, price: false, rayon: false })
					commit('SET_AVM_COMMUNE_ALL', {prix_min: false, prix_med: false, prix_max: false})
					commit('SET_AVM_REF_T3', {prix_min: false, prix_med: false, prix_max: false})
					commit('SET_AVM_REF_ALL', {prix_min: false, prix_med: false, prix_max: false})
					commit('SET_AVM_MARCHE', {prix_marche: false, prix_avenir: false, prix_evol: false })
					dispatch('set_loading_avm', { loading: false })
				}
			})
		} else {
			dispatch('set_loading_avm', { loading: false })
		}
		})
	},

	resetavm: function({ commit }){
		commit('SET_AVM_HEATMAP', {data: false, m : false, diff: false, cpt: false, price: false, rayon: false })
	},

	log_console: function({ state }, data){
		if (data) {
			// console.log(data.message)
		}
	},


	get_foncier: function({ commit, state }, data){
		const endpoints = [
			/*
			{
			url: '/foncier/risques/searchByPolygonDB',
			key: 'parcelle_risques',
			},
			*/
			{
			url: '/foncier/zone_urbaines/searchByPolygonDB',
			key: 'parcelle_zone_urbaine',
			},
			{
			url: '/foncier/documents_urbanisme/searchByPolygonDB',
			key: 'parcelle_documents_urbanisme',
			},
		];
		commit('SET_VALUE', { c: 'loading_foncier', v: true });

		const promises = endpoints.map(({ url, key }) => {
			const fullUrl = state.BaseUrlBackend + url;

			return axios
			.post(fullUrl, data.p, { headers: state.HeaderEfocusBack })
			.then(function(response) {
				console.log(`✅ Réponse pour ${key}`, response);
				const features = response?.data?.features;
				commit('SET_VALUE', {
				c: key,
				v: Array.isArray(features) && features.length ? features : false,
				});
			})
			.catch(function(error) {
				console.error(`❌ Erreur pour ${key}`, error);
				commit('SET_VALUE', { c: key, v: false });
			});
		});

		// Action une fois tous les appels terminés
		Promise.all(promises).then(function() {
			let urlrisque = state.BaseUrlBackend + '/foncier/parcelles?id=' + state.parcelle.reference
			if (data.a) {
				urlrisque = urlrisque + '&adresse=' + state.adr_init.name
			}

			axios.get(urlrisque, {headers: state.HeaderEfocusBack})
			.then(function(responseRisques) {
				if (responseRisques.data) {
					commit('SET_VALUE', {c: 'parcelle_infos', v: responseRisques.data})
					
				}
				else commit('SET_VALUE', {c: 'parcelle_infos', v: false})
				commit('SET_VALUE', { c: 'loading_foncier', v: false });
				console.log('✅ Tous les appels fonciers sont terminés');
			})
		});



		/*
  		let urlrisque = state.BaseUrlBackend + '/foncier/risques/searchByPolygonDB'
		axios.post(urlrisque, data, {headers: state.HeaderEfocusBack})
		.then(function(responseRisques) {
			console.log(responseRisques)
			if (responseRisques.data && responseRisques.data.features && responseRisques.data.features.length) {
				commit('SET_VALUE', {c: 'parcelle_risques', v: responseRisques.data.features})
				
			}
			else commit('SET_VALUE', {c: 'parcelle_risques', v: false})
		})
		let urlzonage = state.BaseUrlBackend + '/foncier/zone_urbaines/searchByPolygonDB'
		axios.post(urlzonage, data, {headers: state.HeaderEfocusBack})
		.then(function(responseZu) {
			console.log(responseZu)
			if (responseZu.data && responseZu.data.features && responseZu.data.features.length) {
				commit('SET_VALUE', {c: 'parcelle_zone_urbaine', v: responseZu.data.features})
				
			}
			else commit('SET_VALUE', {c: 'parcelle_zone_urbaine', v: false})
		})

		let urldocurba = state.BaseUrlBackend + '/foncier/documents_urbanisme/searchByPolygonDB'
		axios.post(urldocurba, data, {headers: state.HeaderEfocusBack})
		.then(function(responseDocs) {
			console.log(responseDocs)
			if (responseDocs.data && responseDocs.data.features && responseDocs.data.features.length) {
				commit('SET_VALUE', {c: 'parcelle_documents_urbanisme', v: responseDocs.data.features})
				
			}
			else commit('SET_VALUE', {c: 'parcelle_documents_urbanisme', v: false})
		})	
			*/
	},

	//get_parcelle({ lat : state.adr_init.latlng.lat, lon : state.adr_init.latlng.lng })
	get_parcelle: function({ commit, state, dispatch }, data){
		let cc = { lat : data.lat, lon : data.lon }
		let urlfoncier = state.BaseUrlBackend + '/foncier/parcelles/searchByCoordinateDB'
		axios.post(urlfoncier, cc, {headers: state.HeaderEfocusBack})
		.then(function(response) {
			if (response.data && response.data.features && response.data.features.length) {
				commit('SET_VALUE', {c: 'parcelle', v: response.data.features[0].properties})
				dispatch('get_foncier', {p: response.data, a: true});
			}
			else commit('SET_VALUE', {c: 'parcelle', v: false})
		})
	},

	set_search: function({ commit, state, dispatch }, data){
		
		// Récupère le Geojson correspondant à la commune (ou arrondissement)
		function getGeoJsonUrl(city, arrondissement) {
			const baseUrl = "https://www.myadequation.fr/GEOJSON";
			const cityMap = {
				'paris': 'Paris',
				'marseille': 'Marseille',
				'lyon': 'Lyon'
			};
			const cityCode = cityMap[city.toLowerCase()];
			if (!cityCode) {
				return `https://app.myadequation.fr/map/?service=WFS&version=1.0.0&request=GetFeature&typeName=Web:commune&maxFeatures=1&&cql_filter=INTERSECTS(geom,POINT(${data.latlng.lng} ${data.latlng.lat}))&outputFormat=application/json`;
			}
			let arrNumber = arrondissement.replace(/[^0-9]/g, '');
			if (!arrNumber) {
				return `https://app.myadequation.fr/map/?service=WFS&version=1.0.0&request=GetFeature&typeName=Web:commune&maxFeatures=1&&cql_filter=INTERSECTS(geom,POINT(${data.latlng.lng} ${data.latlng.lat}))&outputFormat=application/json`;
			}
			arrNumber = '0' + arrNumber;
			arrNumber = arrNumber.slice(-2);
			let arrCode = '';
			switch (cityCode) {
				case 'Paris':
					arrCode = arrNumber == '0' ? '75056' : arrNumber.padStart(5, '751')
					break;
				case 'Lyon':
					arrNumber = arrNumber.slice(-1);
					arrCode = arrNumber == '0' ? '69123' : arrNumber.padStart(5, '6938')
					break;
				case 'Marseille':
					arrCode = arrNumber == '0' ? '13055' : arrNumber.padStart(5, '132')
					break;
					
				default:
					break;
			}
			return `${baseUrl}/${cityCode}/${arrCode}.geojson`;
		}

		// Zoom sur la carte et attend sa réalisation avant de récupérer les coordonnées de la boundingbox
		async function ajusterZoomEtObtenirCoordonnees(that, z, data, state) {
			// Modifier le zoom de la carte
			if (state.parcours_perso_rs.includes(state.efocus_type)) {
				const centreCercle = [state.mrk.lat, state.mrk.lng]; // Coordonnées de Paris, par exemple
				const rayonCercle = 1000; // Rayon en mètres
				let a = L.featureGroup().addTo(that.map_osm)
				L.circle(centreCercle, {
					color: 'red',      // Couleur de la bordure du cercle
					fillColor: '#f03', // Couleur de remplissage
					fillOpacity: 0.5,  // Opacité du remplissage
					radius: rayonCercle // Rayon du cercle en mètres
				}).addTo(a)
				that.map_osm.fitBounds(a.getBounds());
				a.clearLayers()

			} else {
				that.map_osm.setZoom(z);
			}
			
			// Utilisation de setTimeout pour attendre quelques millisecondes si nécessaire
			// Cela peut aider à garantir que le zoom est correctement appliqué
			await new Promise(resolve => setTimeout(resolve, 1000));
			
			// Récupérer les nouvelles coordonnées de la bounding box après le changement de zoom
			dispatch('SendEvent', { action: "Recherche Par adresse", opt_label: data.city + ' ' + data.name, opt_value: 0 })
			dispatch('send_event_backend', {module: 'recherche', action: 'adresse', option: data});
			dispatch('load_programs', {type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }, filtre_prix: data.init, danscettezone: data.danscettezone})
			dispatch('load_rs', {type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
			if (!data.danscettezone) {
				dispatch('load_rpls', {autorayon: true, type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
				dispatch('load_offre_ancien_bi', {autorayon: true, type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
				dispatch('load_offre_locatif_bi', {autorayon: true, type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
			}
		}

		if (state.view=='neuf' || state.view=='') {
			commit('SET_VIEW_LAYER_PROMO', { view: true })
		}

		commit('REMOVE_ALL_PROGRAMS', {})
		commit('REMOVE_ALL_RSS', {})
		commit('RAZ_SELECTED_SECTEUR', {})
		commit('RAZ_SELECTED_PROGRAMMES', {})
		dispatch('set_loadingall', { loadingAll: true })
		dispatch('raz_selection', {});
		dispatch('zoom_carte', {});
		commit('INIT_DATE_YANPORT', {  })
		commit('SET_FITBOUNDS', false)
		commit('SET_COMMUNE_ZOOM', false)
		gtag('event', 'recherche', {'event_category': 'action','event_label': 'recherche'});
		let that = this
		commit('SET_ZOOM', {zoom : 16})
		
		commit('SET_LOCATIFAJOUR', { locatifajour: false })
		commit('SET_VALUE', { c: "mod_loc_adeq_uptodate", v : false })
		commit('SET_VALUE', { c: "mod_vte_adeq_uptodate", v : false })
		commit('SET_VALUE', { c: "mod_res_adeq_uptodate", v : false })
		commit('SET_VALUE', { c: "mod_csn_adeq_uptodate", v : false })

		if (data.init) {
			commit('SET_IMG_STREETVIEW', {url : false})
			commit('SET_ADR_INIT', data)
			this.map_osm.panTo(new L.LatLng(data.latlng.lat, data.latlng.lng));
//			this.map_osm.setView([data.latlng.lat, data.latlng.lng], this.zoom)
		}

		if (data.type != 'boundingbox') {
			commit('SET_FILTER', { veb_avec: state.filters.veb_avec, veb_sans: state.filters.veb_sans, termine: state.filters.termine, actif: state.filters.actif, projet: state.filters.projet, 
				col: state.filters.col, ind: state.filters.ind, nb_one: state.filters.nb_one, nb_two: state.filters.nb_two, nb_three: state.filters.nb_three, nb_four: state.filters.nb_four, 
				prixmin: 0, prixmax: 90000, tvap: state.filters.tvap, tvar: state.filters.tvar, annee_actif: state.filters.annee_actif, psla: state.filters.psla, lli: state.filters.lli, brs: state.filters.brs, 
				autres: state.filters.autres, anru: state.filters.anru, aucun: state.filters.aucun, affichage_prix_etat: state.filters.affichage_prix_etat, affichage_prix_tva: state.filters.affichage_prix_tva,
				affichage_prix_pk: state.filters.affichage_prix_pk})
			let bSansModules = true
			let bycity = ''
			if (data.type =='city') {
				bycity = '&city=' + data.name
			}
			
			dispatch('get_parcelle', { lat : data.latlng.lat, lon : data.latlng.lng })

			let urlc = state.BaseUrlBackend + '/coordinates/get?lat=' + data.latlng.lat + '&lon=' + data.latlng.lng + '&fields=code' + bycity								
			axios.get(urlc, {headers: state.HeaderEfocusBack})
			.then(function(response) {
				if (response.status == '200' || response.status != '200') {
					if (response.data) {
						commit('SET_IMG_STREETVIEW', {url : response.data.ggsv})
						let insee = response.data.insee

						let urlinsee = state.BaseUrlBackend + '/insee/getFiche?id=' + response.data.insee
						axios.get(urlinsee, {headers: state.HeaderEfocusBack})
						.then(function(response_insee) {
							commit('SET_INSEE', {insee: response_insee.data})
						})

						let urlrplsinsee = state.BaseUrlBackend + '/rpls/commune/' + response.data.insee
						axios.get(urlrplsinsee, {headers: state.HeaderEfocusBack})
						.then(function(response_rpls) {
							if (response_rpls.data.found) commit('SET_RPLS_COM', {rpls_commune: response_rpls.data})
							else commit('SET_RPLS_COM', {rpls_commune: false})
						})

						try {
							bSansModules = (state.territoires_module.indexOf(response.data.geo_departement_code)==-1)
							
							if (data.init) {
								data.territoire = response.data.territoire
								data.insee = response.data.insee
								data.zonage = response.data.zonage
								data.epci_city_list = response.data.communes_epci
								data.epci_label = response.data.geo_epci_nom
								data.epci_code = response.data.geo_epci_code
								data.iris_label = response.data.iris_libelle
								data.iris_code = response.data.iris_code
								data.zonage_social = false
								if (response.data.zonage_social) data.zonage_social = response.data.zonage_social
								commit('SET_ADR_INIT', data)
								commit('SET_GEO_INIT', response.data)								
								dispatch('load_ancien')
								dispatch('load_locatif')
							}
							if (state.territoires_module == 'ALL' || state.territoires_module == '["ALL"]') {
								bSansModules = false
							} else {
								if (Array.isArray(state.territoires_module)) {
									if (state.territoires_module.indexOf("ALL")>=0) {
										bSansModules = false
									}
								}
							}
							if (state.parcours_perso_rs.includes(state.efocus_type)) {
								commit('SET_MODULE_ACTIF', {actif : false})
								dispatch('set_view', { view: 'rss' })
							} else {
								if (bSansModules || (state.efocus_type!='A')) {
									commit('SET_MODULE_ACTIF', {actif : false})
									dispatch('set_view', { view: 'neuf' })
								} else {
									commit('SET_MODULE_ACTIF', {actif : true})
									dispatch('set_view', { view: '' })
								}
							}

							commit('SET_ADR_INIT', data)

							// Appel Estimmo
							if (['67', '68', '57', '2A', '2B', '20', '97'].includes(insee.substring(0, 2))) {
								console.log('pas d\'estimmo sur ce département')
								commit('SET_VALUE', {c: 'module_estimmo', v: false});
							} else {
								commit('SET_VALUE', {c: 'module_estimmo', v: true});
								dispatch('load_estimmo', {latlng :{ lat : data.latlng.lat, lng : data.latlng.lng}, p: state.estimmo})
							}

						} catch (error) {
							console.log(error)
						}
					}
				}
			})	
			
			commit('SET_ADR_QUERY', {data : data})
		}

		if (data.type =='city') {
			commit('SET_MARKER', false)
		
			const UneUrl = getGeoJsonUrl(data.city, data.name);
			
			$.getJSON(UneUrl, function(dataRegion)
			{
				let gvRegion2 = JSON.stringify(dataRegion);
				commit('SET_FITBOUNDS', true)
				commit('SET_COMMUNE_ZOOM', dataRegion)
				dispatch('SendEvent', { action: "Recherche Par Ville", opt_label: data.city + ' ' + data.name, opt_value: 0 })
				dispatch('send_event_backend', {module: 'recherche', action: 'ville', option: data});
				dispatch('load_programs', {type_search:'polygon', cc : gvRegion2, filtre_prix: data.init, danscettezone: data.danscettezone})
				dispatch('load_rs', {type_search:'polygon', cc : gvRegion2})
				if (!data.danscettezone) {
					dispatch('load_rpls', {autorayon: true, type_search:'polygon', cc : gvRegion2})
					dispatch('load_offre_ancien_bi', {autorayon: true, type_search:'polygon', cc : gvRegion2})
					dispatch('load_offre_locatif_bi', {autorayon: true, type_search:'polygon', cc : gvRegion2})
				}
				commit('SET_MARKER', {lat: data.latlng.lat, lng: data.latlng.lng})
			});
			
		} else {
			if ((data.type != "boundingbox" && data.type != "lasso")) {
				let vz = 16;
				if (state.efocus_type=='B') vz = 14
				commit('SET_ZOOM', {zoom : vz})
				commit('SET_MARKER', {lat: data.latlng.lat, lng: data.latlng.lng})
				that.map_osm.setView(new L.LatLng(data.latlng.lat, data.latlng.lng), vz)
				ajusterZoomEtObtenirCoordonnees(that, vz, data, state)
			} else {
				dispatch('SendEvent', { action: "Recherche Par adresse", opt_label: data.city + ' ' + data.name, opt_value: 0 })
				dispatch('send_event_backend', {module: 'recherche', action: 'adresse', option: data});
				dispatch('load_programs', {type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }, filtre_prix: data.init, danscettezone: data.danscettezone})
				dispatch('load_rs', {type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
				if (!data.danscettezone) {
					dispatch('load_rpls', {autorayon: true, type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
					dispatch('load_offre_ancien_bi', {autorayon: true, type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
					dispatch('load_offre_locatif_bi', {autorayon: true, type_search:'bb', cc : { hd_lat : that.map_osm.getBounds()._northEast.lat, hd_lon : that.map_osm.getBounds()._southWest.lng, bg_lat : that.map_osm.getBounds()._southWest.lat, bg_lon : that.map_osm.getBounds()._northEast.lng, size : 2000, id : 1 }})
				}
			}
		}

		if (state.parcours_perso_rs.includes(state.efocus_type)) {
			dispatch('setContours', {type: 'zac', contours: true})
			dispatch('setContours', {type: 'qpv', contours: true})
			dispatch('setContours', {type: 'qpv_trois', contours: true})
			dispatch('setContours', {type: 'poi', contours: ["Métro", "Tramway", "Supermarché", "Hypermarché", "Hôpital", "Pharmacie", "Médecin", "Bureau de poste"]})
		} else {
			if (state.efocus_type=='B') {
				dispatch('setContours', {type: 'qpv', contours: true})
				dispatch('setContours', {type: 'qpv_trois', contours: true})
				dispatch('setContours', {type: 'poi', contours: ["Gare", "Métro", "Aéroport"]})
			} else {
				// Gestion préférences
				//dispatch('setContours', {type: 'qpv', contours: (state.preferences.carto.layers.indexOf('qpv')>-1)})
				//dispatch('setContours', {type: 'qpv_trois', contours: (state.preferences.carto.layers.indexOf('qpv_300')>-1)})
				//dispatch('setContours', {type: 'poi', contours: state.preferences.carto.poi})
			}
		}
		dispatch('setContoursTime')
	},

	SendEventView: function({state}, data) {
		try {
			if (!(data || !data)) console.log(data)
		} catch (error) {
			// erreur
		}
	},	
	
	SendEvent: function({state}, data) {
		try {
			if (!(data || !data)) console.log(data)
		} catch (error) {
			// erreur
		}
	},	
	
	_ga: function({state}, data) {
		try {
			if (!(data || !data)) console.log(data)
		} catch (error) {
			// erreur
		}
	},
	
	zoom_carte: function({state}) {
		this.map_osm.setZoom(this.zoom_default)
	},
	
	set_zoom: function({commit}, data) {
		commit('SET_ZOOM', data)
	},
	
	// eslint-disable-next-line
	app_filters: function({ commit, state, dispatch }, data) {
		let communes = []
		let codecommunes = []
		let programs = []
		let programs_filter = []
		let nMoyPM2=0
		let nTotalProgAbonne = 0

		let nb_filtre_app = 0
		if (!state.filters.veb_avec || !state.filters.veb_sans) nb_filtre_app += 1
		if (!state.filters.col || !state.filters.ind) nb_filtre_app += 1
		if (!state.filters.actif || !state.filters.termine || !state.filters.projet) nb_filtre_app += 1
		if (!(state.filters.psla && state.filters.lli && state.filters.brs && state.filters.anru && state.filters.autres && state.filters.aucun)) nb_filtre_app += 1
		if (!(state.filters.tvar && state.filters.tvap)) nb_filtre_app += 1
//		if (state.filters.annee_actif != (new Date()).getFullYear()-3) nb_filtre_app += 1
		commit('SET_NB_FILTRE', {nb: nb_filtre_app})
		for (let i in state.programs) {
			let bok = true
			
			let program = state.programs[i]
			
			// Gestion des filtres
			if (!program.pc && !program.veb) {
				if (state.efocus_type=='B') {
					if (program.Prix_Stock_TVAR_SPK==0) {
						bok = false
					}
					if (program.date_fin != '0') {
						bok = false
					} 
				
				} else {
					if ((state.filters.col && (program.forme_urbaine.toUpperCase() != 'INDIVIDUEL')) || (state.filters.ind && program.forme_urbaine.toUpperCase() == 'INDIVIDUEL')) {
						//
					} else {
						bok = false
					}
					
					if ((state.filters.actif && program.offre > 0) || (state.filters.termine && program.offre == 0)) {
						//
					} else {
						bok = false
					} 
					let prix = 0
					if (program.tva_pleine_libre_prix_m2_parking_avec) {
						prix = program.tva_pleine_libre_prix_m2_parking_avec
					} else {
						if (program.tva_pleine_libre_prix_m2_parking_sans) {
							prix = program.tva_pleine_libre_prix_m2_parking_sans
						} else {
							if (program.tva_pleine_aide_prix_m2_parking_avec) {
								prix = program.tva_pleine_aide_prix_m2_parking_avec
							} else {
								if (program.tva_pleine_aide_prix_m2_parking_sans) {
									prix = program.tva_pleine_aide_prix_m2_parking_sans
								} else {
									if (program.tva_reduite_prix_m2_parking_avec) {
										prix = program.tva_reduite_prix_m2_parking_avec
									} else {
										if (program.tva_reduite_prix_m2_parking_sans) {
											prix = program.tva_reduite_prix_m2_parking_sans
										}
									}
								}
							}
						}
					}
					
					if ((state.filters.prix.min <= prix) && (state.filters.prix.max >= prix)) {
						//
					} else {
						bok = false
					} 

					if (bok) {
						if (!(state.filters.psla && state.filters.brs && state.filters.anru && state.filters.autres && state.filters.aucun)) {
							let bfinancement = false							
							if ((program.lli && state.filters.lli) || (program.psla && state.filters.psla) || (program.brs && state.filters.brs) || (program.pnru && state.filters.anru) || (program.tva_pleine_aide_prix_m2_parking_sans && state.filters.autres)) bfinancement = true
							if (state.filters.aucun && !(program.tva_pleine_aide_prix_m2_parking_sans || program.tva_reduite_prix_m2_parking_sans)) bfinancement = true
							bok = bok && bfinancement
							if (!bfinancement) {
								console.log(program)
							}
						}
					}

					let btva = false
					if (program.Prix_Stock_TVAR_SPK || program.Prix_Stock_TVAR_APK) {
						if (state.filters.tvar) {
							btva = true
						}
					}
					if (program.Prix_Stock_TVAP_LIBRE_SPK || program.Prix_Stock_TVAP_AIDE_SPK) {
						if (state.filters.tvap) {
							btva = true
						}
					}

					if (state.filters.veb_avec && state.filters.veb_sans) {
						// rien
					} else {
						if (state.filters.veb_avec && (!program.liste_veb)) {
							bok = false
						}
					}


					bok = (bok && btva)
					nMoyPM2 += prix
					nTotalProgAbonne += 1
					let anneefin
					try {
						anneefin = parseInt(program.date_fin.substring(0, 4))
					} catch (error) {
						anneefin = 0
					}
					if (anneefin==0) {
						//
					} else {
						if (state.gestionhistorique) {
							if (anneefin < state.filters.annee_actif) {
								bok = false
							}
						} else {
							if (anneefin < 2020) {
								bok = false
							}
						}
					}
				}
			} else {
				if (program.pc) {
					if (state.efocus_type=='B') {
						bok = false
					}
					if (!state.filters.projet) {
						bok = false
					} else {
						let lastEtat = ''
						let dEtat = ''
						if (!program.avantpremiere) {
							switch (program.nature_depositaire) {
								case 'Promoteurs (SAI)':
								case 'Promoteurs reconnus comme tels':
								case 'SCI ou autres supports de programmes de construction':
								case 'Autres professionnels de la construction':
									if (!state.filters_pc.pc_promoteur)  bok = false
									break;
								case 'Organismes HLM':
								case 'Bailleurs sociaux SAI':
									if (!state.filters_pc.pc_bailleur)  bok = false
									break;
								case 'EPL (ex SEM)':
									if (!state.filters_pc.pc_epl)  bok = false
									break;
								case 'Administrations publiques (SAI)':
									if (!state.filters_pc.pc_administration)  bok = false
									break;
								case 'Autres organismes':
									if (!state.filters_pc.pc_autre)  bok = false
									break;
								case 'Non déterminé':							
									if (!state.filters_pc.pc_nc)  bok = false
									break;
								default:
									bok = false
									break;
							}
								if (program.evt.length==1) lastEtat = program.evt[0].libelle
							else if (program.evt.length>1) {
								lastEtat = program.evt[0].libelle
								dEtat = program.evt[0].dates
								for (let index = 1; index < program.evt.length; index++) {
									if (program.evt[index].dates > dEtat) {
										dEtat = program.evt[index].dates
										lastEtat = program.evt[index].libelle
									}
								}
							}
							if (!state.filters_pc.pc_autorise && lastEtat == 'permis autorisé') bok = false
							if (!state.filters_pc.pc_annule && lastEtat.libelle == 'permis annulé') bok = false
							if (!state.filters_pc.pc_commence && lastEtat.libelle == 'permis commencé') bok = false
							if (!state.filters_pc.pc_termine && lastEtat.libelle == 'permis terminé') bok = false
							if (state.filters_pc.filter_date) {
								if (state.filters_pc.filter_date_type == 'dep') {
									for (let index = 0; index < program.evt.length; index++) {
										if (program.evt[index].libelle == 'permis déposé') {
											if (program.evt[index].dates) {
												if (program.evt[index].dates < state.filters_pc.filter_date_date[0]) bok = false
												if (program.evt[index].dates > state.filters_pc.filter_date_date[1]) bok = false
											} else bok = false
										}
									}
								}
								if (state.filters_pc.filter_date_type == 'aut') {
									for (let index = 0; index < program.evt.length; index++) {
										if (program.evt[index].libelle == 'permis autorisé') {
											if (program.evt[index].dates) {
												if (program.evt[index].dates < state.filters_pc.filter_date_date[0]) bok = false
												if (program.evt[index].dates > state.filters_pc.filter_date_date[1]) bok = false
											} else bok = false
										}
									}
								}
								if (state.filters_pc.filter_date_type == 'acq') {
									if (program.pdc_date_acquisition_foncier) {
										if (program.pdc_date_acquisition_foncier < state.filters_pc.filter_date_date[0]) bok = false
										if (program.pdc_date_acquisition_foncier > state.filters_pc.filter_date_date[1]) bok = false
									} else bok = false
								}
							}
						}
					}
				} else {
					if (program.veb) {
						if (state.filters.veb_avec && state.filters.veb_sans) {
							// rien
						} else {
							if (state.filters.veb_sans) {
								bok = false
							}
						}
						if ((state.filters.col && (program.forme_urbaine.toUpperCase() != 'INDIVIDUEL')) || (state.filters.ind && program.forme_urbaine.toUpperCase() == 'INDIVIDUEL') || (program.forme_urbaine == null) || (program.tpl_id == 3)) {
							//
						} else {
							bok = false
						}
						if (!((program.date_acte && (parseInt(program.date_acte.substring(0, 4)) >= state.filters.annee_actif)) || (program.date_resa && (parseInt(program.date_resa.substring(0, 4)) >= state.filters.annee_actif)))) {
							bok = false
						}
						if (program.tranches_liees && program.tranches_liees.length) {
							for (let index = 0; index < program.tranches_liees.length; index++) {
								if (!program.tranches_liees[index].veb) bok = false
							}
						}
					}
				}
				
			}
			
			if (_.indexOf(state.selected_programs, program.id) > -1) program.selected = true
			programs.push(program)
			if (bok) {
				programs_filter.push(program)
			} else {
				//
			}
			if (_.indexOf(communes, program.ville) < 0) {
				communes.push(program.ville)
			}
			if (_.indexOf(codecommunes, program.secteur) < 0) {
				codecommunes.push(program.secteur)
			}
		}
		nMoyPM2 = Math.round((nMoyPM2 / nTotalProgAbonne) / 100) * 100;
		
		commit('SET_ECHELLE', { echelleprix_1: nMoyPM2 - 500,  echelleprix_2: nMoyPM2 + 500})
		commit('SET_PROGRAMS', { programs: programs })
		commit('SET_PROGRAMS_FILTER', { programs: programs_filter })
		commit('EDIT_API_CALLS', { load_programs: { state: 'success', date: _.now() } })
	},
	
	set_communes: function ({ commit, state }, data) {
		commit('SET_COMMUNES', { communes: data.communes, codecommunes: data.codecommunes })
		let url = state.BaseUrlBackend + '/secteurs/getStatByIds'
		axios.post(url, data.codecommunes, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			if (response && response.data) {
				commit('SET_COMMUNES_STAT', {data: response.data})
			}
		})
	},
	
	set_rs_communes: function ({ commit }, data) {
		commit('SET_RS_COMMUNES', { rs_communes: data.rs_communes, rs_codecommunes: data.rs_codecommunes })
	},
	
	set_rpls_communes: function ({ commit }, data) {
		commit('SET_RPLS_COMMUNES', { rpls_communes: data.rpls_communes, rpls_codecommunes: data.rpls_codecommunes })
	},
	
	set_offre_communes: function ({ commit }, data) {
		commit('SET_OFFRE_COMMUNES', { offre_communes: data.offre_communes, offre_codecommunes: data.offre_codecommunes })
	},
	
	click_oir: function({ state }, data) {
		if (data && !data) console.log(data)
	},

	set_user: function({ commit }, data) {
		commit('SET_USER', data)
	},

	set_cityscan_realty: function({ commit }, data) {
		commit('SET_REALTY', data)
		if (data.callback) data.callback()
	},

	app_cityscan_realty: function({ commit, state, dispatch }, data) {
		if (state.cityscan.lat) {
			let EvRequest = {lat:state.cityscan.lat, lon:state.cityscan.lon, realty : state.cityscan.realty}
			let url = state.BaseUrlBackend + '/proxy/cityscan/api/evaluations'
			axios.post(url, EvRequest, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				if (response) {
					if (response.data) {
						if (response.data.content) {
							if (response.data.content.evaluation) {
								commit('SET_ACTIVATIONID', { id: response.data.content.evaluation.id })
								
								const url = `${state.BaseUrlBackend}/proxy/procityscan/api/legend/indicator?language=fr-FR&id=16210&evaluationId=${response.data.content.evaluation.id}&byMonth=true`;
								axios.get(url, { headers: state.HeaderEfocusBack})
								.then(responsescale => {
									const scalesData = responsescale.data.content.scales;
									if (scalesData && scalesData.length && scalesData[0].range && scalesData[0].range.max) {
										commit('SET_CITYSCAN_SCALES', { scalesData: scalesData })
									} else {
										axios.get(url, { headers: state.HeaderEfocusBack})
										.then(responsescale => {
											const scalesData = responsescale.data.content.scales;
											commit('SET_CITYSCAN_SCALES', { scalesData: scalesData })
										})
									}
								})
							}
						}
					}
				}
				if (data.notload) {
	//
				} else dispatch('load_cityscan', {adresse: false, ancien: true, ancien_carte: false})
				if (data.callback) data.callback()
			})
		}
	},

	

	load_cityscan_mutations: function({ commit, state, dispatch }) {
		// Biens vendus comparables
		dispatch('set_loading_mutations', { loading: true })
		const currentDate = new Date();
		let annee_en_cours = currentDate.getFullYear();
		// eslint-disable-next-line
		let annee_en_cours_ = annee_en_cours - 4

		let fu = ''
		if (state.filtre_ancien.ind) {
			if (fu) fu = fu + ","
			fu = fu + "house"
		}
		if (state.filtre_ancien.col) {
			if (fu) fu = fu + ","
			fu = fu + "apartment"
		}
		
		let lt = ''
		if (state.filtre_ancien.t1) {
			if (lt) lt = lt + ","
			lt = lt + "1"
		}
		if (state.filtre_ancien.t2) {
			if (lt) lt = lt + ","
			lt = lt + "2"
		}
		if (state.filtre_ancien.t3) {
			if (lt) lt = lt + ","
			lt = lt + "3"
		}
		if (state.filtre_ancien.t4) {
			if (lt) lt = lt + ","
			lt = lt + "4"
		}
		if (state.filtre_ancien.t5) {
			if (lt) lt = lt + ","
			lt = lt + "5,6,7"
		}
/*
		let url2 = state.BaseUrlBackend + '/proxy/cityscan/api/widget/data/sold-properties?evaluationId=' + state.cityscan.activationId + '&clientKey=' + state.cityscan.clientKey + '&page=0&itemsPerPage=2000&filterType=distance&transactionTypes=sale&propertyTypes=' + fu + '&surfaceBuilding=' +  state.filtre_ancien.area_min + ',' + state.filtre_ancien.area_max + '&price=' + state.filtre_ancien.price_min + ',' + state.filtre_ancien.price_max + '&numberOfRooms=' + lt + '&years=' + annee_en_cours_ + ',' + annee_en_cours + '&orderBy=date%20DESC&similarity=false&onlyUserData=false&postalCodes=&distance=' + state.filtre_ancien.distance + '&from=cs-pro'
		axios.get(url2, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			let indicators = response.data.content.items
			let nb = indicators.length
			let nbtotal = response.data.content.pagination.totalItems
			commit('SET_BIENS_CITYSCAN', {nb: nb, nbtotal: nbtotal, biens_comparables: indicators})
			dispatch('set_loading_mutations', { loading: false })
		})
*/
		let url2 = state.BaseUrlBackend + '/dvf/searchByDistance'

		let c = {
			autorayon: false, 
			center_lat : state.adr_init.latlng.lat,
			center_lon : state.adr_init.latlng.lng,
			distance : state.filtre_ancien.distance,
			filter: state.filtre_ancien
		}

		axios.post(url2, c, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			let indicators = response.data.hits.hits
			let nb = indicators.length
			let nbtotal = response.data.hits.total.value
			commit('SET_BIENS_DVF', {nb: nb, nbtotal: nbtotal, biens_comparables: indicators})
			dispatch('set_loading_mutations', { loading: false })
		})
	
	},


	load_cityscan: function({ commit, state, dispatch }, data) {
		dispatch('set_loading_cityscan', { loading: true })
		if (data.ancien) {
			// Evaluation valeur de marché ancien
			let urlScale = false
			if (state.cityscan.activationId) {
				urlScale = `${state.BaseUrlBackend}/proxy/procityscan/api/legend/indicator?language=fr-FR&id=16210&evaluationId=${state.cityscan.activationId}&byMonth=true`;
			} else {
				if (state.cityscan.activationId) {
					urlScale = `${state.BaseUrlBackend}/proxy/procityscan/api/legend/indicator?language=fr-FR&id=16210&addressId=${state.cityscan.addressId}&byMonth=true`;
				}
			}

//			if (state.cityscan.activationId) {
			if (urlScale) {
				//const urlScale = `${state.BaseUrlBackend}/proxy/procityscan/api/legend/indicator?language=fr-FR&id=16210&addressId=${state.cityscan.addressId}&byMonth=true`;
				axios.get(urlScale, { headers: state.HeaderEfocusBack})
				.then(responsescale => {
					const scalesData = responsescale.data.content.scales;
					if (scalesData && scalesData.length && scalesData[0].range && scalesData[0].range.max) {
						commit('SET_CITYSCAN_SCALES', { scalesData: scalesData })
					} else {
						axios.get(url, { headers: state.HeaderEfocusBack})
						.then(responsescale => {
							const scalesData = responsescale.data.content.scales;
							commit('SET_CITYSCAN_SCALES', { scalesData: scalesData })
						})
					}
				})



				let url = state.BaseUrlBackend + '/proxy/cityscan/api/estimations?indicatorId=' + '1650' + '&evaluationId=' + state.cityscan.activationId
				axios.get(url, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					commit('SET_EVAL_CITYSCAN', response.data)
				})

				dispatch('load_cityscan_mutations')
			}
			// Carte
			if (data.ancien_carte) {
				if (state.cityscan.addressId) {
					let url3 = state.BaseUrlBackend + '/proxy/cityscan/api/indicators?addressId=' + state.cityscan.addressId + '&ids=' + '16211'
					axios.get(url3, { headers: state.HeaderEfocusBack})
					.then(function(response) {
						if (response.data.content.indicators && response.data.content.indicators.length) {
							commit('SET_EVAL_PRIX_CITYSCAN', response.data)
						} else {
							axios.get(url3, { headers: state.HeaderEfocusBack})
							.then(function(response2) {
								commit('SET_EVAL_PRIX_CITYSCAN', response2.data)
							})
						}
					})
				}
			}
		}

		if (data.adresse) {
			// Evaluation de la qualité de l'adresse
			let UneUrl = state.BaseUrlBackend + '/proxy/cityscan/evaluationAdresse/' + state.cityscan.activationId
			axios.get(UneUrl, {headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_RESULT_EVALUATION_ADRESSE', response.data)
			})
			
			let t1 = ["12","14","21","10","22","15","23"]
			for (let d=0; d< t1.length;d++) {
				dispatch('set_loading_cityscan', { loading: true, item:"_"+t1[d] })
				let UneUrlC = state.BaseUrlBackend + '/proxy/procityscan/api/widget/data?evaluationId=' + state.cityscan.activationId + '&clientKey=' + state.cityscan.clientKey + '&thematicId=' + t1[d] + '&strongPoints=0&language=fr-FR'
				axios.get(UneUrlC, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					TraiteReponseWidget(response)
					dispatch('set_loading_cityscan', { loading: false, item:"_"+t1[d] })
				})
			}
		}
		
		function TraiteReponseWidget(response) {
			
			function TraiteItem(indicator) {
				let name =''
				let temps = false
				let transport = false
				let nb = 0
				let duration = 0
				let transportType = ''
				switch(indicator.id)
				{
					case 2000: name = 'velo'; break;
					case 2001: name = 'auto'; break;
					case 2002: name = 'borne'; break;
					case 1210: name = 'route_rapide'; break;
					case 1220: name = 'gare'; break;
					case 1221: name = 'aeroport'; break;
					case 1222: name = 'port'; break;
					case 1230: name = 'parking'; break;
					case 1231: name = 'services_vehicule'; break;
					case 1300: name = 'commissariat'; break;
					case 1301: name = 'gendarmerie'; break;
					case 1310: name = 'pompiers'; break;
					case 1311: name = 'urgences'; break;
					case 1320: name = 'medecin'; break;
					case 1321: name = 'pharmacie'; break;
					case 1322: name = 'laboratoires'; break;
					case 1323: name = 'specialistes'; break;
					case 1330: name = 'alimentation'; break;
					case 1331: name = 'shopping'; break;
					case 1332: name = 'commerces_bouche'; break;
					case 1333: name = 'commerces_utilitaires'; break;
					case 1334: name = 'soins_beaute'; break;
					case 1340: name = 'restaurant'; break;
					case 1341: name = 'bar'; break;
					case 1342: name = 'jardin'; break;
					case 1343: name = 'discotheque'; break;
					case 1344: name = 'plaisance'; break;
					case 1350: name = 'bibliotheques'; break;
					case 1351: name = 'theatre'; break;
					case 1352: name = 'musees'; break;
					case 1353: name = 'cinema'; break;
					case 1360: name = 'sport_collectif'; break;
					case 1361: name = 'sport_individuel'; break;
					case 1370: name = 'services_logement'; break;
					case 1372: name = 'personnes_agees'; break;
					case 1200: name = 'bus'; break;
					case 1201: name = 'metro'; break;
					case 1202: name = 'tramway'; break;
					case 12: name = 'transport'; break;
					case 14: name = 'education'; break;
					case 21: name = 'commerce'; break;
					case 10: name = 'vie'; break;
					case 22: name = 'loisirs'; break;
					case 15: name = 'numerique'; break;
					case 23: name = 'services'; break;
					case 1400: name = 'creche'; break;
					case 1410: name = 'maternelle'; break;
					case 1420: name = 'elementaire'; break;
					case 1430: name = 'college'; break;
					case 1440: name = 'lycee'; break;
					case 1441: name = 'lycee_pro'; break;
					case 1450: name = 'universite'; break;
					case 1460: name = 'superieures'; break;
					case 1470: name = 'formation_pro'; break;							
					case 1000: name = 'sonore'; break;
					case 1001: name = 'olfactive'; break;
					case 1010: name = 'saturation_population'; break;
					case 1011: name = 'saturation_vehicules'; break;
					case 1020: name = 'air'; break;
					case 1021: name = 'electromagnetique'; break;
					case 1022: name = 'radon'; break;							
					case 1500: name = 'haut_debit'; break;
					case 1510: name = 'mobile_4G'; break;
					case 1520: name = 'mobile_3G'; break;
					case 1530: name = 'fibre'; break;
					case 1371: name = 'hotel'; break;
					case 1373: name = 'hebergement'; break;
					case 1380: name = 'poste'; break;
					case 2010: name = 'recyclage'; break;
					case 2011: name = 'dechets'; break;
					default:
					break;
				}
				
				if (indicator.pois) {
					nb = indicator.pois.length
				}
				switch (indicator.isoId) {
					case 'car05':
					transport = 'voiture'
					temps = 'à moins de 5 min en voiture'
					duration = 5
					transportType = 'DRIVING'
					break;
					case 'car10':
					transport = 'voiture'
					temps = 'à moins de 10 min en voiture'
					duration = 10
					transportType = 'DRIVING'
					break;
					case 'car15':
					transport = 'voiture'
					temps = 'à moins de 15 min en voiture'
					duration = 15
					transportType = 'DRIVING'
					break;
					case 'car20':
					transport = 'voiture'
					temps = 'à moins de 20 min en voiture'
					duration = 20
					transportType = 'DRIVING'
					break;
					case 'foot05':
					transport = 'pied'
					temps = 'à moins de 5 min à pied'
					duration = 5
					transportType = 'WALKING'
					break;
					case 'foot10':
					transport = 'pied'
					temps = 'à moins de 10 min à pied'
					duration = 10
					transportType = 'WALKING'
					break;
					case 'foot15':
					transport = 'pied'
					temps = 'à moins de 15 min à pied'
					duration = 15
					transportType = 'WALKING'
					break;
					case 'foot20':
					transport = 'pied'
					temps = 'à moins de 20 min à pied'
					duration = 20
					transportType = 'WALKING'
					break;
					default :
					break;
				}
				
				if (name!='') {
					commit('SET_SCORING_CITYSCAN', 
					{name: name, score: indicator.score, note: indicator.grade, temps: temps, nb: nb, transport: transport, factors: indicator.pois, duration: duration, transportType: transportType}
					)
				}
			}
			
			for (let a=0; a<response.data.content.length; a++) {
				if (response.data.content[a]) {
					TraiteItem(response.data.content[a])
				}
				for (let b=0; b<response.data.content[a].subThematics.length; b++) {
					for (let c=0; c<response.data.content[a].subThematics[b].indicators.length; c++) {
						TraiteItem(response.data.content[a].subThematics[b].indicators[c])
					}
				}
			}
		}
		
	},

	get_fil_kpi: function({ commit, state }, data) {

		commit('SET_VALUE', {c: 'kpi_fil_volume_libelle', v: ''});
		commit('SET_VALUE', {c: 'kpi_fil_volume', v: false});
		commit('SET_VALUE', {c: 'kpi_fil_volume_loading', v: true});
		let url = state.BaseUrlBackend + '/filkpi/volume?typ=' + data.typ + '&id=' + data.id + '&annuel=' + data.annuel
		let HeaderEfocusSanctum = {
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '
		}
		HeaderEfocusSanctum['Authorization'] = 'Bearer ' + process.env.VUE_APP_SANCTUMTOKEN
		axios.get(url, { headers: HeaderEfocusSanctum})
		.then(function(response) {
			if (response && response.data) {
				commit('SET_VALUE', {c: 'kpi_fil_volume', v: response.data});
				commit('SET_VALUE', {c: 'kpi_fil_volume_libelle', v: data.label});
				commit('SET_VALUE', {c: 'kpi_fil_volume_loading', v: false});
			}
		})
	},

	load_programs: function({ commit, state, dispatch }, data) {
		if (!state.parcours_sans_neuf.includes(state.efocus_type)) {
			commit('REMOVE_ALL_PROGRAMS', {})
			commit('RAZ_SELECTED_SECTEUR', {})
			commit('RAZ_SELECTED_PROGRAMMES', {})
			
			let communes = []
			let codecommunes = []
			
			let programs_filter = []
			if (!state.loading) {
				commit('SET_ETAPE', { etape: 3 })
				dispatch('set_loading', { loading: true })
				let url = ''
				if (data.type_search == 'polygon') {
					url = state.BaseUrlBackend + '/programs/searchByPolygonDB'
				} else {
					url = state.BaseUrlBackend + '/programs/searchByBoundingBoxDB'
				}
				if (!data.danscettezone) {
					if (state.cityscan.addressId > 0) {
						let ResetRequest = {addressId:state.cityscan.addressId}
						let url2 = state.BaseUrlBackend + '/proxy/cityscan/api/address/deactivation'
						axios.post(url2, ResetRequest, { headers: state.HeaderEfocusBack})
						.then(function(response) {
							if (response) {
								// Nothing
							}
						})
					}
					
					if (state.cityscan.activationId > 0) {
						let url3 = state.BaseUrlBackend + '/proxy/cityscan/api/evaluations/deactivate/' + state.cityscan.activationId
						axios.post(url3, {}, { headers: state.HeaderEfocusBack})
						.then(function(response) {
							if (response) {
								//
							}
						})
					}

					if (state.module_actif || state.module_actif == null || state.efocus_type != 'A') {
						let AddRequest = {road:'', postalCode:'', city: ''}
						AddRequest.road = state.adr_query.data.name
						AddRequest.postalCode = state.adr_query.data.postcode
						AddRequest.city = state.adr_query.data.city
						let url4 = state.BaseUrlBackend + '/proxy/cityscan/api/address/activation'
						axios.post(url4, AddRequest, { headers: state.HeaderEfocusBack})
						.then(function(response) {
							if (response.data.error) {
								commit('SET_MODULE_ADRESSE', { actif: false })
								if (response.data.error==102) {
									dispatch('add_notification', { status: 'info_warning', message: "Nous n'avons pas assez d'éléments pour localiser l'adresse" })
									dispatch('add_notification', { status: 'info_warning', message: "Le module 'qualité d'adresse' et 'ancien' est désactivé." })
									dispatch('add_notification', { status: 'info_warning', message: "Le module 'marché de l'ancien' est désactivé." })
								} else {
									dispatch('add_notification', { status: 'error', message: response.data.message })
								}
							} else {
								commit('SET_MODULE_ADRESSE', { actif: true })
								commit('SET_ADDRESSID', { id: response.data.content.activation.address.id, lat: response.data.content.activation.lat, lon: response.data.content.activation.lon})
								let EvRequest = {lat:response.data.content.activation.lat, lon:response.data.content.activation.lon, city: AddRequest.city, postalCode: AddRequest.postalCode, road: AddRequest.road, realty : state.cityscan.realty}
								let url5 = state.BaseUrlBackend + '/proxy/cityscan/api/evaluations'
								axios.post(url5, EvRequest, { headers: state.HeaderEfocusBack})
								.then(function(response) {
									commit('SET_ACTIVATIONID', { id: response.data.content.evaluation.id })
									dispatch('load_cityscan', {adresse: true, ancien: true, ancien_carte: true})
								})
							}
							
						})
					}
				}
				
			
				axios.post(url, data.cc, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					let hits = response.data.hits.hits
					let programs = []
					let nMoyPM2 = 0
					let nTotalProgAbonne = 0
					let min = 0
					let max = 0
					let tab = []
					for (let i in hits) {
						let bok = true
						let program
						if (hits[i]._index != "flux_pc_efocus" && hits[i]._index != "flux_permis_efocus" && hits[i]._index != "flux_ppf_efocus_projet" && hits[i]._index != "flux_veb_efocus") {
							
							program = hits[i]._source
							program.pc = false
							program.veb = false
							if (program.brs == null) program.brs = false
							if (program.psla == null) program.psla = false
							program.lli = program.financements.includes('LLI Investisseur')
							if (state.efocus_type=='B') {
								if (program.Prix_Stock_TVAR_SPK==0) {
									bok = false
								}
								if (program.date_fin != '0') {
									bok = false
								} 
							
							} else {
								// Gestion des filtres
								if ((state.filters.col && (program.forme_urbaine.toUpperCase() != 'INDIVIDUEL')) || (state.filters.ind && program.forme_urbaine.toUpperCase() == 'INDIVIDUEL')) {
									//
								} else {
									bok = false
								}
								program.avant_premiere = false

								let fn;
								fn = function monthDiff(d1, d2) {
									let months;
									months = (d2.getFullYear() - d1.getFullYear()) * 12;
									months -= d1.getMonth();
									months += d2.getMonth();
									return months <= 0 ? 0 : months;
								}

								let d1 = new Date(program.date_debut_commercialisation)
								let d2 = new Date(program.date_maj_elk)
								let interval = fn(d1, d2)

								if (program.stock_initial < 6 && interval < 7 && program.offre > 0) {
									program.avant_premiere = true
								}

								if ((state.filters.actif && program.offre > 0) || (state.filters.termine && program.offre == 0)) {
										//
								} else {
									bok = false
								} 
								let prix = 0
								if (program.tva_pleine_libre_prix_m2_parking_avec) {
									prix = program.tva_pleine_libre_prix_m2_parking_avec
								} else {
									if (program.tva_pleine_libre_prix_m2_parking_sans) {
										prix = program.tva_pleine_libre_prix_m2_parking_sans
									} else {
										if (program.tva_pleine_aide_prix_m2_parking_avec) {
											prix = program.tva_pleine_aide_prix_m2_parking_avec
										} else {
											if (program.tva_pleine_aide_prix_m2_parking_sans) {
												prix = program.tva_pleine_aide_prix_m2_parking_sans
											} else {
												if (program.tva_reduite_prix_m2_parking_avec) {
													prix = program.tva_reduite_prix_m2_parking_avec
												} else {
													if (program.tva_reduite_prix_m2_parking_sans) {
														prix = program.tva_reduite_prix_m2_parking_sans
													}
												}
											}
										}
									}
								}
								if (min==0 || prix < min) min = prix
								if (max==0 || prix > max) max = prix
								tab.push(prix)
													
								if (prix) {
									nMoyPM2 += prix
									nTotalProgAbonne += 1
								}

								let prixFiltre = 0
								if (program.tva_reduite_prix_m2_parking_avec) {
									prixFiltre = program.tva_reduite_prix_m2_parking_avec
								} else {
									if (program.tva_reduite_prix_m2_parking_sans) {
										prixFiltre = program.tva_reduite_prix_m2_parking_sans
									} else {
										if (program.tva_pleine_aide_prix_m2_parking_avec) {
											prixFiltre = program.tva_pleine_aide_prix_m2_parking_avec
										} else {
											if (program.tva_pleine_aide_prix_m2_parking_sans) {
												prixFiltre = program.tva_pleine_aide_prix_m2_parking_sans
											} else {
												if (program.tva_pleine_libre_prix_m2_parking_avec) {
													prixFiltre = program.tva_pleine_libre_prix_m2_parking_avec
												} else {
													if (program.tva_pleine_libre_prix_m2_parking_sans) {
														prixFiltre = program.tva_pleine_libre_prix_m2_parking_sans
													}
												}
											}
										}
									}
								}


								if (((state.filters.prix.min <= prixFiltre) && (state.filters.prix.max >= prixFiltre)) || data.filtre_prix) {
									//
								} else {
									bok = false
								} 

								if (program.Prix_Stock_TVAR_SPK) {
									if (!state.filters.tvar) {
										bok = false
									}
								}

								if (!state.filters.tvap && state.filters.tvar) {
									if (program.Prix_Stock_TVAR_SPK==0) {
										bok = false
									}
								}

								if (bok) {
									if (!(state.filters.lli && state.filters.psla && state.filters.brs && state.filters.anru && state.filters.autres && state.filters.aucun)) {
										let bfinancement = false							
										if ((program.lli && state.filters.lli) || (program.psla && state.filters.psla) || (program.brs && state.filters.brs) || (program.pnru && state.filters.anru) || (program.tva_pleine_aide_prix_m2_parking_sans && state.filters.autres)) bfinancement = true
										if (state.filters.aucun && !(program.tva_pleine_aide_prix_m2_parking_sans || program.tva_reduite_prix_m2_parking_sans)) bfinancement = true
										bok = bok && bfinancement
										if (!bok) {
											//if (program.id == 'did_145553') console.log('F')
										}
									}
								}
										

								if (!state.filters.tvap && !state.filters.tvar) {
									bok = false
								}


								if (state.filters.veb_avec && state.filters.veb_sans) {
									// rien
								} else {
									if (state.filters.veb_avec && (!program.liste_veb)) {
										bok = false
									}
								}

								//if (!state.filters.veb_sans && !(program.liste_veb && program.liste_veb.length)) {
								//	bok = false
								//}

								if (program.stock_initial < 10 && !state.filters.nb_one){
									bok = false
								} else {
									if (program.stock_initial > 9 && program.stock_initial < 50 && !state.filters.nb_two){
										bok = false
									} else {
										if (program.stock_initial > 49 && program.stock_initial < 100 && !state.filters.nb_three){
											bok = false
										} else {
											if (program.stock_initial > 99 && !state.filters.nb_four){
												bok = false
											}
										}
									}
								}

							}
							program.filter = bok
							program.COMMERCIALISATION = 'termine'
							if (program.offre > 0) program.COMMERCIALISATION = 'actif'




							
							if (_.indexOf(state.selected_programs, program.id) > -1) program.selected = true
							programs.push(program)
							if (bok) {
								programs_filter.push(program)
							}
							if (_.indexOf(communes, program.ville) < 0) {
								communes.push(program.ville)
							}
							if (_.indexOf(codecommunes, program.secteur) < 0) {
								codecommunes.push(program.secteur)
							}
						} else {
							if (hits[i]._index == "flux_ppf_efocus_projet") {
								if (state.efocus_type=='A') {
									program = hits[i]._source
									program.veb = false
									program.pc = true
									program.avantpremiere = true
									program.no_prog = Number(program.id)
									// Gestion des filtres
									if ((state.filters.col && (program.forme_urbaine.toUpperCase() != 'INDIVIDUEL')) || (state.filters.ind && program.forme_urbaine.toUpperCase() == 'INDIVIDUEL') || (program.forme_urbaine == null)) {
										//
									} else {
										bok = false
									}
									
									if (!state.filters.projet) {
										bok = false
									} 
									
									nTotalProgAbonne += 1
									program.filter = bok
									program.COMMERCIALISATION = 'projet'
									
									if (_.indexOf(state.selected_programs, program.id) > -1) program.selected = true
									programs.push(program)
									if (bok) {
										programs_filter.push(program)
									}
									if (_.indexOf(communes, program.ville) < 0) {
										communes.push(program.ville)
									}
									if (_.indexOf(codecommunes, program.secteur) < 0) {
										codecommunes.push(program.secteur)
									}
								}							
							} else {
								if (hits[i]._index == "flux_veb_efocus") {
									if (state.efocus_type=='A') {

										program = hits[i]._source
										program.pc = false
										program.veb = true
										program.avantpremiere = false
										if (state.filters.veb_avec && state.filters.veb_sans) {
											// rien
										} else {
											if (state.filters.veb_sans) {
												bok = false
											}
										}

										if ((state.filters.col && (program.forme_urbaine.toUpperCase() != 'INDIVIDUEL')) || (state.filters.ind && program.forme_urbaine.toUpperCase() == 'INDIVIDUEL') || (program.forme_urbaine == null) || (program.tpl_id == 3)) {
											//
										} else {
											bok = false
										}

										if (!((program.date_acte && (parseInt(program.date_acte.substring(0, 4)) < state.filters.annee_actif)) || (program.date_resa && (parseInt(program.date_resa.substring(0, 4)) < state.filters.annee_actif)))) {
											bok = false
										}

										program.filter = bok
										program.COMMERCIALISATION = 'veb'
										if (_.indexOf(state.selected_programs, program.id) > -1) program.selected = true
										programs.push(program)
										if (bok) {
											programs_filter.push(program)
										}
										if (_.indexOf(communes, program.ville) < 0) {
											communes.push(program.ville)
										}
										if (_.indexOf(codecommunes, program.secteur) < 0) {
											codecommunes.push(program.secteur)
										}
									}
								} else {
									if (state.efocus_type=='A') {

										program = hits[i]._source
										program.pc = true
										program.veb = false
										program.avantpremiere = false
										program.no_prog = Number(program.id)

										// Gestion des filtres
										if ((state.filters.col && (program.forme_urbaine.toUpperCase() != 'INDIVIDUEL')) || (state.filters.ind && program.forme_urbaine.toUpperCase() == 'INDIVIDUEL') || (program.forme_urbaine == null) || (program.tpl_id == 3)) {
											//
										} else {
											bok = false
										}
										
										if (!state.filters.projet) {
											bok = false
										} 
										
										nTotalProgAbonne += 1
										program.filter = bok
										program.COMMERCIALISATION = 'projet'
										
										if (_.indexOf(state.selected_programs, program.id) > -1) program.selected = true
										programs.push(program)
										if (bok) {
											programs_filter.push(program)
										}
										if (_.indexOf(communes, program.ville) < 0) {
											communes.push(program.ville)
										}
										if (_.indexOf(codecommunes, program.secteur) < 0) {
											codecommunes.push(program.secteur)
										}
									}
								}
							}
						}
					}
					commit('SET_PROGRAMMES_PRIX', {min: min, max: max, tab: tab})
//					if (data.filtre_prix) {
//						let filter_de_promotion = JSON.parse(JSON.stringify(state.filters));
//						filter_de_promotion.prixmin = min
//						filter_de_promotion.prixmax = max
//						commit('SET_FILTER', filter_de_promotion)
//					}

		
					nMoyPM2 = Math.round((nMoyPM2 / nTotalProgAbonne) / 100) * 100;
					commit('SET_ECHELLE', { echelleprix_1: nMoyPM2 - 500,  echelleprix_2: nMoyPM2 + 500})
					programs = _.sortBy(programs, [ 'ville', 'no_prog', 'id' ])
					
					commit('SET_PROGRAMS', { programs: programs })
					commit('SET_PROGRAMS_FILTER', { programs: programs_filter })
					dispatch('set_communes', { communes: communes, codecommunes: codecommunes })
					commit('EDIT_API_CALLS', { load_programs: { state: 'success', date: _.now() } })

					if (nTotalProgAbonne>0) {
						//
					} else {
						//
					}
					
					dispatch('app_filters')
					dispatch('set_loading', { loading: false })
				})
				
			}
		}
		
	},
	
	load_rs: function({ commit, state, dispatch }, data) {
		commit('REMOVE_ALL_RSS', {})
		
		let rs_communes = []
		let rs_codecommunes = []
		
		let rss_filter = []
		commit('SET_ETAPE', { etape: 3 })
		dispatch('set_loading', { loading: true })
		let url = ''
		if (data.type_search == 'polygon') {
			url = state.BaseUrlBackend + '/rss/searchByPolygon'
		} else {
			url = state.BaseUrlBackend + '/rss/searchByBoundingBox'
		}
		axios.post(url, data.cc, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			let hits = response.data.hits.hits
			let rss = []
			let nTotalProgAbonne = 0
			let rs = false
			//let rss_filter = []
			// Obtenir la date actuelle
			const dateActuelle = new Date();

			// Obtenir l'année actuelle
			const anneeActuelle = dateActuelle.getFullYear();

			// Calculer l'année il y a 3 ans
			const anneeMoinsTrois = anneeActuelle - 3;
			for (let i in hits) {
				let bok = true
				if (hits[i]._index == "flux_rs_efocus") {
					
					rs = hits[i]._source
					nTotalProgAbonne += 1
					rs.nouvelle_residence = 0
					if (rs.ouverture) {
						if (rs.ouverture >= anneeMoinsTrois) rs.nouvelle_residence = 1
						else rs.nouvelle_residence = 2
					}

					if ((rs.cible=="SENIOR" & !(state.filtre_rs.senior))
					|| (rs.cible=="SOCIAL" & !(state.filtre_rs.social))
					|| (rs.cible=="SOCIAL ADOMA" & !(state.filtre_rs.social))
					|| (rs.cible=="ADOMA" & !(state.filtre_rs.social))
					|| (rs.cible=="SOCIAL" & !(state.filtre_rs.social))
					|| (rs.cible=="TOURISTE" & !(state.filtre_rs.touriste))
					|| (rs.cible=="TOUT AGE" & !(state.filtre_rs.tout))
					|| (rs.cible=="JEUNES" & !(state.filtre_rs.jeune))
					|| (rs.cible=="INTERGENERATIONNEL" & !(state.filtre_rs.inter))
					|| (rs.cible=="ETUDIANT" & !(state.filtre_rs.etudiant))
					)
					{
						bok = false
					} else {
						if ((rs.nature=="BEGUINAGE" & !(state.filtre_rs.nature.BEGUINAGE))
						|| (rs.nature=="RÉSIDENCE SERVICES SÉNIORS (RSS) LIBRE" & !(state.filtre_rs.nature.RSS))
						|| (rs.nature=="MAISONS DE REPOS ET DE SOINS" & !(state.filtre_rs.nature.REPOS_SOINS))
						|| (rs.nature=="RÉSIDENCE SERVICES ETUDIANTS (RSE) LIBRE" & !(state.filtre_rs.nature.RSE_LIBRE))
						|| (rs.nature=="EHPAD" & !(state.filtre_rs.nature.EHPAD))
						|| (rs.nature=="MAISON DE REPOS" & !(state.filtre_rs.nature.REPOS))
						|| (rs.nature=="VILLAGE SENIOR SOCIAL" & !(state.filtre_rs.nature.VILLAGE_SOCIAL))
						|| (rs.nature=="RÉSIDENCE SERVICES ETUDIANTS (RSE) MIXTE" & !(state.filtre_rs.nature.RSE_MIXTE))
						|| (rs.nature=="FOYER JEUNES TRAVAILLEURS (FJT)" & !(state.filtre_rs.nature.FJT))
						|| (rs.nature=="MARPA" & !(state.filtre_rs.nature.MARPA))
						|| (rs.nature=="VILLAGE SENIOR PRIVE" & !(state.filtre_rs.nature.VILLAGE_PRIVE))
						|| (rs.nature=="RÉSIDENCE SERVICES ETUDIANTS (RSE) SOCIALE" & !(state.filtre_rs.nature.RSE_SOCIAL))
						|| (rs.nature=="CHRS - Centre d'hébergement et de réinsertion sociale" & !(state.filtre_rs.nature.CHRS))
						|| (rs.nature=="RESIDENCE AUTONOMIE" & !(state.filtre_rs.nature.AUTONOMIE))
						|| ((rs.nature=="COPROPRIÉTÉ" || rs.nature=="RSS 1ère GENERATION") & !(state.filtre_rs.nature.COPROPRIETE))

						|| (rs.nature=="HÔTEL" & !(state.filtre_rs.nature.HOTEL))
						|| (rs.nature=="RÉSIDENCE DE TOURISME" & !(state.filtre_rs.nature.RESIDENCE_DE_TOURISME))
						|| (rs.nature=="HÔTEL ET RÉSIDENCE" & !(state.filtre_rs.nature.HOTEL_ET_RÉSIDENCE))
						|| (rs.nature=="COLIVING" & !(state.filtre_rs.nature.COLIVING))
						|| (rs.nature=="COLIVING - HABITAT PARTAGE" & !(state.filtre_rs.nature.COLIVING_HABITAT_PARTAGE))
						|| (rs.nature=="COLOCATION" & !(state.filtre_rs.nature.COLOCATION))
							)
						{
							bok = false
						} else {
								if ((rs.etoiles=="1 étoile" & !(state.filtre_rs.E1))
							|| (rs.etoiles=="2 étoiles" & !(state.filtre_rs.E2))
							|| (rs.etoiles=="3 étoiles" & !(state.filtre_rs.E3))
							|| (rs.etoiles=="4 étoiles" & !(state.filtre_rs.E4))
							|| (rs.etoiles=="5 étoiles" & !(state.filtre_rs.E5))
							|| ((rs.etoiles=="" || rs.etoiles==null) & !(state.filtre_rs.ENC))
							)
							{
								bok = false
							} else {
								try {
									if ((rs.meublee=="OUI" & !state.filtre_rs.MeubleOui)
									|| (rs.meublee=="NON" & !state.filtre_rs.MeubleNon)
									|| ((rs.meublee=="" || rs.meuble==null) & !state.filtre_rs.MeubleNC))
									{
										bok = false
									} else {
										if ((rs.services=="OUI" & !state.filtre_rs.ServiceOui)
										|| (rs.services=="NON" & !state.filtre_rs.ServiceNon)
										|| ((rs.services=="" || rs.services==null) & !state.filtre_rs.ServiceNC))
										{
											bok = false
										} else {
											bok = true
										}
									}
								} catch (error) {
									if (state.filtre_rs.MeubleNC) {
										bok = true
									} else {
										bok = false
									}
								}
							}
						}
					}

					if (_.indexOf(state.selected_rss, rs.id) > -1) rs.selected = true
					rss.push(rs)
					if (bok) {
						rss_filter.push(rs)
					}
					if (_.indexOf(rs_communes, rs.ville) < 0) {
						rs_communes.push(rs.ville)
					}
					if (_.indexOf(rs_codecommunes, rs.insee) < 0) {
						rs_codecommunes.push(rs.insee)
					}
				} else {
					rs = hits[i]._source
					rs.pc = true

					if (_.indexOf(state.selected_rss, rs.id) > -1) rs.selected = true
					rss.push(rs)
					if (bok) {
						rss_filter.push(rs)
					}
					if (_.indexOf(rs_communes, rs.ville) < 0) {
						rs_communes.push(rs.ville)
					}
					if (_.indexOf(rs_codecommunes, rs.insee) < 0) {
						rs_codecommunes.push(rs.insee)
					}
				}
			}

			rss = _.sortBy(rss, [ 'ville', 'gestionnaire' ])
			
			commit('SET_RSS', { rss: rss })
			commit('SET_RSS_FILTER', { rss: rss_filter })
			dispatch('set_rs_communes', { rs_communes: rs_communes, rs_codecommunes: rs_codecommunes })
			commit('EDIT_API_CALLS', { load_rss: { state: 'success', date: _.now() } })
			
			if (nTotalProgAbonne>0) {
				//
			} else {
				//
			}
			
			dispatch('app_filters')
			dispatch('set_loading', { loading: false })
		})
	},

	load_rpls: function({ commit, state, dispatch }, data) {
		
		let rpls_communes = []
		let rpls_codecommunes = []
		
		let rplss_filter = []
		commit('SET_ETAPE', { etape: 3 })
		let url = ''
		if (data.type_search == 'polygon') {
			url = state.BaseUrlBackend + '/rpls/searchByPolygon'
		} else {
			url = state.BaseUrlBackend + '/rpls/searchByBoundingBox'
		}
		url = state.BaseUrlBackend + '/rpls/searchByDistance'

		let c = {
			autorayon: data.autorayon, 
			center_lat : state.adr_init.latlng.lat,
			center_lon : state.adr_init.latlng.lng,
			distance : state.mapdistancerpls
		}

		if (state.load_rpls_url != c) {
			commit('SET_VALUE', {c: 'load_rpls_url', v: c});

			commit('REMOVE_ALL_RPLS', {})
			dispatch('set_loading', { loading: true })
			axios.post(url, c, { headers: state.HeaderEfocusBack})
			//axios.post(url, data.cc, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				let hits = response.data.hits.hits
				let rplss = []
				let nTotalProgAbonne = 0
				let rpls = false
				for (let i in hits) {
					let bok = true
					if (hits[i]._index == "flux_rpls_efocus" || hits[i]._index == "rpls_residence") {
						rpls = hits[i]._source
						rpls.distance = hits[i].fields.distance[0]
						nTotalProgAbonne += 1
						rpls.selected = false
						if (_.indexOf(state.selected_rplss, rpls.residence) > -1) rpls.selected = true
						rplss.push(rpls)
						if (bok) {
							rplss_filter.push(rpls)
							if (rpls.distance < state.filtre_rpls.distance) rpls.filter = true
							else rpls.filter = false
						}
						if (_.indexOf(rpls_communes, rpls.DEPCOM_LIBELLE) < 0) {
							rpls_communes.push(rpls.DEPCOM_LIBELLE)
						}
						if (_.indexOf(rpls_codecommunes, rpls.DEPCOM_CODE) < 0) {
							rpls_codecommunes.push(rpls.DEPCOM_CODE)
						}
					}
				}
	
				rplss = _.sortBy(rplss, [ 'DEPCOM_LIBELLE', 'LIBSEGPATRIM' ])
				
				commit('SET_RPLSS', { rplss: rplss })
				commit('SET_RPLSS_FILTER', { rplss: rplss_filter })
				dispatch('set_rpls_communes', { rpls_communes: rpls_communes, rpls_codecommunes: rpls_codecommunes })
				commit('EDIT_API_CALLS', { load_rplss: { state: 'success', date: _.now() } })
				
				if (nTotalProgAbonne>0) {
					//
				} else {
					//
				}
				if (data.autorayon) {
					commit('SET_MAPDISTANCERPLS', {mapdistancerpls: response.data.rayon})
				}
				dispatch('app_filters')
				dispatch('set_loading', { loading: false })
			})
		} else {
			//
		}
		
	},

	// eslint-disable-next-line
	load_ancien_rayon: function({ commit, state, dispatch }, data) {
		commit('SET_VALUE', { c: 'ancien_rayon_loading', v: data.c});
		let url_rayon = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=insee_code&insee=' + state.adr_init.insee + '&mode=rayon&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&rayon=' + state.ancien_rayon_distance

		axios.get(url_rayon, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_VALUE', { c: 'ancien_rayon', v: response.data});
			commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
		})

		let url_rayon_flat = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=insee_code&propertyType=flat&insee=' + state.adr_init.insee + '&mode=rayon&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&rayon=' + state.ancien_rayon_distance

		axios.get(url_rayon_flat, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_VALUE', { c: 'ancien_rayon_flat', v: response.data});
			commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
		})

		let url_rayon_house = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=insee_code&propertyType=house&insee=' + state.adr_init.insee + '&mode=rayon&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&rayon=' + state.ancien_rayon_distance

		axios.get(url_rayon_house, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_VALUE', { c: 'ancien_rayon_house', v: response.data});
			commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
		})
	},


	// eslint-disable-next-line
	load_locatif_rayon: function({ commit, state, dispatch }, data) {
		commit('SET_VALUE', { c: 'locatif_rayon_loading', v: data.c});
		let url_rayon = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=insee_code&insee=' + state.adr_init.insee + '&mode=rayon&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&rayon=' + state.locatif_rayon_distance

		axios.get(url_rayon, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_VALUE', { c: 'locatif_rayon', v: response.data});
			commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
		})

		let url_rayon_flat = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=insee_code&propertyType=flat&insee=' + state.adr_init.insee + '&mode=rayon&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&rayon=' + state.locatif_rayon_distance

		axios.get(url_rayon_flat, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_VALUE', { c: 'locatif_rayon_flat', v: response.data});
			commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
		})

		let url_rayon_house = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=insee_code&propertyType=house&insee=' + state.adr_init.insee + '&mode=rayon&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&rayon=' + state.locatif_rayon_distance

		axios.get(url_rayon_house, { headers: state.HeaderEfocusBack})
		.then(function(response) {
			commit('SET_VALUE', { c: 'locatif_rayon_house', v: response.data});
			commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
		})
	},

	// eslint-disable-next-line
	load_ancien: function({ commit, state, dispatch }, data) {
		if (state.module_ancien_adequation) {
			commit('SET_VALUE', { c: 'ancien_rayon_loading', v: 9});
			let url_iris = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=code_iris&insee=' + state.adr_init.iris_code

			axios.get(url_iris, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'ancien_iris', v: response.data});
				commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
			})

			let url_ville = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=insee_code&insee=' + state.adr_init.insee

			axios.get(url_ville, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'ancien_ville', v: response.data});
				commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
			})

			let url_iris_flat = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=code_iris&propertyType=flat&insee=' + state.adr_init.iris_code

			axios.get(url_iris_flat, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'ancien_iris_flat', v: response.data});
				commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
			})

			let url_ville_flat = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=insee_code&propertyType=flat&insee=' + state.adr_init.insee

			axios.get(url_ville_flat, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'ancien_ville_flat', v: response.data});
				commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
			})

			let url_iris_house = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=code_iris&propertyType=house&insee=' + state.adr_init.iris_code

			axios.get(url_iris_house, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'ancien_iris_house', v: response.data});
				commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
			})

			let url_ville_house = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-buy&type=insee_code&propertyType=house&insee=' + state.adr_init.insee

			axios.get(url_ville_house, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'ancien_ville_house', v: response.data});
				commit('SET_VALUE', { c: 'ancien_rayon_loading', v: (state.ancien_rayon_loading-1)});
			})

			dispatch('load_ancien_rayon', { c: state.ancien_rayon_loading })
		}
	},


	// eslint-disable-next-line
	load_locatif: function({ commit, state, dispatch }, data) {
		if (state.module_ancien_adequation) {
			commit('SET_VALUE', { c: 'locatif_rayon_loading', v: 9});
			let url_iris = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=code_iris&insee=' + state.adr_init.iris_code

			axios.get(url_iris, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'locatif_iris', v: response.data});
				commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
			})

			let url_ville = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=insee_code&insee=' + state.adr_init.insee

			axios.get(url_ville, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'locatif_ville', v: response.data});
				commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
			})

			let url_iris_flat = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=code_iris&propertyType=flat&insee=' + state.adr_init.iris_code

			axios.get(url_iris_flat, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'locatif_iris_flat', v: response.data});
				commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
			})

			let url_ville_flat = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=insee_code&propertyType=flat&insee=' + state.adr_init.insee

			axios.get(url_ville_flat, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'locatif_ville_flat', v: response.data});
				commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
			})

			let url_iris_house = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=code_iris&propertyType=house&insee=' + state.adr_init.iris_code

			axios.get(url_iris_house, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'locatif_iris_house', v: response.data});
				commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
			})

			let url_ville_house = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=insee_code&propertyType=house&insee=' + state.adr_init.insee

			axios.get(url_ville_house, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_VALUE', { c: 'locatif_ville_house', v: response.data});
				commit('SET_VALUE', { c: 'locatif_rayon_loading', v: (state.locatif_rayon_loading-1)});
			})

			dispatch('load_locatif_rayon', { c: state.locatif_rayon_loading })
		}
	},

	load_offre_ancien_bi: function({ commit, state, dispatch }, data) {
		if (state.module_ancien_adequation) {

			let offre_communes = []
			let offre_codecommunes = []
			
			let offre_filter = []
			commit('SET_ETAPE', { etape: 3 })
	//		dispatch('set_loading', { loading: true })
			let url = ''
			if (data.type_search == 'polygon') {
				url = state.BaseUrlBackend + '/anciens/searchByPolygon'
			} else {
				url = state.BaseUrlBackend + '/anciens/searchByBoundingBox'
			}
			url = state.BaseUrlBackend + '/anciens/searchByDistance'
			let rayon = state.mapdistanceoffre;
			if (data.autorayon) { rayon = 0; }

			let nbrooms = '';
			if (state.filtre_ancien_offre.t1) { nbrooms += ',1'}
			if (state.filtre_ancien_offre.t2) { nbrooms += ',2'}
			if (state.filtre_ancien_offre.t3) { nbrooms += ',3'}
			if (state.filtre_ancien_offre.t4) { nbrooms += ',4'}
			if (state.filtre_ancien_offre.t5) { nbrooms += ',5'}

			let surfmin = state.filtre_ancien_offre.area_min;
			let surfmax = state.filtre_ancien_offre.area_max;

			let prixmin = state.filtre_ancien_offre.price_min;
			let prixmax = state.filtre_ancien_offre.price_max;

			let dpe = '';
			if (state.filtre_ancien_offre.A) { dpe += ',A'}
			if (state.filtre_ancien_offre.B) { dpe += ',B'}
			if (state.filtre_ancien_offre.C) { dpe += ',C'}
			if (state.filtre_ancien_offre.D) { dpe += ',D'}
			if (state.filtre_ancien_offre.E) { dpe += ',E'}
			if (state.filtre_ancien_offre.F) { dpe += ',F'}
			if (state.filtre_ancien_offre.G) { dpe += ',G'}
			if (state.filtre_ancien_offre.NC) { dpe += ',NC'}
			if (dpe==',A,B,C,D,E,F,G,NC') { dpe = '' }
			let propertyType = 'total'
			if (state.filtre_ancien_offre.appartement && state.filtre_ancien_offre.maison) { propertyType = 'total'}
			else {
				if (state.filtre_ancien_offre.appartement) { propertyType = 'flat'}
				else {
					if (state.filtre_ancien_offre.maison) { 
						propertyType = 'house'
					}
				}
			}
			
			url = state.BaseUrlBackend + '/biens/list?theme=bi-real-estate-buy&mode=rayon&rayon=' + rayon + '&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&nbrooms=' + nbrooms + '&surfmin=' + surfmin + '&surfmax=' + surfmax + '&prixmin=' + prixmin + '&prixmax=' + prixmax + '&dpe=' + dpe + '&propertyType=' + propertyType
			if (state.load_offre_ancien_bi_url != url) {
				commit('SET_VALUE', {c: 'load_offre_ancien_bi_url', v: url});

				dispatch('set_loading_offre', { loading: true })
				commit('REMOVE_ALL_OFFRE', {})
				axios.get(url, { headers: state.HeaderEfocusBack})
				//axios.post(url, data.cc, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					let hits = response.data.hits.hits
					let offres = []
					let nTotalProgAbonne = 0
					let offre = false
					for (let i in hits) {
						let bok = true
		//				if (hits[i]._index == "real-estate-buy") {
						if (hits[i]._index == "bi-real-estate-buy") {
								if (!hits[i]._source.newProperty) {
								offre = hits[i]._source
		//						offre.distance = hits[i].fields.distance[0]
								nTotalProgAbonne += 1
								offre.selected = false
								offres.push(offre)
								if (bok) {
									offre_filter.push(offre)
								}
								if (_.indexOf(offre_communes, offre.city) < 0) {
									offre_communes.push(offre.city)
								}
								if (_.indexOf(offre_codecommunes, offre.city) < 0) {
									offre_codecommunes.push(offre.city)
								}
							}
						}
					}
		
					if (data.autorayon) {
						commit('SET_MAPDISTANCEOFFRE', {mapdistanceoffre: response.data.rayon})
					}
		
					offres = _.sortBy(offres, [ 'city' ])
					commit('SET_OFFRE', { offre: offres })
					commit('SET_OFFRE_FILTER', { offre: offre_filter })
					dispatch('set_offre_communes', { offre_communes: offre_communes, offre_codecommunes: offre_codecommunes })
					commit('EDIT_API_CALLS', { load_offre_ancien_bi: { state: 'success', date: _.now() } })
					
					if (nTotalProgAbonne>0) {
						//
					} else {
						//
					}
					
					dispatch('set_loading_offre', { loading: false })
		//			dispatch('set_loading', { loading: false })
				})	
			} else {
				//console.log('url ancien ' + url)
			}
		}
	},

	load_offre_locatif_bi: function({ commit, state, dispatch }, data) {
		if (state.module_ancien_adequation) {
				
			
			let offre_filter = []
			commit('SET_ETAPE', { etape: 3 })
	//		dispatch('set_loading', { loading: true })
			let url = ''
			url = state.BaseUrlBackend + '/anciens/searchByDistance'
			let rayon = state.mapdistanceoffrelocatif;
			if (data.autorayon) { rayon = 0; }

			let meuble = ''
			if (state.filtre_offre_locatif.MeubleOui && state.filtre_offre_locatif.MeubleNon) { meuble = ''}
			else {
				if (state.filtre_offre_locatif.MeubleOuistate.filtre_offre_locatif.MeubleOui) {
					meuble = '1';
				} else {
					meuble = '0';
				}
			}

			let nbrooms = '';
			if (state.filtre_offre_locatif.t1) { nbrooms += ',1'}
			if (state.filtre_offre_locatif.t2) { nbrooms += ',2'}
			if (state.filtre_offre_locatif.t3) { nbrooms += ',3'}
			if (state.filtre_offre_locatif.t4) { nbrooms += ',4'}
			if (state.filtre_offre_locatif.t5) { nbrooms += ',5'}

			let surfmin = state.filtre_offre_locatif.area_min;
			let surfmax = state.filtre_offre_locatif.area_max;

			let prixmin = state.filtre_offre_locatif.price_min;
			let prixmax = state.filtre_offre_locatif.price_max;

			let dpe = '';
			if (state.filtre_offre_locatif.A) { dpe += ',A'}
			if (state.filtre_offre_locatif.B) { dpe += ',B'}
			if (state.filtre_offre_locatif.C) { dpe += ',C'}
			if (state.filtre_offre_locatif.D) { dpe += ',D'}
			if (state.filtre_offre_locatif.E) { dpe += ',E'}
			if (state.filtre_offre_locatif.F) { dpe += ',F'}
			if (state.filtre_offre_locatif.G) { dpe += ',G'}
			if (state.filtre_offre_locatif.NC) { dpe += ',NC'}
			if (dpe==',A,B,C,D,E,F,G,NC') { dpe = '' }
			let propertyType = 'total'
			if (state.filtre_offre_locatif.appartement && state.filtre_offre_locatif.maison) { propertyType = 'total'}
			else {
				if (state.filtre_offre_locatif.appartement) { propertyType = 'flat'}
				else {
					if (state.filtre_offre_locatif.maison) { 
						propertyType = 'house'
					}
				}
			}
			
			url = state.BaseUrlBackend + '/biens/list?theme=bi-real-estate-rent&mode=rayon&rayon=' + rayon + '&lat=' + state.adr_init.latlng.lat + '&lon=' + state.adr_init.latlng.lng + '&nbrooms=' + nbrooms + '&surfmin=' + surfmin + '&surfmax=' + surfmax + '&prixmin=' + prixmin + '&prixmax=' + prixmax + '&dpe=' + dpe + '&propertyType=' + propertyType + '&meuble=' + meuble
			if (state.load_offre_locatif_bi_url != url) {
				commit('SET_VALUE', {c: 'load_offre_locatif_bi_url', v: url});
				dispatch('set_loading_offre', { loading: true })
				commit('REMOVE_ALL_OFFRE', {})
		

		/*
				let c = {
					autorayon: data.autorayon, 
					center_lat : state.adr_init.latlng.lat,
					center_lon : state.adr_init.latlng.lng,
					distance : state.mapdistanceoffre
				}
		*/
		//		axios.post(url, c, { headers: state.HeaderEfocusBack})
				axios.get(url, { headers: state.HeaderEfocusBack})
				//axios.post(url, data.cc, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					let hits = response.data.hits.hits
					let offres = []
					let nTotalProgAbonne = 0
					let offre = false
					for (let i in hits) {
						let bok = true
		//				if (hits[i]._index == "real-estate-buy") {
						if (hits[i]._index == "bi-real-estate-rent") {
								if (!hits[i]._source.newProperty) {
								offre = hits[i]._source
		//						offre.distance = hits[i].fields.distance[0]
								nTotalProgAbonne += 1
								offre.selected = false
								offres.push(offre)
								if (bok) {
									offre_filter.push(offre)
								}
								/*
								if (_.indexOf(offre_communes, offre.city) < 0) {
									offre_communes.push(offre.city)
								}
								if (_.indexOf(offre_codecommunes, offre.city) < 0) {
									offre_codecommunes.push(offre.city)
								}
									*/
							}
						}
					}

					if (data.autorayon) {
						commit('SET_MAPDISTANCEOFFRELOCATIF', {mapdistanceoffre: response.data.rayon})
					}

					offres = _.sortBy(offres, [ 'city' ])
					commit('SET_OFFRE_LOCATIF', { offre: offres })
					commit('SET_OFFRE_LOCATIF_FILTER', { offre: offre_filter })
					//dispatch('set_offre_communes', { offre_communes: offre_communes, offre_codecommunes: offre_codecommunes })
					commit('EDIT_API_CALLS', { load_offre_locatif_bi: { state: 'success', date: _.now() } })
					
					if (nTotalProgAbonne>0) {
						//
					} else {
						//
					}
					
					dispatch('set_loading_offre', { loading: false })
		//			dispatch('set_loading', { loading: false })
				})
			} else {
				//console.log('url locatif ' + url)
			}
		}
	},
	
	set_filter_locatif: function({ commit }, data) {
		commit('SET_FILTER_LOCATIF', data)	
		commit('EDIT_API_CALLS', { load_locatif: { state: 'success', date: _.now() } })
	},

	set_filter_rs: function({ commit }, data) {
		commit('SET_FILTER_RS', data)	
		commit('EDIT_API_CALLS', { load_rss: { state: 'success', date: _.now() } })
	},

	set_filter_rpls: function({ commit }, data) {
		commit('SET_FILTER_RPLS', data)	
		commit('EDIT_API_CALLS', { load_rplss: { state: 'success', date: _.now() } })
	},

	set_filter_offre: function({ commit }, data) {
		commit('SET_FILTER_OFFRE', data)	
		commit('EDIT_API_CALLS', { load_offre_ancien_bi: { state: 'success', date: _.now() } })
	},

	set_filter_offre_locatif: function({ commit }, data) {
		commit('SET_FILTER_OFFRE_LOCATIF', data)	
		commit('EDIT_API_CALLS', { load_offre_locatif_bi: { state: 'success', date: _.now() } })
	},

	set_filter_ancien: function({ commit, dispatch }, data) {
		commit('SET_FILTER_ANCIEN', data)
		dispatch('load_cityscan_mutations')
	},

	// eslint-disable-next-line
	set_filter_ancien_offre: function({ commit, dispatch }, data) {
		commit('SET_FILTER_ANCIEN_OFFRE', data)
	},

	// eslint-disable-next-line
	set_filter_locatif_offre: function({ commit, dispatch }, data) {
		commit('SET_FILTER_LOCATIF_OFFRE', data)	
	},

	ajoute_communes: function({ commit }, data) {
		commit('AJOUTE_COMMUNES', data)	
	},
	
	raz_selection: function({ commit, state, dispatch }) {
		dispatch('set_nbprogselect', {nb : 0})
		dispatch('set_nbpcselect', {nb : 0})
		if (state.programs_filter) {
			for (let i in state.programs_filter) {
				let s = state.programs_filter[i].id + "-" + state.programs_filter[i].ville
				if (document.getElementById(s)) {
					document.getElementById(s).className = 'checkbox'
				}
			}
		}
		commit('SET_AVM_HEATMAP', {data: false, m : false, diff: false, cpt: false, price: false, rayon: false })
		commit('SET_ETAPE', {etape: 0})	
	},
	
	set_menu: function({ commit }) {		
		commit('SET_MENU')
	},

	set_menu_false: function({ commit }) {		
		commit('SET_MENU_FALSE')
	},

	reset_view: function({ commit }) {		
		if (state.view_old =='home') {
			commit('SET_VIEW', { view: 'home' })
		} else {
			if (state.module_actif) {
				commit('SET_VIEW', { view: '' })
			} else {
				commit('SET_VIEW', { view: 'neuf' })
			}
		}
	},
	
	set_uniquemen_selection: function({ commit }, data) {
		commit('SET_UNIQUEMENT_SELECTION',data)
	},

	set_locatifajour: function({ commit }, data) {
		commit('SET_LOCATIFAJOUR', { locatifajour: data.locatifajour })
	},

	async ChargerDonneesYanport({ commit, state, dispatch }) {
		let t=[]
		// eslint-disable-next-line
		let f="&zoneType=IRIS"
		let TabGeo_type = ['irisIds', 'cityIds'/*, 'agglomerationIds'*/]
		let indexZ = 1
		switch (state.fond_carte_loyer) {
			case 2:
				// eslint-disable-next-line
			f = "&zoneType=CITY"
			indexZ = 2
			break;
			//case 3:
				// eslint-disable-next-line
			//f = "&zoneType=AGGLOMERATION"
			//indexZ = 3
			//break;
			case 4:
				// eslint-disable-next-line
			f = "&zoneType=DEPARTMENT"
			break;
			default:
			break;
		}
		let d = new Date()
		let datemax = d.toISOString()
		let d2 = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
		let datemin = d2.toISOString()

		let TabGeo = ['&zoneType=IRIS', '&zoneType=CITY'/*, '&zoneType=AGGLOMERATION'*/]
		let TabGeo_lib = ['IRIS', 'Ville'/*, 'Agglomération'*/]
		for (let index = 0; index < TabGeo.length; index++) {
			//let UneUrlGeo = state.BaseUrlBackend + '/proxy/yanport/maps?size=1&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT' + TabGeo[index] + '&active=false&bbox=' + state.adr_init.latlng.lat + '%2C' + state.adr_init.latlng.lng + '%2C' + state.adr_init.latlng.lat +'%2C' + state.adr_init.latlng.lng + '&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + datemax.substring(0, 10) + 'T00%3A00%3A00.000Z' + '&zoomLevel=14.25&marketingTypes=RENT&deleteDateMin=' + datemin.substring(0, 10) + 'T00%3A00%3A00.000Z' + '&field=PRICE_M2_HC&source=AD'
			let UneUrlGeo = state.BaseUrlBackend + '/proxy/yanport/maps/properties?size=1&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT' + TabGeo[index] + '&active=false&bbox=' + state.adr_init.latlng.lat + '%2C' + state.adr_init.latlng.lng + '%2C' + state.adr_init.latlng.lat +'%2C' + state.adr_init.latlng.lng + '&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + datemax.substring(0, 10) + 'T00%3A00%3A00.000Z' + '&zoomLevel=14.25&marketingTypes=RENT&deleteDateMin=' + datemin.substring(0, 10) + 'T00%3A00%3A00.000Z' + '&field=PRICE_M2_HC&source=AD'
			dispatch('set_load_yanport', {v : 1});
			t.push(axios.get(UneUrlGeo, {headers: state.HeaderEfocusBack})
				.then(async response => {
					if (response && response.data) {																
						let z_id = response.data.features[0].properties.id;
						let z_name = response.data.features[0].properties.name;
						let UneUrlGeoU = state.BaseUrlBackend + '/proxy/yanport/properties/percentiles?size=1&existingFields=marketing.priceM2HC&propertyTypes=HOUSE&propertyTypes=APARTMENT&excludeLeBonCoinWith60DurationDays=true&from=0&deleteDateMax=' + datemax.substring(0, 10) + 'T00%3A00%3A00.000Z' + '&marketingTypes=RENT&deleteDateMin=' + datemin.substring(0, 10) + 'T00%3A00%3A00.000Z' + '&field=PRICE_M2_HC&source=AD&' + TabGeo_type[index] + '=' + z_id

						t.push(axios.get(UneUrlGeoU, {headers: state.HeaderEfocusBack})
						.then(async response => {
							if (response && response.data) {																
								await dispatch('load_histo_loyer_geo', { geo: TabGeo[index], geo_type: TabGeo_type[index], geo_lib: TabGeo_lib[index], loyer_id: z_id,
									loyer_name: z_name,
									loyer_zoneType: state.loyer_zoneType,
									loyer_count: response.data.count,
									loyer_value: response.data.values["50.0"]
								})

								if (indexZ==index+1) {
									await dispatch('load_histo_loyer', { loyer_id: z_id,
										loyer_name: z_name,
										loyer_zoneType: state.loyer_zoneType,
										loyer_count: response.data.count,
										loyer_value: response.data.values["50.0"]
									})
								}
							}
							await dispatch('set_load_yanport', {v : -1});
							return response;
						})
					)
					}
				})
			)
		}
		await Promise.all(t);
		commit('SET_LOCATIFAJOUR', { locatifajour: true })
	},

	/* eslint-disable */
	async ChargerDonneesLocatif({ commit, state, dispatch }) {
		let t=[]		
		const UneUrl = `https://app.myadequation.fr/map/?service=WFS&version=1.0.0&request=GetFeature&typeName=Web:iris&maxFeatures=1&&cql_filter=INTERSECTS(geom,POINT(${state.adr_init.latlng.lng} ${state.adr_init.latlng.lat}))&outputFormat=application/json`;

		let codeInsee = false
		let codeIris = false
		let NomInsee = ''
		let NomIris = ''



		axios.get(UneUrl)
		.then(async response => {
			if (response && response.data) {
				var b_locatif = JSON.parse(JSON.stringify({
					"insee_code": {
						"nom": "",
						"code": ""
					},
					"code_iris": {
						"nom": "",
						"code": ""
					},
				}));
				codeInsee = response.data.features[0].properties.insee_com
				codeIris = response.data.features[0].properties.code_iris
				NomInsee = response.data.features[0].properties.nom_com
				NomIris = response.data.features[0].properties.nom_iris
				b_locatif.insee_code.nom = NomInsee
				b_locatif.insee_code.code = codeInsee
				b_locatif.code_iris.nom = NomIris
				b_locatif.code_iris.code = codeIris
				let f="&zoneType=IRIS"
				let TabGeo_type = ['insee_code', 'code_iris']
				let indexZ = 1
				switch (state.fond_carte_loyer) {
					case 2:
							// eslint-disable-next-line
						f = "&zoneType=CITY"
						indexZ = 2
						break;
				}

				let TabGeo = [codeInsee, codeIris]
				var that = this		
				
				

				for (let index = 0; index < TabGeo.length; index++) {
					try {
						let UneUrlGeo = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=' + TabGeo_type[index] + '&insee=' + TabGeo[index]
						let response = await axios.get(UneUrlGeo, { headers: state.HeaderEfocusBack });
						if (response && response.data) {
							b_locatif[TabGeo_type[index]].kpi = response.data;
							// Autres traitements
						}
					} catch (error) {
						console.error('Erreur lors de la requête:', error);
					}
				}
				commit('SET_LOCATIF_BI', {bi_locatif : b_locatif})


/*
				for (let index = 0; index < TabGeo.length; index++) {
					let UneUrlGeo = state.BaseUrlBackend + '/biens/kpi?theme=bi-real-estate-rent&type=' + TabGeo_type[index] + '&insee=' + TabGeo[index]
	
					dispatch('set_load_yanport', {v : 1});
					t.push(axios.get(UneUrlGeo, {headers: state.HeaderEfocusBack})
						.then(async response => {
							if (response && response.data) {
								console.log(response.data)
								bi_locatif[TabGeo_type[index]].kpi = response.data
							}
						})
					)
				}
				*/
			}
		})





		
		//await Promise.all(t);
		//commit('SET_LOCATIFAJOUR', { locatifajour: true })
	},

	async set_view({ commit, dispatch }, data) {

		commit('SET_VIEW', { view: data.view })
		dispatch('expand_program', { program: false })
		if (data.view == 'home') {
			dispatch('set_map_mode', { mode: 'consultation' })
		}
		
		if (data.view == '') {
			dispatch('SendEventView', { action: data.view})
		} else {
			dispatch('SendEventView', { action: data.view})
		}
		let module = '';
		switch (data.view) {
			case 'report':
				module = 'livedata';
				document.title = "efocus - LiveData"
				break;
			case 'report_B':
				module = 'livedata_B';
				document.title = "efocus - LiveData - B"
				break;	
			case 'home':
				module = 'recherche';
				document.title = "efocus - Recherche"
				break;
			case 'neuf':
				module = 'module_neuf';
				document.title = "efocus - Module neuf"
				commit('SET_VIEW_LAYER_PROMO', { view: true })
				commit('SET_VIEW_LAYER_PC', { view: true })
				commit('SET_VIEW_LAYER_RS', { view: false })
				commit('SET_VIEW_LAYER_RPLS', { view: false })
				commit('SET_VIEW_LAYER_OFFRE', { view: false })
				break;
			case 'locatif':

				commit('SET_VIEW_LAYER_RPLS', { view: false })
				if (state.locatifajour == false) {
					await dispatch('ChargerDonneesYanport')
				}

				module = 'module_locatif';
				document.title = "efocus - Module locatif"
				break;
			case 'carto-locatif':
				commit('SET_VIEW_LAYER_RPLS', { view: false })
				if (state.locatifajour == false) {
					await dispatch('ChargerDonneesLocatif')
				}

				module = 'module_locatif';
				document.title = "efocus - Module locatif"
				break;
			case 'adresse':
				module = 'module_adresse';
				document.title = "efocus - Module adresse"
				break;
			case 'ancien':
			case 'ancien-adeq':
			case 'ancien-mutations':
				commit('SET_VIEW_LAYER_RPLS', { view: false })
				module = 'module_ancien';
				document.title = "efocus - Module ancien"
				break;
			case 'rss':
				module = 'module_rss';
				document.title = "efocus - Module résidences services"
				commit('SET_VIEW_LAYER_PROMO', { view: false })
				commit('SET_VIEW_LAYER_PC', { view: false })
				commit('SET_VIEW_LAYER_RS', { view: true })
				commit('SET_VIEW_LAYER_RPLS', { view: false })
				commit('SET_VIEW_LAYER_OFFRE', { view: false })
				break;
			case 'rpls':
				module = 'module_rpls';
				document.title = "efocus - Module rpls"
				commit('SET_VIEW_LAYER_PROMO', { view: false })
				commit('SET_VIEW_LAYER_PC', { view: false })
				commit('SET_VIEW_LAYER_RS', { view: false })
				commit('SET_VIEW_LAYER_RPLS', { view: true })
				commit('SET_VIEW_LAYER_OFFRE', { view: false })
				break;
			case 'ancien-offre':
				module = 'module_ancien';
				document.title = "efocus - Module ancien"
				commit('SET_VIEW_LAYER_PROMO', { view: false })
				commit('SET_VIEW_LAYER_PC', { view: false })
				commit('SET_VIEW_LAYER_RS', { view: false })
				commit('SET_VIEW_LAYER_RPLS', { view: false })
				commit('SET_VIEW_LAYER_OFFRE', { view: true })
				break;
			case '':
				module = 'module';
				document.title = "efocus - Liste des modules"
				break;
			case 'vie':
				module = 'adresse-qualite';
				document.title = "efocus - Module adresse - Qualité de vie"
				break;
			case 'transport':
				module = 'adresse-transports';
				document.title = "efocus - Module adresse - Transports"
				break;
			case 'education':
				module = 'adresse-education';
				document.title = "efocus - Module adresse - Education"
				break;
			case 'commerces':
				module = 'adresse-commerces';
				document.title = "efocus - Module adresse - Commerces"
				break;
			case 'loisirs':
				module = 'adresse-loisirs';
				document.title = "efocus - Module adresse - Loisirs"
				break;
			case 'services':
				module = 'adresse-services';
				document.title = "efocus - Module adresse - Services"
				break;
			case 'numerique':
				module = 'adresse-numerique';
				document.title = "efocus - Module adresse - Numérique"
				break;
			default:
				break;
		}

		gtag('event', module, {'event_category': 'module','event_label': module});
		dispatch('send_event_backend', {module: module, action: 'ouverture', option: ''});
	},
	
	set_view_layer: function({ commit, dispatch }, data) {		
		dispatch('send_event_backend', {module: data.view, action: 'ouverture', option: ''});
		commit('SET_VIEW_LAYER', { view: data.view })
	},
	
	set_view_layer_promo: function({ commit }, data) {		
		commit('SET_VIEW_LAYER_PROMO', { view: data.view })
	},

	set_view_layer_pc: function({ commit }, data) {		
		commit('SET_VIEW_LAYER_PC', { view: data.view })
	},

	set_view_layer_rs: function({ commit }, data) {		
		commit('SET_VIEW_LAYER_RS', { view: data.view })
	},

	set_view_layer_poi: function({ commit }, data) {		
		commit('SET_VIEW_LAYER_POI', { view: data.view })
	},

	set_view_prog: function({ commit, dispatch }, data) {		
		commit('SET_VIEW_PROG', { view: data.view })
		if (data.view == 'program' || data.view == 'rs') {
			//
		}
		if (data.view == '') {
			dispatch('_ga', {action: 'set', attribut: 'page', valeur: 'map'})
		} else {
			dispatch('_ga', {action: 'set', attribut: 'page', valeur: data.view})
		}
		dispatch('_ga', {action: 'send', attribut: 'pageview'});
	},
	
	clear_programs: function({ commit }) {
		commit('SET_PROGRAMS', { programs: [] })
	},
	
	set_authorization: function({ commit }, data) {
		commit('SET_AUTHORIZATION', { authorized: data.authorized })
	},
	
	set_nolive: function({ commit }, data) {
		commit('SET_NOLIVE', { nolive: data.nolive })
	},
	
	set_module_cityscan: function({ commit }, data) {
		commit('SET_MODULE_CITYSCAN', { module_cityscan: data.module_cityscan })
	},
	
	set_module_foncier: function({ commit }, data) {
		commit('SET_MODULE_FONCIER', { module_foncier: data.module_foncier })
	},
	
	set_module_rs: function({ commit }, data) {
		commit('SET_MODULE_RS', { module_rs: data.module_rs })
	},
	
	set_module_rpls: function({ commit }, data) {
		commit('SET_MODULE_RPLS', { module_rpls: data.module_rpls })
	},
	
	set_module_offre: function({ commit }, data) {
		commit('SET_MODULE_OFFRE', { module_offre: data.module_offre })
	},
	
	associate_programs_markers: function({ commit }, data) {
		commit('ASSOCIATE_PROGRAMS_MARKERS', data)
	},
	
	associate_rss_markers: function({ commit }, data) {
		commit('ASSOCIATE_RSS_MARKERS', data)
	},
	
	associate_parcelles_markers: function({ commit }, data) {
		commit('ASSOCIATE_PARCELLES_MARKERS', data)
	},
	
	associate_offre_markers: function({ commit }, data) {
		commit('ASSOCIATE_OFFRE_MARKERS', data)
	},
	
	associate_offre_locatif_markers: function({ commit }, data) {
		commit('ASSOCIATE_OFFRE_LOCATIF_MARKERS', data)
	},
	
	associate_locatif_markers: function({ commit }, data) {
		commit('ASSOCIATE_LOCATIF_MARKERS', data)
	},
	
	raz_secteur: function({ commit }, data) {
		commit('RAZ_SECTEURS', data)
	},
	
	raz_communes_selectionnees: function({ commit }) {
		commit('RAZ_COMMUNES_SELECTIONNEES')
	},
	
	select_program: function({ commit }, data) {
		let selected = !data.program.selected
		if (data.selected) selected = data.selected
		
		if (selected) {
			commit('ADD_TO_SELECTED_PROGRAMS', { program: data.program })
		} else {
			commit('REMOVE_TO_SELECTED_PROGRAMS', { program: data.program })
		}
		
	},
	set_secteur: function({ commit }, data) {
		commit('SET_SECTEURS', { secteurs: data.secteurs, secteurs_lib: data.secteurs_lib })
	},
	
	add_secteurs: function({ commit }, data) {
		commit('ADD_SECTEURS', { secteurs: data.secteurs, secteurs_lib: data.secteurs_lib })
	},
	
	del_secteurs: function({ commit }, data) {
		commit('DEL_SECTEURS', { secteurs: data.secteurs, secteurs_lib: data.secteurs_lib })
	},
	
	select_programs: function({ commit }, data) {
		if (data.selected) {
			commit('ADD_TO_SELECTED_PROGRAMS', { programs: data.programs })
		} else {
			commit('REMOVE_TO_SELECTED_PROGRAMS', { programs: data.programs })
		}
	},

	set_terrtoires_neuf: function({ commit }, data) {
		commit('SET_TERRITOIRES_NEUF', data)
	},

	print_program: function({ state }, data) {
		// Définition de la zone à imprimer
		let zone = document.getElementById(data.divname).innerHTML;
		// Ouverture du popup
		let fen = window.open("", "", "height=1050, width=700,toolbar=0, menubar=0, scrollbars=1, resizable=1,status=0, location=0, left=10, top=10")
		
		// style du popup
		fen.document.body.style.color = '#000000'
		fen.document.body.style.backgroundColor = '#FFFFFF'
		fen.document.body.style.padding = "0px"
		
		// Ajout des données a imprimer
		fen.document.title = data.titre
		
		
		axios.get('https://www.myadequation.fr/EFOCUS/print_program.txt?' + _.now(), {})
		.then(response => {
			fen.document.body.innerHTML = '<style>' + response.data + '</style>'
			zone = zone.replace('height: 285px', '')
			fen.document.body.innerHTML += " " + zone + " "
			// Impression du popup
			fen.window.print()
			
			//Fermeture du popup
			fen.window.close()
			return true
		}).catch(console.error)
	},	

	set_report_dispo: function({ commit }, data) {
		commit('URL_REPORT_DISPO', {dispo : data.dispo})
	},
	
	get_report_pdf2: function({ commit, state, dispatch }, data) {
		if (!state.loading) {
			dispatch('set_loading', { loading: true })
			let url = ''
			
			
			url = 'https://www.myadequation.fr/apiefocus/ReportV3/'+ state.livedata.livedata_id
			
			let request_body = data.html
			axios.post(url, request_body, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('URL_REPORT_INIT', {url : response.data.url})
				commit('URL_REPORT_DISPO', {dispo : true})
				dispatch('set_loading', { loading: false })
			})
		}
		
	}, 

	// eslint-disable-next-line
	get_report_pdf: function({ commit, state, dispatch }, data) {
		if (!state.loading) {
			gtag('event', 'livedata_pdf', {'event_category': 'filtre','event_label': 'livedata_pdf'});
			dispatch('send_event_backend', {module: 'livedata', action: 'pdf', option: ''});
			dispatch('set_loading', { loading: true })
			dispatch('set_loading_pdf', { loading_pdf: true })
			let url = ''
			if (data && !data) console.log(data)
			
			url = state.BaseUrlBackend + '/report/pdf?entree=' + data.entree + '&prix=' + data.prix + '&destination=' + data.destination + '&financement=' + data.tva + '&modules=' + data.modules
			if (data.modele) url = state.BaseUrlBackend + '/report/pdf_modele?entree=' + data.entree + '&prix=' + data.prix + '&destination=' + data.destination + '&financement=' + data.tva + '&modules=' + data.modules + '&modele=' + data.nommodele
			let request_body = {}
			request_body = JSON.parse(JSON.stringify(state.livedata));
			const a = JSON.parse(JSON.stringify(state.cityscan.adresse))
			for (const attribut in a) {
				if (Object.prototype.hasOwnProperty.call(a, attribut)) {
					if (attribut == 'biens_comparables') a.biens_comparables.splice(0);
					for (const attribut2 in a[attribut]) {
						if (attribut2=='factors') {
							if (Array.isArray(a[attribut]['factors'])) {
								a[attribut]['factors'].splice(0);
							}
						}
					}
				}
			}

			request_body.listepoi = state.listepoi
			request_body.adr_init = state.adr_init
			request_body.ancien = a;
			request_body.locatif = state.locatif;
			request_body.typo = null
			request_body.echelle = null
			request_body.ancien.reference = state.cityscan.realty;
			request_body.modules_adresse = state.modules_adresse;
			request_body.module_estimmo =  state.module_estimmo;
			
			
			axios.post(url, request_body, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				dispatch('set_loading', { loading: false })

				let url = response.data.data.url;
				const xhr = new XMLHttpRequest();
				xhr.open('GET', url, true);
				xhr.responseType = 'blob';

				xhr.onload = () => {
				const blob = xhr.response;
				const a = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				a.href = url;
				a.download = 'efocus_' + _.now() + '.pdf';
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
				};

				xhr.send();
				dispatch('set_loading_pdf', { loading_pdf: false })
			})
			
		}
		
	}, 

	
	// eslint-disable-next-line
	get_report_fil_pdf_dynamic: function({ commit, state, dispatch }, data) {
		if (!state.loading) {

			commit('SET_VALUE', {c: 'export_progress', v: 0});
			commit('SET_VALUE', {c: 'export_progress_visible', v: true});

			const euro = new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 0
            });

			gtag('event', 'livedata_pdf', {'event_category': 'filtre','event_label': 'livedata_pdf'});
			dispatch('send_event_backend', {module: 'livedata', action: 'pdf', option: ''});
			dispatch('set_loading', { loading: true })
			dispatch('set_loading_pdf', { loading_pdf: true })
			let url = ''
			if (data && !data) console.log(data)
				

			url = state.BaseUrlBackend + '/report/fil_pdf_modele'
			let request_body = {};
			request_body.kpi_fil_volume = JSON.parse(JSON.stringify(state.kpi_fil_volume));
			request_body.kpi_fil_libelle = state.kpi_fil_volume_libelle;
			request_body.annuel = data.annuel
			const exportApexChartToPng = (chartRef, requestBodyKey, requestBody) => {
				if (!chartRef) {
					console.error('Référence de graphique non trouvée:', chartRef);
					return Promise.reject(new Error(`Référence de graphique non trouvée : ${chartRef}`));
				}
			
				return chartRef.chart.dataURI().then(({ imgURI }) => {
					requestBody[requestBodyKey] = imgURI;
				}).catch((error) => {
					console.error('Erreur lors de l\'exportation de l\'ApexChart', error);
					return Promise.reject(error); // Assure-toi de rejeter l'erreur pour gérer correctement l'enchaînement des promesses
				});
			};

			const exportElementToPng = (elementId, requestBodyKey, requestBody) => {
				const elementToExport = document.getElementById(elementId);
				if (!elementToExport) {
					return Promise.reject(new Error(`Élément non trouvé : ${elementId}`)); // Retourne une promesse rejetée
				}
				try {
					let options = {
						height: elementToExport.scrollHeight,
						width: elementToExport.scrollWidth,
						style: {
							'transform': 'scale(1)',
							'transformOrigin': 'top left',
						},
						filter: (node) => {
							try {
							// Exclure les <link> venant de zohocdn.com
							if (node.tagName === 'LINK' && node.href && node.href.includes('zohocdn.com')) {
								return false;
							}

							// Exclure les <style> dont la feuille provient de zohocdn.com
							if (node.tagName === 'STYLE' && node.sheet && node.sheet.ownerNode) {
								const href = node.sheet.ownerNode.href;
								if (href && href.includes('zohocdn.com')) {
								return false;
								}
							}
							} catch (e) {
							// Ne rien exclure par défaut en cas d'erreur
							return true;
							}

							return true; // Garder tout le reste
						}
					};
				
					options.height = elementToExport.offsetHeight;
					options.width = elementToExport.offsetWidth;
					/*
					return toPng(elementToExport, options)
					.then((dataUrl) => {
						requestBody[requestBodyKey] = dataUrl;
					})
					.catch((error) => {
						console.error(`Erreur lors de la génération de l'image pour ${elementId}`, error);
					});
					*/
  				/**/
					return domtoimage.toPng(elementToExport, options)
						.then((dataUrl) => {
							requestBody[requestBodyKey] = dataUrl;
						})
						.catch((error) => {
							console.error(`Erreur lors de la génération de l'image pour ${elementId}`, error);
						});
				/**/
				} catch (error) {
					console.log(elementId)
					console.log(elementToExport)
					return Promise.reject(error);
				}
			};

			const exportAllImages = (request_body) => {
				const elementsToExport = [
					{ id: 'fil_chartVolumePromo_trim', key: 'promo_volume' },
					{ id: 'fil_chart_offre', key: 'promo_offre' },
					{ id: 'fil_chartOptions_prix_trim_pi', key: 'promo_prix_pi' },
					{ id: 'fil_chartOptions_rythme_trim', key: 'promo_rythme' },
					{ id: 'fil_chartOptions_rythme_annee', key: 'promo_rythme_annee' },
					{ id: 'fil_chart_aide', key: 'promo_dispositif' },
					{ id: 'fil_chartOptions_destination_trim', key: 'promo_destination' },
					{ id: 'fil_chartOptions_destination_annee', key: 'promo_destination_annee' },
					{ id: 'fil_chartPrixVente', key: 'RepartitionPrixVente' },
					{ id: 'fil_chartPrixOffre', key: 'RepartitionPrixOffre' },
					{ id: 'fil_chartPrixVente_annee', key: 'RepartitionPrixVente_annee' },
					{ id: 'fil_chartPrixOffre_annee', key: 'RepartitionPrixOffre_annee' },
				];

				const totalElements = elementsToExport.length;
				let completedElements = 0;
				const exportPromises = elementsToExport.map((element) => {
					if (element.isApexChart) {
						const chartRef = state[element.id];
						return exportApexChartToPng(chartRef, element.key, request_body)
						.then(() => {
							completedElements++;
							commit('SET_VALUE', {c: 'export_progress', v: (completedElements / totalElements) * 100});
						  });
				
					}
					else return exportElementToPng(element.id, element.key, request_body)
						.then(() => {
						completedElements++;
						commit('SET_VALUE', {c: 'export_progress', v: (completedElements / totalElements) * 100});
					  });
			
				});
			
				return Promise.all(exportPromises).then(() => {
					commit('SET_VALUE', {c: 'export_progress_visible', v: false});
				  })
			};



			exportAllImages(request_body)
			.then(() => {
				axios.post(url, request_body, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					dispatch('set_loading', { loading: false })
	
					let url = response.data.data.url;
					const xhr = new XMLHttpRequest();
					xhr.open('GET', url, true);
					xhr.responseType = 'blob';
	
					xhr.onload = () => {
					const blob = xhr.response;
					const a = document.createElement('a');
					const url = window.URL.createObjectURL(blob);
					a.href = url;
					a.download = 'fil_' + _.now() + '.pdf';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					};
	
					xhr.send();
					dispatch('set_loading_pdf', { loading_pdf: false })
				})											
			})
			.catch((error) => {
				console.error('Erreur lors de la capture des images', error);
				dispatch('set_loading', { loading: false });
			});
		}
		
	}, 


	// eslint-disable-next-line
	get_report_pdf_dynamic: function({ commit, state, dispatch }, data) {
		if (!state.loading) {

			commit('SET_VALUE', {c: 'export_progress', v: 0});
			commit('SET_VALUE', {c: 'export_progress_visible', v: true});

			const euro = new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 0
            });

			gtag('event', 'livedata_pdf', {'event_category': 'filtre','event_label': 'livedata_pdf'});
			dispatch('send_event_backend', {module: 'livedata', action: 'pdf', option: ''});
			dispatch('set_loading', { loading: true })
			dispatch('set_loading_pdf', { loading_pdf: true })
			let url = ''
			if (data) console.log(data)
				
			url = state.BaseUrlBackend + '/report/pdf?entree=' + data.entree + '&prix=' + data.prix + '&destination=' + data.destination + '&financement=' + data.tva + '&modules=' + data.modules
			if (data.modele) url = state.BaseUrlBackend + '/report/pdf_modele?entree=' + data.entree + '&prix=' + data.prix + '&destination=' + data.destination + '&financement=' + data.tva + '&modules=' + data.modules + '&modele=' + data.nommodele + '&titre=' + data.etude_titre
			let request_body = {};
			request_body = JSON.parse(JSON.stringify(state.livedata));
			const a = JSON.parse(JSON.stringify(state.cityscan.adresse))
			for (const attribut in a) {
				if (Object.prototype.hasOwnProperty.call(a, attribut)) {
					if (attribut == 'biens_comparables') a.biens_comparables.splice(0);
					for (const attribut2 in a[attribut]) {
						if (attribut2=='factors') {
							if (Array.isArray(a[attribut]['factors'])) {
								a[attribut]['factors'].splice(0);
							}
						}
					}
				}
			}
			
			/*
			try {
				request_body.etude_titre = data.etude_titre
			} catch (error) {
				request_body.etude_titre = ''
			}
			*/

			try {
				request_body.locatif_tension = Math.round((state.insee_offre_locative*100000) / state.insee[0].data[state.insee[0].data.length-1].household.total_household)/100				
			} catch (error) {
				request_body.locatif_tension = null
				console.log(error)
			}
			request_body.estimmo = state.estimmo
			request_body.offre_locative = state.insee_offre_locative
			request_body.module_estimmo =  state.module_estimmo;

			let revenu_median_2_personnes = 0
			try {
				revenu_median_2_personnes = state.insee[0].data[4].household.household_division.household_2p.decile.decile_5.income;
			} catch (error) {
				revenu_median_2_personnes = 0
				console.log('pas de revenu moyen de 2 personnes')
			}
			request_body.revenu_median_2_personnes = revenu_median_2_personnes
			if (revenu_median_2_personnes) {
				request_body.budget_moyen_locatif = (Math.round(state.insee[0].data[4].household.household_division.household_2p.decile.decile_5.income * 0.25/10)*10).toString() + ' €'
			} else request_body.budget_moyen_locatif = '-'

			try {
				let nPression = 0
				nPression = Math.round(state.insee_sne[0].data.social_demand.global.demand_pressure*10,1)/10
				if (nPression==0) nPression = null
				else nPression = euro.format(nPression)
				request_body.pression_demande_locative = nPression;
				request_body.pression_demande_locative_libelle = 'demandes pour 1 attribution'
				if (nPression == null) request_body.pression_demande_locative_libelle = 'donnée non disp.'
				request_body.pression_demande_nombre = state.insee_sne[0].data.social_demand.global.demand
				if (!request_body.pression_demande_nombre) {
					request_body.pression_demande_nombre = 'donnée non disp.'
					request_body.pression_demande_locative_libelle = 'donnée non disp.'
				}
				request_body.insee_pression_demande_logement_social = Math.round(state.insee_sne[0].data.social_demand.global.demand_pressure*10,1)/10;
			} catch (error) {
				request_body.pression_demande_locative = ''
				request_body.pression_demande_locative_libelle = 'donnée non disp.'
				request_body.pression_demande_nombre = 'donnée non disp.'
				console.log(error)
			}


			request_body.listepoi = JSON.parse(JSON.stringify(state.listepoi));
			request_body.adr_init = JSON.parse(JSON.stringify(state.adr_init));
			request_body.ancien = a;
			request_body.locatif = JSON.parse(JSON.stringify(state.locatif));
			request_body.typo = null
			request_body.echelle = null
			request_body.locatif.loyer_tranches_geo = null
			request_body.locatif.yanport_typo_ref = null
			request_body.locatif.yanport_typo_prix = null
			request_body.locatif.yanport_typo_graph_prix = null
			request_body.locatif.yanport_typo_graph_prix_geo = null
			request_body.locatif.yanport_typo_jour = null
			request_body.locatif.yanport_typo_graph_jour = null
			request_body.locatif.yanport_typo_graph_jour_geo = null

			request_body.ancien.reference = JSON.parse(JSON.stringify(state.cityscan.realty));
			if (state.mrk.lat && state.module_actif && state.ModuleAdresse && state.module_cityscan) {
				request_body.modules_adresse = JSON.parse(JSON.stringify(state.modules_adresse));
			}

			try {
				request_body.locatif_social_ensemble_parc_social = state.rpls_commune._source.parc_complet.ensemble_parc_social;
			} catch (error) {
				request_body.locatif_social_ensemble_parc_social = "-"
			}

			try {
				request_body.locatif_social_age_moyen_du_parc = Math.round(parseFloat(state.rpls_commune._source.evolution_parc_complet.age_moyen_du_parc));
			} catch (error) {
				request_body.locatif_social_age_moyen_du_parc = "-"
			}

			try {
				request_body.locatif_social_taux_vacance = Math.round(parseFloat(state.rpls_commune._source.vacances_mobilites.taux_vacance.totale.janvier_2022*100))/100;
			} catch (error) {
				request_body.locatif_social_taux_vacance = "-"
			}

			try {
				request_body.locatif_social_loyer_moyen = Math.round(parseFloat(state.rpls_commune._source.loyers.loyer_moyen_2022_parc_complet*100))/100;
			} catch (error) {
				request_body.locatif_social_loyer_moyen = "-"
			}

			try {
				request_body.locatif_social_loyer_moyen_pli = Math.round(parseFloat(state.rpls_commune._source.loyer_moyen_par_financement.pli*100))/100;
			} catch (error) {
				request_body.locatif_social_loyer_moyen_pli = "-"
			}
			
			request_body.locatif_loyer_median = state.locatif.loyer_yanport_geo.cityIds.value
//			request_body.locatif_tension = null
//			if (state.insee[0].data[state.insee.length-1].household.total_household > 0) {
//				request_body.locatif.tension = Math.round(state.locatif.loyer_yanport_geo['cityIds'].count*1000 / state.insee[0].data[state.insee.length-1].household.total_household, 2)
//			}			
			
			let chartDataOccupation = [
				{label: "Propriétaire", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].lodgment.occupation.owner_rate*100)},
				{label: "Locataire", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].lodgment.occupation.tenant_rate*100)},
				{label: "Social", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].lodgment.occupation.social_tenant_rate*100)},
				{label: "Gratuit", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].lodgment.occupation.free_tenant_rate*100)},
				];
			chartDataOccupation.sort(function(a, b) {
				return b.nb - a.nb;
			});

			let chartDataForme = [
				{label: "Collectif", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].lodgment.division.apartment_rate*100)},
				{label: "Individuel", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].lodgment.division.house_rate*100)},
			];
			chartDataForme.sort(function(a, b) {
				return b.nb - a.nb;
			});

			let max_pop = state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_75_more.number
				+ state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_60_74.number
				+ state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_50_59.number
				+ state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_40_49.number
				+ state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_30_39.number
				+ state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_0_30.number
	
			let chartDataMen = [
				{label: "29 ans et moins", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_0_30.number/max_pop*100)},
				{label: "de 30 à 39 ans", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_30_39.number/max_pop*100)},
				{label: "de 40 à 49 ans", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_40_49.number/max_pop*100)},
				{label: "de 50 à 59 ans", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_50_59.number/max_pop*100)},
				{label: "de 60 à 74 ans", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_60_74.number/max_pop*100)},
				{label: "75 ans et plus", nb: Math.round(state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_75_more.number/max_pop*100)},
			];
			chartDataMen.sort(function(a, b) {
				return b.nb - a.nb;
			});
	
			request_body.insee_population = state.insee[0].data[state.insee[0].data.length-1].population.population;
			request_body.insee_population_evolution = state.insee_kpi[0].data.population.evolution_rate;
			request_body.insee_menage = state.insee[0].data[state.insee[0].data.length-1].household.total_household;
			request_body.insee_menage_evolution = state.insee_kpi[0].data.household.evolution_rate;
			request_body.insee_menage_repartition = [
				{
					"label" : chartDataMen[0].label,
					"nb" : chartDataMen[0].nb
				},
				{
					"label" : chartDataMen[1].label,
					"nb" : chartDataMen[1].nb
				},
				{
					"label" : chartDataMen[2].label,
					"nb" : chartDataMen[2].nb
				},
				{
					"label" : chartDataMen[3].label,
					"nb" : chartDataMen[3].nb
				},
				{
					"label" : chartDataMen[4].label,
					"nb" : chartDataMen[4].nb
				},
				{
					"label" : chartDataMen[5].label,
					"nb" : chartDataMen[5].nb
				}
			];
			request_body.insee_migration_residentielle = state.insee_kpi[0].data.household.last_year_rotation.total;
			request_body.insee_construction = state.insee_sitadel[0].data.construction_total;
			request_body.insee_emplois = state.insee[0].data[state.insee[0].data.length-1].employment.total;
			request_body.insee_emplois_evolution = state.insee_kpi[0].data.employment.evolution_rate;
			request_body.insee_emplois_concentration = state.insee_kpi[0].data.employment.indice_concentration;
			request_body.insee_parc_logement = state.insee[0].data[state.insee[0].data.length-1].lodgment.division.total_lodgments;
			request_body.insee_parc_logement_forme = [
				{
					"label" : chartDataForme[0].label,
					"nb" : chartDataForme[0].nb
				},
				{
					"label" : chartDataForme[1].label,
					"nb" : chartDataForme[1].nb
				}
			];
			request_body.insee_parc_logement_occupation = [
				{
					"label" : chartDataOccupation[0].label,
					"nb" : chartDataOccupation[0].nb
				},
				{
					"label" : chartDataOccupation[1].label,
					"nb" : chartDataOccupation[1].nb
				},
				{
					"label" : chartDataOccupation[2].label,
					"nb" : chartDataOccupation[2].nb
				},
				{
					"label" : chartDataOccupation[3].label,
					"nb" : chartDataOccupation[3].nb
				}
			];
			request_body.insee_revenu_median = state.insee[0].data[state.insee[0].data.length-1].year;
			request_body.insee_revenu_median_inf_30 = state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_0_30.median_income;
			request_body.insee_revenu_median_inf_39 = state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_30_39.median_income;
			request_body.insee_revenu_median_inf_49 = state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_40_49.median_income;
			request_body.insee_revenu_median_inf_59 = state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_50_59.median_income;
			request_body.insee_revenu_median_inf_74 = state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_60_74.median_income;
			request_body.insee_revenu_median_sup_75 = state.insee[0].data[state.insee[0].data.length-1].household.age_division.age_75_more.median_income;

			request_body.rpls_commune = state.rpls_commune;
/*
			if (document.getElementById('comment_i'))
			{
				const element = document.getElementById('comment_i');
				try {
					const canvas = html2canvas(element, { useCORS: true });
					request_body['img_comment'] = canvas.toDataURL("image/png");
				} catch (error) {
					console.error("Erreur lors de la capture :", error);
				}
			}
*/

			const exportApexChartToPng = (chartRef, requestBodyKey, requestBody) => {
				if (!chartRef || !chartRef.chart) {
					console.error('Référence de graphique non trouvée:', chartRef);
					return Promise.reject(new Error(`Référence de graphique non trouvée : ${chartRef}`));
				}
				console.log(chartRef.chart)
				return chartRef.chart.dataURI().then(({ imgURI }) => {
					requestBody[requestBodyKey] = imgURI;
				}).catch((error) => {
					console.error('Erreur lors de l\'exportation de l\'ApexChart', error);
					return Promise.reject(error); // Assure-toi de rejeter l'erreur pour gérer correctement l'enchaînement des promesses
				});
			};

			const exportHighChartToPng = (chartRef, requestBodyKey, requestBody) => {
				return new Promise((resolve, reject) => {
					if (!chartRef || typeof chartRef.getSVGForExport !== 'function') {
					console.error('Référence Highcharts invalide ou manquante:', chartRef);
					return reject(new Error(`Référence de graphique Highcharts non valide : ${chartRef}`));
					}

					chartRef.getSVGForExport({}, {}, function (svg) {
					const svgBlob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
					const url = URL.createObjectURL(svgBlob);
					const img = new Image();

					img.onload = function () {
						const canvas = document.createElement('canvas');
						canvas.width = img.width;
						canvas.height = img.height;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(img, 0, 0);

						try {
						const dataUrl = canvas.toDataURL('image/png');
						requestBody[requestBodyKey] = dataUrl;
						URL.revokeObjectURL(url); // Nettoyage
						resolve();
						} catch (e) {
						URL.revokeObjectURL(url);
						console.error('Erreur lors de la conversion Highcharts → PNG', e);
						reject(e);
						}
					};

					img.onerror = function () {
						URL.revokeObjectURL(url);
						reject(new Error('Erreur lors du chargement de l’image SVG générée'));
					};

					img.src = url;
					});
				});
			};

			const exportElementToPng_ok = (elementId, requestBodyKey, requestBody, c) => {
				let elementToExport = false
				if (c) {
					console.log(elementId)
					elementToExport = document.getElementsByClassName(elementId)[0];
				} else {
					elementToExport = document.getElementById(elementId);
				}

				if (!elementToExport) {
					return Promise.reject(new Error(`Élément non trouvé : ${elementId}`)); // Retourne une promesse rejetée
				}


				try {
					let options = {
						height: elementToExport.scrollHeight,
						width: elementToExport.scrollWidth,
						style: {
							'transform': 'scale(1)',
							'transformOrigin': 'top left',
						},
						cacheBust: true,
						filter: (node) => {
							try {
							// Exclure les <link> venant de zohocdn.com
							if (node.tagName === 'LINK' && node.href && node.href.includes('zohocdn.com')) {
								return false;
							}

							// Exclure les <style> dont la feuille provient de zohocdn.com
							if (node.tagName === 'STYLE' && node.sheet && node.sheet.ownerNode) {
								const href = node.sheet.ownerNode.href;
								if (href && href.includes('zohocdn.com')) {
								return false;
								}
							}
							} catch (e) {
								console.log('ici')
							// Ne rien exclure par défaut en cas d'erreur
							return true;
							}

							return true; // Garder tout le reste
						}
					};
				

					// Sauvegarde de la police originale et remplacement temporaire
					const originalFontMap = new Map();
					elementToExport.querySelectorAll('*').forEach((el) => {
					originalFontMap.set(el, el.style.fontFamily);
					el.style.fontFamily = 'Arial, sans-serif';
					});

					// Appel sécurisé de domtoimage
					const startTime = Date.now();

					if (['map_poi', 'map_syno'].includes(elementId)) {

					commit('SET_VALUE', {c: 'showMap', v: false});
									
					// Cloner la carte
					const original = elementToExport
					const clone = original.cloneNode(true)

					// Préparer un conteneur hors DOM visible
					const sandbox = document.createElement('div')
					sandbox.style.position = 'absolute'
					sandbox.style.top = '-9999px'
					sandbox.style.left = '-9999px'
					sandbox.style.width = original.offsetWidth + 'px'
					sandbox.style.height = original.offsetHeight + 'px'
					sandbox.appendChild(clone)
					document.body.appendChild(sandbox)

					// Utiliser la copie pour exporter
					const bounds = clone.getBoundingClientRect()
					const canvas = document.createElement('canvas')
					canvas.width = bounds.width
					canvas.height = bounds.height
					const ctx = canvas.getContext('2d')

					const drawIntoCanvas = (nodeList) => {
						Array.from(nodeList).forEach(img => {
							const rect = img.getBoundingClientRect()
							const x = rect.left - bounds.left
							const y = rect.top - bounds.top
							const src = img.getAttribute('src')
							const isCrossOrigin = false // ou vraie logique CORS

							if (isCrossOrigin) {
								console.warn('🚫 Image externe ignorée (CORS):', src)
								return
							}

							try {
								ctx.drawImage(img, x, y, rect.width, rect.height)
							} catch (e) {
								console.warn('❌ Tuile non dessinée :', src, e)
							}
						})
					}

					// Dessiner les images depuis le clone
					drawIntoCanvas(clone.querySelectorAll('img'))
					drawIntoCanvas(clone.querySelectorAll('.leaflet-marker-icon'))

					// Créer l’image exportée
					const dataUrl = canvas.toDataURL('image/png')
					const img = new Image()
					img.src = dataUrl

					// Nettoyer le clone
					document.body.removeChild(sandbox)

					// Réactiver la carte réelle
					commit('SET_VALUE', { c: 'showMap', v: true })

					}


					if (['heatmap_ville', 'heatmap_iris', 'heatmap_loyer'].includes(elementId)) {
						const container = elementToExport;
						const canvas = container.querySelector('canvas');

						if (canvas) {
							console.log(`🎯 Canvas heatmap détecté pour "${elementId}"`);

							// Sauvegarde taille initiale
							const originalWidth = canvas.width;
							const originalHeight = canvas.height;

							// Réduction temporaire pour accélérer export
/*
							canvas.width = 500;
							canvas.height = 300;
							canvas.style.width = '500px';
							canvas.style.height = '300px';
*/
							canvas.width = 300;
							canvas.height = 180;
							canvas.style.width = '300px';
							canvas.style.height = '180px';

							try {
							const dataUrl = canvas.toDataURL('image/png');
							const img = new Image();
							img.src = dataUrl;
							img.style.width = '100%';
							img.style.height = 'auto';

							container.innerHTML = '';
							container.appendChild(img);
							console.log(`🖼️ Heatmap "${elementId}" exportée à taille réduite`);
							} catch (e) {
							console.warn(`❌ Échec export heatmap "${elementId}"`, e);

							// Restaurer taille en cas d’échec
							canvas.width = originalWidth;
							canvas.height = originalHeight;
							canvas.style.width = '';
							canvas.style.height = '';
							}
						}
					}
				

					return domtoimage.toPng(elementToExport, options)
					.then((dataUrl) => {
						const endTime = Date.now();
						const durationMs = endTime - startTime;
						console.log(`✅ Export de "${elementId}" fin en ${durationMs} ms`);
						// Restauration Zoho, fonts et styles
						originalFontMap.forEach((font, el) => {
						el.style.fontFamily = font;
						});
						requestBody[requestBodyKey] = dataUrl;
					})
					.catch((error) => {
						const endTime = Date.now();
						const durationMs = endTime - startTime;
						console.error(`❌ Échec export "${elementId}" erreur après ${durationMs} ms`, error);
						// Restauration en cas d’erreur aussi
						originalFontMap.forEach((font, el) => {
						el.style.fontFamily = font;
						});
						console.error(`Erreur lors de la génération de l'image pour ${elementId}`, error);
					});
					
					/**/
				} catch (error) {
					console.log(elementId)
					console.log(elementToExport)
					return Promise.reject(error); // Assure-toi de rejeter l'erreur
				}
			};


			const exportElementToPng = (elementId, requestBodyKey, requestBody, c) => {
				let elementToExport = c
					? document.getElementsByClassName(elementId)[0]
					: document.getElementById(elementId)

				if (!elementToExport) {
					return Promise.reject(new Error(`Élément non trouvé : ${elementId}`))
				}

				try {
					const originalFontMap = new Map()
					elementToExport.querySelectorAll('*').forEach((el) => {
						originalFontMap.set(el, el.style.fontFamily)
						el.style.fontFamily = 'Arial, sans-serif'
					})
					
					const options = {
						style: {
							transform: 'scale(1)',
							transformOrigin: 'top left'
						},
						cacheBust: true,
						filter: (node) => {
							try {
								if (node.tagName === 'LINK') {
									const href = node.href || ''
									if (
										href.includes('zohocdn.com') ||
										href.includes('fonts.googleapis.com')
									) {
										return false
									}
								}
								if (node.tagName === 'STYLE') {
									const ownerHref = node.sheet?.ownerNode?.href || ''
									if (
										ownerHref.includes('zohocdn.com') ||
										ownerHref.includes('fonts.googleapis.com')
									) {
										return false
									}
								}
							} catch (e) {
								return true
							}
							return true
						}
					}

					const startTime = Date.now()

					// --- Gestion Leaflet ---
					if (['map_poi', 'map_syno'].includes(elementId)) {
						commit('SET_VALUE', { c: 'showMap', v: false })

						const original = elementToExport
						const clone = original.cloneNode(true)

						const sandbox = document.createElement('div')
						sandbox.style.position = 'absolute'
						sandbox.style.top = '-9999px'
						sandbox.style.left = '-9999px'
						sandbox.style.width = original.offsetWidth + 'px'
						sandbox.style.height = original.offsetHeight + 'px'
						sandbox.appendChild(clone)
						document.body.appendChild(sandbox)

						const bounds = clone.getBoundingClientRect()
						const canvas = document.createElement('canvas')
						canvas.width = bounds.width
						canvas.height = bounds.height
						const ctx = canvas.getContext('2d')

						const drawIntoCanvas = (nodeList) => {
							Array.from(nodeList).forEach(img => {
								const rect = img.getBoundingClientRect()
								const x = rect.left - bounds.left
								const y = rect.top - bounds.top
								const src = img.getAttribute('src')
								if (src) {
									try {
										ctx.drawImage(img, x, y, rect.width, rect.height)
									} catch (e) {
										console.warn('❌ Tuile non dessinée :', src, e)
									}
								}
							})
						}

						drawIntoCanvas(clone.querySelectorAll('img'))
						drawIntoCanvas(clone.querySelectorAll('.leaflet-marker-icon'))

						const dataUrl = canvas.toDataURL('image/png')
						document.body.removeChild(sandbox)
						commit('SET_VALUE', { c: 'showMap', v: true })

						requestBody[requestBodyKey] = dataUrl
						return Promise.resolve(dataUrl)
					}

					// --- Gestion Heatmap (canvas direct) ---
					/*
					if (['heatmap_ville', 'heatmap_iris', 'heatmap_loyer'].includes(elementId)) {
						const container = elementToExport
						const canvas = container.querySelector('canvas')

						if (canvas) {
							console.log(`🎯 Canvas heatmap détecté pour "${elementId}"`)

							const originalWidth = canvas.width
							const originalHeight = canvas.height

							canvas.width = 300
							canvas.height = 180
							canvas.style.width = '300px'
							canvas.style.height = '180px'

							try {
								const dataUrl = canvas.toDataURL('image/png')
								const img = new Image()
								img.src = dataUrl
								img.style.width = '100%'
								img.style.height = 'auto'

								container.innerHTML = ''
								container.appendChild(img)
								console.log(`🖼️ Heatmap "${elementId}" exportée`)
								requestBody[requestBodyKey] = dataUrl
								return Promise.resolve(dataUrl)
							} catch (e) {
								canvas.width = originalWidth
								canvas.height = originalHeight
								canvas.style.width = ''
								canvas.style.height = ''
								return Promise.reject(e)
							}
						}
					}
					*/

					// --- Export avec html-to-image ---
					return toPng(elementToExport, options)
						.then((dataUrl) => {
							const durationMs = Date.now() - startTime
							console.log(`✅ Export "${elementId}" terminé en ${durationMs}ms`)

							// Restauration des polices
							originalFontMap.forEach((font, el) => {
								el.style.fontFamily = font
							})

							requestBody[requestBodyKey] = dataUrl
							return dataUrl
						})
						.catch((error) => {
							const durationMs = Date.now() - startTime
							console.error(`❌ Échec export "${elementId}" après ${durationMs}ms`, error)

							originalFontMap.forEach((font, el) => {
								el.style.fontFamily = font
							})

							return Promise.reject(error)
						})
				} catch (error) {
					console.error('Erreur générale', error)
					return Promise.reject(error)
				}
			}


			const exportElementDomToPng = (elementId, requestBodyKey, requestBody, c) => {
				let elementToExport = c
					? document.getElementsByClassName(elementId)[0]
					: document.getElementById(elementId)

				if (!elementToExport) {
					return Promise.reject(new Error(`Élément non trouvé : ${elementId}`))
				}

				try {
					
					const startTime = Date.now()

					return domtoimage.toPng(elementToExport)
					.then((dataUrl) => {
						requestBody[requestBodyKey] = dataUrl;
					})
					.catch((error) => {
						console.error(`Erreur lors de la génération de l'image pour l'élément avec ID ${id}`, error);
						reject(error);
					});
				} catch (error) {
					console.error('Erreur générale', error)
					return Promise.reject(error)
				}
			}
			/*
			let txt_comment = ''
			if (document.getElementsByClassName('p-editor-content') && document.getElementsByClassName('p-editor-content')[0]) {
				txt_comment = document.getElementsByClassName('p-editor-content')[0].innerText
			} 
			request_body.txt_comment = txt_comment;
			*/
			request_body.txt_comment = state.comment_html;

			const exportAllImages = (request_body) => {
				const elementsToExport = [
					{ id: 'map_poi', key: 'poi' },
					{ id: 'grp_repart_menage', key: 'grp_menage' },
					{ id: 'grp_repart_forme', key: 'grp_forme', isApexChart: true },
					{ id: 'grp_repart_dest', key: 'grp_dest'/*, isApexChart: true*/ },
					{ id: 'grp_revenu_menage', key: 'grp_revenu' },
					{ id: 'grp_revenu_menage_compo', key: 'grp_revenu_compo' },					
				];
				try {

					//if (document.getElementById('comment_i'))  elementsToExport.push({ id: 'comment_i', key: 'img_comment', domtopnf: true })
					if (document.getElementById('map_syno'))  elementsToExport.push({ id: 'map_syno', key: 'carto' })
					if (document.getElementById('chartVolumePromo'))  elementsToExport.push({ id: 'chartVolumePromo', key: 'promo_volume', isApexChart: true })
					if (document.getElementById('grde'))  elementsToExport.push({ id: 'grde', key: 'promo_destination', isApexChart: true })
					if (document.getElementById('graide'))  elementsToExport.push({ id: 'graide', key: 'promo_aide', isApexChart: true })
					if (document.getElementById('groff'))  elementsToExport.push({ id: 'groff', key: 'promo_offre', isApexChart: true })
					if (document.getElementById('chartRythmePromo'))  elementsToExport.push({ id: 'chartRythmePromo', key: 'promo_rythme', isApexChart: true  })
					if (document.getElementById('chartPrixPromo'))  elementsToExport.push({ id: 'chartPrixPromo', key: 'promo_prix_pi', isApexChart: true  })
				} catch (error) {
					console.log('pas de neuf')
				}

				try {
					if (document.getElementById('chartFina'))  elementsToExport.push({ id: 'chartFina', key: 'grp_social_repartition_financement' })
					if (document.getElementById('chartTypo'))  elementsToExport.push({ id: 'chartTypo', key: 'grp_social_repartition_typologie' })
					if (document.getElementById('chartDpe'))  elementsToExport.push({ id: 'chartDpe', key: 'grp_social_repartition_dpe' })
				} catch (error) {
					console.log('pas de rpls')
				}
				try {
					if (document.getElementById('chartSneFamilyTab'))  elementsToExport.push({ id: 'chartSneFamilyTab', key: 'grp_SneFamily' })
					if (document.getElementById('chartSnePersonneMenageTab'))  elementsToExport.push({ id: 'chartSnePersonneMenageTab', key: 'grp_SnePersonneMenage' })
					if (document.getElementById('chartSneAgeTab'))  elementsToExport.push({ id: 'chartSneAgeTab', key: 'grp_SneAge' })
					if (document.getElementById('chartSneTypoTab'))  elementsToExport.push({ id: 'chartSneTypoTab', key: 'grp_SneTypo' })
				} catch (error) {
					console.log('pas de sne')
				}

				if (state.module_actif && state.module_cityscan) {
					elementsToExport.push({ id: 'heatmap_cityIds', key: 'heatmap_ville', isApexChart: true })
					elementsToExport.push({ id: 'heatmap_irisIds', key: 'heatmap_iris', isApexChart: true })
					elementsToExport.push({ id: 'GraphPrix_irisIds', key: 'GraphPrix_irisIds', isApexChart: true })
					elementsToExport.push({ id: 'GraphPrix_cityIds', key: 'GraphPrix_cityIds', isApexChart: true })
				}
				elementsToExport.push({ id: 'heatmap_loyer', key: 'heatmap_loyer' })
				if (state.mrk.lat && state.module_actif && state.ModuleAdresse && state.module_cityscan) {
					elementsToExport.push({ id: 'chartPrixAncien', key: 'prix_ancien', isApexChart: true })
				}

				const totalElements = elementsToExport.length;
				let completedElements = 0;

				// Sauvegarde et retrait des liens Zoho
				const zohoLinks = Array.from(document.querySelectorAll('link[href*="zohocdn.com"]'));
				zohoLinks.forEach(link => link.remove());

				/*
				// Sauvegarde et retrait des feuilles de style contenant .woff/.ttf
				const fontStyleNodes = Array.from(document.querySelectorAll('link[rel="stylesheet"], style')).filter((el) => {
				try {
					if (el.tagName === 'LINK' && /\.(woff2?|ttf)(\?|$)/.test(el.href)) return true;
					if (el.tagName === 'STYLE' && el.textContent.match(/\.(woff2?|ttf)/)) return true;
				} catch (e) {}
				return false;
				});
				fontStyleNodes.forEach(node => node.remove());
				
				// Supprimer les liens Material Icons (Google Fonts)
				const materialLinks = Array.from(document.querySelectorAll('link[href*="fonts.googleapis.com"][href*="Material"]'));
				materialLinks.forEach(link => link.remove());

				// Supprimer les polices Material .woff2 si présentes dans les styles inline
				const googleWoffNodes = Array.from(document.querySelectorAll('style')).filter((el) => {
				return el.textContent.includes('fonts.gstatic.com/s/material');
				});
				googleWoffNodes.forEach(node => node.remove());
*/

				document.querySelectorAll('.leaflet-control-container').forEach(el => {
				el.style.visibility = 'hidden';
				});
/*
				const exportPromises = elementsToExport.map((element) => {
					if (element.isApexChart) {
						const chartRef = state[element.id];
						return exportApexChartToPng(chartRef, element.key, request_body)
						.then(() => {
							completedElements++;
							commit('SET_VALUE', {c: 'export_progress', v: (completedElements / totalElements) * 100});
						  });
				
					}
					else return exportElementToPng(element.id, element.key, request_body, element.class)
						.then(() => {
						completedElements++;
						console.log(`✅ Export réussi pour "${element.id}"`);
						commit('SET_VALUE', {c: 'export_progress', v: (completedElements / totalElements) * 100});
					  });
			
				});
			
				return Promise.all(exportPromises).then(() => {
					zohoLinks.forEach(link => document.head.appendChild(link));
					fontStyleNodes.forEach(node => document.head.appendChild(node));
					materialLinks.forEach(link => document.head.appendChild(link));
					googleWoffNodes.forEach(node => document.head.appendChild(node));
					document.querySelectorAll('.leaflet-control-container').forEach(el => {
					el.style.visibility = 'visible';
					});
					commit('SET_VALUE', {c: 'export_progress_visible', v: false});
				  })
*/



				const exportResults = [];

				const exportSequentially = async () => {
				
				if (elementsToExport.length) {
					commit('SET_VALUE', {c: 'export_progress', v: 0});
					commit('SET_VALUE', {c: 'export_progress_visible', v: true});
				}
				for (let i = 0; i < elementsToExport.length; i++) {
					const element = elementsToExport[i];
					const start = Date.now();

					try {
					if (element.domtopnf) {
						await exportElementDomToPng(element.id, element.key, request_body, element.class);
					} else {
						if (element.isApexChart) {
							const chartRef = state[element.id];
							await exportApexChartToPng(chartRef, element.key, request_body);
						} else {
							if (element.isHighChart) {
								const chartComponent = state[element.id];

								const chartRef =
								chartComponent?.__chart__ || // <- recommandé avec highcharts-vue
								chartComponent?.chart ||
								Highcharts.charts.find(c => c?.renderTo?.id === element.id);

								if (chartRef) {
									await exportHighChartToPng(chartRef, element.key, request_body);
								} else {
									console.warn(`❌ Aucun graphique Highcharts trouvé pour "${element.id}"`);
								}

							} else {
								await exportElementToPng(element.id, element.key, request_body, element.class);
							}
						}
					}

					const duration = Date.now() - start;
					exportResults.push({
						id: element.id,
						key: element.key,
						success: true,
						durationMs: duration
					});

					} catch (error) {
					const duration = Date.now() - start;
					exportResults.push({
						id: element.id,
						key: element.key,
						success: false,
						durationMs: duration,
						errorMessage: error?.message || 'Erreur inconnue'
					});

					console.error(`❌ Échec export "${element.id}" après ${duration} ms`, error);
					}

					completedElements++;
					commit('SET_VALUE', {
					c: 'export_progress',
					v: (completedElements / totalElements) * 100
					});
				}
				// Restauration styles
				zohoLinks.forEach(link => document.head.appendChild(link));
/*
				fontStyleNodes.forEach(node => document.head.appendChild(node));
				materialLinks.forEach(link => document.head.appendChild(link));
				googleWoffNodes.forEach(node => document.head.appendChild(node));
*/				
				document.querySelectorAll('.leaflet-control-container').forEach(el => {
					el.style.visibility = 'visible';
				});

				commit('SET_VALUE', { c: 'export_progress_visible', v: false });
				console.log('🎉 Tous les exports sont terminés !');
				console.table(exportResults);
				};

				// Lancer l’export en série
				return exportSequentially();






			};



			exportAllImages(request_body)
			.then(() => {
				axios.post(url, request_body, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					dispatch('set_loading', { loading: false })
	
					let url = response.data.data.url;
					const xhr = new XMLHttpRequest();
					xhr.open('GET', url, true);
					xhr.responseType = 'blob';
	
					xhr.onload = () => {
					const blob = xhr.response;
					const a = document.createElement('a');
					const url = window.URL.createObjectURL(blob);
					a.href = url;
					a.download = 'efocus_' + _.now() + '.pdf';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					};
	
					xhr.send();
					dispatch('set_loading_pdf', { loading_pdf: false })
				})											
			})
			.catch((error) => {
				console.error('Erreur lors de la capture des images', error);
				dispatch('set_loading', { loading: false });
			});
		}
		
	}, 
	
	// eslint-disable-next-line
	get_report_pdf_b: function({ commit, state, dispatch }, data) {
		if (!state.loading) {
			gtag('event', 'livedata_pdf', {'event_category': 'filtre','event_label': 'livedata_pdf'});
			dispatch('send_event_backend', {module: 'livedata', action: 'pdf', option: ''});
			dispatch('set_loading', { loading: true })
			let url = ''
			if (data && !data) console.log(data)
			
			url = state.BaseUrlBackend + '/report/pdf_b?entree=' + data.entree + '&prix=' + data.prix + '&destination=' + data.destination + '&financement=' + data.tva + '&modules=' + data.modules
			let request_body = state.livedata;
			const a = JSON.parse(JSON.stringify(state.cityscan.adresse))
			for (const attribut in a) {
				if (Object.prototype.hasOwnProperty.call(a, attribut)) {
					if (attribut == 'biens_comparables') a.biens_comparables.splice(0);
					for (const attribut2 in a[attribut]) {
						if (attribut2=='factors') {
							if (Array.isArray(a[attribut]['factors'])) {
								a[attribut]['factors'].splice(0);
							}
						}
					}
				}
			}
			request_body.ancien = a;
			request_body.locatif = state.locatif;
			request_body.ancien.reference = state.cityscan.realty;
			request_body.modules_adresse = state.modules_adresse;
			axios.post(url, request_body, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				dispatch('set_loading', { loading: false })

				let url = response.data.data.url;
				const xhr = new XMLHttpRequest();
				xhr.open('GET', url, true);
				xhr.responseType = 'blob';

				xhr.onload = () => {
				const blob = xhr.response;
				const a = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				a.href = url;
				a.download = 'efocus_' + _.now() + '.pdf';
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
				};

				xhr.send();
			})

		}
		
	}, 

	get_report_pdf3: function({ commit, state, dispatch }, data) {
		if (!state.loading) {
			dispatch('set_loading', { loading: true })
			let url = ''
			
			
			url = 'https://www.myadequation.fr/apiefocus/ReportV3/'+ state.livedata.livedata_id
			
			let request_body = { ListeProgrammes: state.livedata.pg_codes, ListePC: state.livedata.pc_codes, ListeSecteurs: state.livedata.secteurs_codes, FormeUrbaine: 3, projet_lat: this.map_osm.getCenter().lat, projet_lng : this.map_osm.getCenter().lng, optimisation: state.optimisation, tableau: data.tableau }
			axios.post(url, request_body, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('URL_REPORT_INIT', {url : response.data.url})
				commit('URL_REPORT_DISPO', {dispo : true})
				dispatch('set_loading', { loading: false })
			})
		}
		
	}, 	
	
	get_list_report: function({ commit, state, dispatch }) {
		if (!state.loading) {			
			dispatch('set_loading', { loading: true })
			let url = ''
			url = state.BaseUrlBackend + '/report/get'
			axios.get(url, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				commit('SET_REPORT_LIST', {ReportList: response.data})
				dispatch('set_loading', { loading: false })
			})
		}
		
	}, 
	
	async report_by_id({ commit, state, dispatch }, data) {

		// Fonction qui retourne une promesse qui se résout après un certain délai
		function sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		}

		// Fonction asynchrone dans laquelle vous voulez faire une pause
		async function Attente(n) {

			// Ici, on fait une pause de 2 secondes
			await sleep(n);

		}

		commit('SET_SOURCE_VIEW', {view: data.view})
		commit('RAZ_SELECTED_SECTEUR', {})
		commit('SET_AVM_HEATMAP', {data: false, m : false, diff: false, cpt: false, price: false, rayon: false })
		
		if (!state.loading) {
			gtag('event', 'livedata', {'event_category': 'module','event_label': 'livedata'});
			dispatch('send_event_backend', {module: 'livedata', action: 'ouverture', option: ''});
			commit('SET_ETAPE', { etape: 3 })
			dispatch('set_loading', { loading: true })
			let url = ''
			for (let index = 0; index < data.programs.length; index++) {
				if (!data.programs[index].code.startsWith('did_')) data.programs[index].code = 'did_' + data.programs[index].code
			}
			data.recherche = state.adr_init
			data.insee = state.geo_init.insee
			data.secteurs = state.secteurs
			data.secteurs_lib = state.secteurs_lib
			if (data.secteurs.length == 0) {
				data.secteurs = state.geo_init.quartier_code
				data.secteurs_lib = state.geo_init.quartier_libelle
				for (let index = 0; index < data.secteurs.length; index++) {
					const code = data.secteurs[index];
					const lib = data.secteurs_lib[index];
					commit('ADD_SECTEURS', {secteurs: code, secteurs_lib: lib})
				}
			}
			url = state.BaseUrlBackend + '/livedata/create2'

			if (state.locatifajour == false) {
				await dispatch('ChargerDonneesYanport')
				await Attente(5000);
			}

			axios.post(url, data, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				let livedata = response.data
				/*
				function tri(a,b){
					if(a.promoteur != b.promoteur){
						return a.promoteur > b.promoteur ? 1 : -1;
					}
					return 0;
				}
				*/
				function tri_sec(a,b){
					if(a.secteur != b.secteur){
						return a.secteur > b.secteur ? 1 : -1;
					}
					return 0;
				}
				function tri_mev(a,b){
					if(a.mev != b.mev){
						return a.mev > b.mev ? 1 : -1;
					}
					return 0;
				}
				let t = []
				let indice = 0
				livedata.synoptique.sort(tri_sec)
				for(let i = 0; i < livedata.synoptique.length; i++){
					//livedata.synoptique[i].tableau.sort(tri)
					livedata.synoptique[i].tableau.sort(tri_mev)
					for(let j = 0; j < livedata.synoptique[i].tableau.length; j++){
						indice = indice + 1;
						livedata.synoptique[i].tableau[j].id = indice
					}
					t.push(livedata.synoptique[i].secteur)
				}
				let tp = []
				for(let j = 0; j < livedata.synoptique_pc.length; j++){
					tp.push(livedata.synoptique_pc[j].secteur)
				}
				let tap = []
				for(let j = 0; j < livedata.synoptique_ap.length; j++){
					tap.push(livedata.synoptique_ap[j].secteur)
				}
				let tr = []
				for(let k = 0; k < livedata.synoptique_rs.length; k++){
					tr.push(livedata.synoptique_rs[k].secteur)
				}
				
				livedata.tab_s = t
				livedata.tab_sp = tp
				livedata.tab_ap = tap
				livedata.tab_sr = tr
				livedata.periode1 = "ans"
				livedata.periode2 = "trimestres"
				commit('SET_LIVE_DATA', { livedata: livedata })
				dispatch('set_loading', { loading: false })
				dispatch('set_view', { view: 'report' })
			})
		}
	},
	
	report_B_by_id: function({ commit, state, dispatch }, data) {
		commit('SET_SOURCE_VIEW', {view: data.view})
		commit('RAZ_SELECTED_SECTEUR', {})
		commit('SET_AVM_HEATMAP', {data: false, m : false, diff: false, cpt: false, price: false, rayon: false })
		
		if (!state.loading) {
			gtag('event', 'livedata', {'event_category': 'module','event_label': 'livedata'});
			dispatch('send_event_backend', {module: 'livedata', action: 'ouverture', option: ''});
			commit('SET_ETAPE', { etape: 3 })
			dispatch('set_loading', { loading: true })
			let url = ''
			data.insee = state.geo_init.insee
			data.secteurs = state.secteurs
			data.secteurs_lib = state.secteurs_lib
			for (let index = 0; index < data.programs.length; index++) {
				if (!data.programs[index].code.startsWith('did_')) data.programs[index].code = 'did_' + data.programs[index].code
			}
			url = state.BaseUrlBackend + '/livedata/createB'
			axios.post(url, data, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				let livedata = response.data
				
				function tri(a,b){
					if(a.promoteur != b.promoteur){
						return a.promoteur > b.promoteur ? 1 : -1;
					}
					return 0;
				}
				for(let i = 0; i < livedata.synoptique.length; i++){
					livedata.synoptique[i].tableau.sort(tri)
				}
				livedata.periode1 = "ans"
				livedata.periode2 = "trimestres"
				commit('SET_LIVE_DATA', { livedata: livedata })
				dispatch('set_loading', { loading: false })
				dispatch('set_view', { view: 'report_B' })
			})
		}
	},
	
	report_E_by_id: function({ commit, state, dispatch }, data) {
		commit('SET_SOURCE_VIEW', {view: data.view})
		commit('RAZ_SELECTED_SECTEUR', {})
		commit('SET_AVM_HEATMAP', {data: false, m : false, diff: false, cpt: false, price: false, rayon: false })
		
		if (!state.loading) {
			gtag('event', 'livedata', {'event_category': 'module','event_label': 'livedata'});
			dispatch('send_event_backend', {module: 'livedata', action: 'ouverture', option: ''});
			commit('SET_ETAPE', { etape: 3 })
			dispatch('set_loading', { loading: true })
			let url = ''
			data.insee = state.geo_init.insee
			data.secteurs = state.secteurs
			data.secteurs_lib = state.secteurs_lib

			url = state.BaseUrlBackend + '/livedata/create'
			axios.post(url, data, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				let livedata = response.data

				let tr = []
				for(let k = 0; k < livedata.synoptique_rs.length; k++){
					tr.push(livedata.synoptique_rs[k].secteur)
				}
				
				livedata.tab_sr = tr
				livedata.periode1 = "ans"
				livedata.periode2 = "trimestres"
				commit('SET_LIVE_DATA', { livedata: livedata })
				dispatch('set_loading', { loading: false })
				dispatch('set_view', { view: 'report_E' })
			})
		}
	},
	
	expand_gisement: function({ commit, dispatch }, data) {
		if (data.selectgisement) {
			if (state.expanded_gisement && state.expanded_gisement.gisement.id == data.selectgisement.gisement.id) {
				commit('EDIT_APP', { expanded_gisement: false })
				dispatch('set_view_prog', { view: '' })
			} else {
				commit('EDIT_APP', { active_gisement_loading: true })
				gtag('event', 'gisement_ouverture', {'event_category': 'action','event_label': 'gisement_ouverture'});
				dispatch('send_event_backend', {module: 'gisement', action: 'fiche gisement', option: data.selectgisement.gisement.id});
				commit('EDIT_APP', { expanded_gisement: data.selectgisement })


				let url2 = state.BaseUrlBackend + '/gisements/detailed?id=' + data.selectgisement.gisement.id
				axios.get(url2, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					if (response && response.data) {
						commit('EDIT_APP', { active_gisement: response.data })
						commit('REFRESH_PROG', { refresh: false })
					}
					commit('EDIT_APP', { active_gisement_loading: false })
				})

				dispatch('SendEvent', { action: "Ouverture gisement", opt_label: data.selectgisement.gisement.id, opt_value: data.selectgisement.gisement.id })
				dispatch('set_view_prog', { view: 'gisement' })
			}
		} else {
			commit('EDIT_APP', { expanded_gisement: false })
			dispatch('set_view_prog', { view: '' })
		}
	},

	liste_gisement: function({ commit }, data) {
		if (data.gisements) {
			commit('EDIT_APP', { gisements: data.gisements })
		}
	},

	expand_program: function({ commit, dispatch }, data) {
		if (data.program) {
			gtag('event', 'programme_neuf_ouverture', {'event_category': 'action','event_label': 'programme_neuf_ouverture'});
			dispatch('send_event_backend', {module: 'neuf', action: 'fiche programme', option: data.program});
			commit('REFRESH_PROG', { refresh: true })
			commit('EDIT_APP', { expanded_program_mrk: data.mrk })
			commit('EDIT_APP', { expanded_program: data.program.id })
			
			if (!data.program.pc && !data.program.veb) {
				let vId = data.program.id.toString()
				if (!vId.startsWith('did_')) vId = 'did_' + data.program.id
				let url2 = state.BaseUrlBackend + '/programs/detailed?id=' + vId
	
				axios.get(url2, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					if (response && response.data) {
						commit('EDIT_APP', { active_segmentation: response.data })
						commit('REFRESH_PROG', { refresh: false })
					}
				})
			}
			
			dispatch('set_view_prog', { view: 'program' })
			dispatch('SendEvent', { action: "Ouverture programme", opt_label: data.program.nom, opt_value: data.program.id })
		} else {
			commit('EDIT_APP', { active_segmentation: false })
			commit('EDIT_APP', { expanded_program: false })
			dispatch('set_view_prog', { view: '' })
		}
	},
	
	expand_rs: function({ commit, dispatch }, data) {
		if (data.rs) {
			gtag('event', 'programme_rss_ouverture', {'event_category': 'action','event_label': 'programme_rss_ouverture'});
			dispatch('send_event_backend', {module: 'rs', action: 'fiche residence', option: data.rs});
			commit('REFRESH_RS', { refresh: true })
			commit('EDIT_APP', { expanded_rs: data.rs.id })
			dispatch('set_view_prog', { view: 'rs' })
		} else {
			commit('EDIT_APP', { expanded_rs: false })
			dispatch('set_view_prog', { view: '' })
		}
	},
	
	expand_annonce: function({ commit, dispatch }, data) {
		if (data.annonce) {
			gtag('event', 'annonce_locative_ouverture', {'event_category': 'action','event_label': 'annonce_locative_ouverture'});
			dispatch('send_event_backend', {module: 'locatif', action: 'fiche annonce', option: data.annonce});
			commit('REFRESH_ANNONCE', { refresh: true })
			commit('EDIT_APP', { expanded_annonce: data.annonce.id })
			dispatch('set_view_prog', { view: 'annonce' })
		} else {
			commit('EDIT_APP', { expanded_annonce: false })
			dispatch('set_view_prog', { view: '' })
		}
	},
	
	expand_rpls: function({ commit, dispatch }, data) {
		if (data.rpls) {
			gtag('event', 'programme_rpls_ouverture', {'event_category': 'action','event_label': 'programme_rpls_ouverture'});
			dispatch('send_event_backend', {module: 'rpls', action: 'fiche rpls', option: data.rpls});
			commit('REFRESH_RS', { refresh: true })
			commit('EDIT_APP', { expanded_rpls: data.rpls.residence })
			dispatch('set_view_prog', { view: 'rpls' })
		} else {
			commit('EDIT_APP', { expanded_rpls: false })
			dispatch('set_view_prog', { view: '' })
		}
	},
	
	expand_offre: function({ commit, dispatch }, data) {
		if (data.offre) {
			gtag('event', 'programme_offre_ouverture', {'event_category': 'action','event_label': 'programme_offre_ouverture'});
			dispatch('send_event_backend', {module: 'ancien', action: 'fiche offre', option: data.offre});
			commit('REFRESH_OFFRE', { refresh: true })
			commit('EDIT_APP', { expanded_offre: data.offre.id })
			dispatch('set_view_prog', { view: 'offre' })
		} else {
			commit('EDIT_APP', { expanded_offre: false })
			dispatch('set_view_prog', { view: '' })
		}
	},
	
	expand_offre_locatif: function({ commit, dispatch }, data) {
		if (data.offre) {
			gtag('event', 'programme_offre_ouverture', {'event_category': 'action','event_label': 'programme_offre_ouverture'});
			dispatch('send_event_backend', {module: 'ancien', action: 'fiche offre', option: data.offre});
			commit('REFRESH_OFFRE_LOCATIF', { refresh: true })
			commit('EDIT_APP', { expanded_offre_locatif: data.offre.id })
			dispatch('set_view_prog', { view: 'offre-locatif' })
		} else {
			commit('EDIT_APP', { expanded_offre_locatif: false })
			dispatch('set_view_prog', { view: '' })
		}
	},
	
	expand_parcelle: function({ commit }, data) {
		if (data.parcelle) {
			commit('EDIT_APP', { expanded_parcelle: data.parcelle.id })
		} else {
			commit('EDIT_APP', { expanded_parcelle: false })
		}
	},
	
	expand_program_from_syno: function({ commit, dispatch }, data) {
		if (data.id) {
			gtag('event', 'programme_neuf_ouverture', {'event_category': 'action','event_label': 'programme_neuf_ouverture'});
			dispatch('send_event_backend', {module: 'livedata', action: 'fiche programme', option: data.id});
			commit('EDIT_APP', { expanded_program: data.id })
			commit('REFRESH_PROG', { refresh: true })




			if (!data.pc) {
				let vId = data.id
				if (!data.id.startsWith('did_')) vId = 'did_' + data.id
				let url2 = state.BaseUrlBackend + '/programs/detailed?id=' + vId
				axios.get(url2, { headers: state.HeaderEfocusBack})
				.then(function(response) {
					if (response && response.data) {
						commit('EDIT_APP', { active_segmentation: response.data })
						commit('REFRESH_PROG', { refresh: false })
					}
				})
			}
			
			dispatch('set_view_prog', { view: 'program' })
		} else {
			commit('EDIT_APP', { expanded_program: false })
			dispatch('set_view_prog', { view: '' })
		}
	},
	
	edit_filter: function({ commit }, data) {
		commit('EDIT_FILTER', data)
	},
	
	set_loading: function({ commit }, data) {
		commit('SET_LOADING', { loading: data.loading })
	},
	
	set_loading_pdf: function({ commit }, data) {
		commit('SET_LOADING_PDF', { loading_pdf: data.loading_pdf })
	},
	
	set_loading_mutations: function({ commit }, data) {
		commit('SET_LOADING_MUTATIONS', { loading: data.loading })
	},
	
	set_loading_offre: function({ commit }, data) {
		commit('SET_LOADING_OFFRE', { loading: data.loading })
	},
	
	set_autolog: function({ commit }, data) {
		commit('SET_AUTOLOG', { autolog: data.autolog })
	},
	
	set_loading_cityscan: function({ commit }, data) {
		commit('SET_LOADING_CITYSCAN', { loading: data.loading, item: data.item })
	},
	
	set_loading_avm: function({ commit }, data) {
		commit('SET_LOADING_AVM', { loading: data.loading })
	},
	
	set_jwt: function({ commit }, data) {
		commit('SET_JWT', { jwt: data.jwt, user_id: data.user_id })
	},
	
	set_print: function({ commit }, data) {
		commit('EDIT_APP', { print: data.print })
	},
	
	set_contour_iso: function({ commit }, data) {
		commit('SET_CONTOURS', { type: "iso", contours: data.contour })
	},

	set_contour_iso_map: function({ commit }, data) {
		commit('SET_CONTOURS_ISO_MAP', { contours: data.contour })
	},
	
	set_contour_loyer: function({ commit }, data) {
		commit('SET_CONTOURS', { type: "loyer", contours: data.contour })
	},
	
	set_contour_prix_ancien: function({ commit }, data) {
		commit('SET_VALUE', {c: 'contour_prix_ancien', v: data.contour});
	},

	set_contour_prix_locatif: function({ commit }, data) {
		commit('SET_VALUE', {c: 'contour_prix_locatif', v: data.contour});
	},

	set_contour_prix_locatif: function({ commit }, data) {
		commit('SET_VALUE', {c: 'contour_prix_locatif', v: data.contour});
	},

	set_contour_prix: function({ commit }, data) {
		commit('SET_CONTOURS', { type: "prix", contours: data.contour })
	},
	
	set_contour_iso_param: function({ commit }, data) {
		commit('SET_CONTOURS_PARAM', data)
	},
	set_contour_iso_map_param: function({ commit }, data) {
		commit('SET_CONTOURS_ISO_PARAM', data)
	},
	set_optimisation: function({ commit }, data) {
		commit('SET_OPTIMISATION', data)
	},
	set_help: function({ commit }, data) {
		commit('SET_HELP', data)
	},
	set_help_prog: function({ commit }, data) {
		commit('SET_HELP_PROG', data)
	},
	set_help_rs: function({ commit }, data) {
		commit('SET_HELP_RS', data)
	},
	set_help_live: function({ commit }, data) {
		commit('SET_HELP_LIVE', data)
	},

	send_event_backend: function({ commit }, data) {
		commit('NULL');
		let url = state.BaseUrlBackend + '/backend/log'
		axios.post(url, data, { responseType: '', headers: state.HeaderEfocusBack});
	},

	set_activesection2: function({ commit }, data) {
		commit('SET_ACTIVESECTION2', data)
	},

	set_preferences_adresses_niv1: function({ commit }, data) {
		commit('SET_PREFERENCES_ADRESSES_NIV1', data)
	},

	set_preferences_adresses_niv2: function({ commit }, data) {
		commit('SET_PREFERENCES_ADRESSES_NIV2', data)
	},

	set_value: function({ commit }, data) {
		commit('SET_VALUE', data)
	},

	load_estimmo: function({ commit }, data) {
		if (state.module_estimmo) {
			commit('SET_VALUE', {c: 'loading_estimmo', v: true});
			let url = state.BaseUrlBackend + '/estimmo'
			let p = []
			for (let index = 0; index < data.p.superficies.length; index++) {
				let a = {
					typology : data.p.superficies[index].typology,
					surface : data.p.superficies[index].surface,
				}
				p.push(a)
			}
			const dataTypo = {
				"coordinates": {
					"latitude":  data.latlng.lat,
					"longitude": data.latlng.lng
				},
				"programme_size": data.p.programme_size,
				"superficies": p,
				"year_of_sale": 2025
			}

			commit('SET_ESTIMMO_PRG_SIZE', {v: data.p});
			axios.post(url, dataTypo, { headers: state.HeaderEfocusBack})
			.then(function(response) {
				if (response && response.data) {
					let v = JSON.parse(JSON.stringify(state.estimmo));
					let e = response.data.result
					for (let index = 0; index < e.length; index++) {
						if (v.superficies[index].typology = e[index].typology) {
							for (let index = 0; index < e.length; index++) {
								v.superficies[index].prix = e[index].prix
							}
						}
					}
					commit('SET_VALUE', {c: 'estimmo', v: v});
					commit('SET_VALUE', {c: 'loading_estimmo', v: false});
				}
			})
		}
	},
}


// MUTATIONS
const mutations = {
	SET_ESTIMMO_PRG_SIZE: function(state, data) {
		state.estimmo.programme_size = data.v.programme_size
		state.estimmo.superficies = data.v.superficies
	},
	SET_MAPDISTANCE: function(state, data) {
		state.mapdistance = data.mapdistance
	},
	SET_MAPDISTANCETIME: function(state, data) {
		state.mapdistancetime = data.mapdistancetime
	},
	SET_MAPDISTANCEOFFRE: function(state, data) {
		state.mapdistanceoffre = data.mapdistanceoffre
		state.filtre_ancien_offre.distance = data.mapdistanceoffre
	},
	SET_MAPDISTANCEOFFRETIME: function(state, data) {
		state.mapdistanceoffretime = data.mapdistanceoffretime
	},
	SET_MAPDISTANCEOFFRELOCATIF: function(state, data) {
		state.mapdistanceoffrelocatif = data.mapdistanceoffre
		state.filtre_offre_locatif.distance = data.mapdistanceoffre
	},
	SET_MAPDISTANCEOFFRELOCATIFTIME: function(state, data) {
		state.mapdistanceoffrelocatiftime = data.mapdistanceoffretime
	},
	SET_MAPDISTANCERPLS: function(state, data) {
		state.mapdistancerpls = data.mapdistancerpls
	},
	SET_MAPDISTANCERPLSTIME: function(state, data) {
		state.mapdistancerplstime = data.mapdistancerplstime
	},
	SET_PREFERENCES_ADRESSES_NIV1: function(state, data) {
		let index = state.preferences.adresse_niv1.indexOf(data.niv1)
		if (data.select) {
			if (index == -1) {
				state.preferences.adresse_niv1.push(data.niv1)
				for (let index = 0; index < data.niv2.length; index++) {
					const element = data.niv2[index];
					if (state.preferences.adresse_niv2.indexOf(element) == -1) state.preferences.adresse_niv2.push(element)
				}
			}
		} else {
			if (index !== -1) state.preferences.adresse_niv1.splice(index, 1)
		}
	},
	
	SET_PREFERENCES_ADRESSES_NIV2: function(state, data) {
		let index = state.preferences.adresse_niv2.indexOf(data.niv2)
		if (data.select) {
			if (index == -1) state.preferences.adresse_niv2.push(data.niv2)
		} else {
			if (index !== -1) state.preferences.adresse_niv2.splice(index, 1)
		}
	},
	
	RECORD_PREFERENCES: function(state) {
		try {
			state.preferences.carto.poi = state.contour_poi
			state.preferences.carto.metro = state.contour_metro
			state.preferences.carto.gpe = state.contour_ligne_gpe
			state.preferences.carto.tram = state.contour_tramway
			state.preferences.carto.train = state.contour_train

			state.preferences.ancien.estimation.rooms = state.cityscan.realty.rooms
			state.preferences.ancien.estimation.typeId = state.cityscan.realty.typeId
			state.preferences.ancien.estimation.condition = state.cityscan.realty.condition
			state.preferences.ancien.estimation.parkingOpen = state.cityscan.realty.parkingOpen
			state.preferences.ancien.estimation.area = state.cityscan.realty.area

		} catch (error) {
		//	
		}

		state.preferences.neuf.filtres.anciennete = (new Date()).getFullYear() - state.filters.annee_actif
		state.preferences.neuf.filtres.etat = []
		if (state.filters.termine) state.preferences.neuf.filtres.etat.push('termines')
		if (state.filters.actif) state.preferences.neuf.filtres.etat.push('actifs')
		if (state.filters.projet) state.preferences.neuf.filtres.etat.push('projets')

		state.preferences.neuf.filtres.fu = []
		if (state.filters.col) state.preferences.neuf.filtres.fu.push('collectif')
		if (state.filters.ind) state.preferences.neuf.filtres.fu.push('individuel')

		state.preferences.neuf.filtres.tva = []
		if (state.filters.tvap) state.preferences.neuf.filtres.tva.push('pleine')
		if (state.filters.tvar) state.preferences.neuf.filtres.tva.push('reduite')

		state.preferences.neuf.filtres.financements = []
		if (state.filters.lli) state.preferences.neuf.filtres.financements.push('lli')
		if (state.filters.psla) state.preferences.neuf.filtres.financements.push('psla')
		if (state.filters.brs) state.preferences.neuf.filtres.financements.push('brs')
		if (state.filters.anru) state.preferences.neuf.filtres.financements.push('anru')
		if (state.filters.aucun) state.preferences.neuf.filtres.financements.push('aucun')
		if (state.filters.autres) state.preferences.neuf.filtres.financements.push('autres')

		if (state.fond_carte == 1 ) state.preferences.carto.fond = 'gris'
		if (state.fond_carte == 2 ) state.preferences.carto.fond = 'couleurs'
		if (state.fond_carte == 3 ) state.preferences.carto.fond = 'satellite'

		state.preferences.carto.layers = []
		if (state.contour_zac) state.preferences.carto.layers.push('zac')
		if (state.contour_qpv) state.preferences.carto.layers.push('qpv')
		if (state.contour_qpv_trois) state.preferences.carto.layers.push('qpv_300')
		if (state.contour_commune) state.preferences.carto.layers.push('communes')
			
		state.preferences.neuf.legende = state.pin_type

		state.preferences_init = JSON.parse(JSON.stringify(state.preferences));
	},

	SET_PREFERENCES: function(state, data) {
		
			state.preferences = JSON.parse(JSON.stringify(data.preferences));
			if (data.init) {
				state.preferences_init = JSON.parse(JSON.stringify(data.preferences));
			}
			if (data.preferences) {
				state.filters.annee_actif = (new Date()).getFullYear()-data.preferences.neuf.filtres.anciennete
				if (data.preferences.neuf.filtres.anciennete) state.filters.anciennete = data.preferences.neuf.filtres.anciennete
				state.filters.termine = data.preferences.neuf.filtres.etat.indexOf('termines')>-1
				state.filters.actif = data.preferences.neuf.filtres.etat.indexOf('actifs')>-1
				state.filters.projet = data.preferences.neuf.filtres.etat.indexOf('projets')>-1
	
				state.filters.col = data.preferences.neuf.filtres.fu.indexOf('collectif')>-1,
				state.filters.ind = data.preferences.neuf.filtres.fu.indexOf('individuel')>-1
	
				state.filters.forme.collectif = data.preferences.neuf.filtres.fu.indexOf('collectif')>-1,
				state.filters.forme.individuel = data.preferences.neuf.filtres.fu.indexOf('individuel')>-1
	
				state.filters.commercialisation.termine = data.preferences.neuf.filtres.etat.indexOf('termines')>-1
				state.filters.commercialisation.actif = data.preferences.neuf.filtres.etat.indexOf('actifs')>-1
	
				state.filters.tvap = data.preferences.neuf.filtres.tva.indexOf('pleine')>-1
				state.filters.tvar = data.preferences.neuf.filtres.tva.indexOf('reduite')>-1
	
				if (data.preferences.neuf.filtres.veb) {
					state.filters.veb_avec = data.preferences.neuf.filtres.veb.indexOf('veb_avec')>-1
					state.filters.veb_sans = data.preferences.neuf.filtres.veb.indexOf('veb_sans')>-1
				}
	
				state.filters.lli = data.preferences.neuf.filtres.financements.indexOf('lli')>-1
				state.filters.psla = data.preferences.neuf.filtres.financements.indexOf('psla')>-1
				state.filters.brs = data.preferences.neuf.filtres.financements.indexOf('brs')>-1
				state.filters.anru = data.preferences.neuf.filtres.financements.indexOf('anru')>-1
				state.filters.aucun = data.preferences.neuf.filtres.financements.indexOf('aucun')>-1
				state.filters.autres = data.preferences.neuf.filtres.financements.indexOf('autres')>-1
				if (data.preferences.carto.fond == 'gris') state.fond_carte = 1
				if (data.preferences.carto.fond == 'couleurs') state.fond_carte = 2
				if (data.preferences.carto.fond == 'satellite') state.fond_carte = 3
	
				state.contour_zac = data.preferences.carto.layers.indexOf('zac')>-1
				state.contour_qpv = data.preferences.carto.layers.indexOf('qpv')>-1
				state.contour_qpv_trois = data.preferences.carto.layers.indexOf('qpv_300')>-1
				state.contour_commune = data.preferences.carto.layers.indexOf('communes')>-1
				if (data.preferences.neuf.legende) state.pin_type = data.preferences.neuf.legende

				try {

					state.contour_poi = data.preferences.carto.poi
					state.contour_metro = data.preferences.carto.metro
					state.contour_ligne_gpe = data.preferences.carto.gpe
					state.contour_tramway = data.preferences.carto.tram
					state.contour_train = data.preferences.carto.train
		
					state.cityscan.realty.rooms = data.preferences.ancien.estimation.rooms
					state.cityscan.realty.typeId = data.preferences.ancien.estimation.typeId
					state.cityscan.realty.condition = data.preferences.ancien.estimation.condition
					state.cityscan.realty.area = data.preferences.ancien.estimation.area
					

				} catch (error) {
					console.log(error)
				}
		
			}
	},
	
	SET_LOCATIF_BI: function(state, data) {
		state.bi_locatif = data.bi_locatif
	},

	SET_LOCATIFAJOUR: function(state, data) {
		state.locatifajour = data.locatifajour;
		if (data.locatifajour == false) {
			state.locatif = {
				loyer_tranches_geo: { irisIds : [], cityIds: [], agglomerationIds: [] },
				loyer_tranches_typo: [null, null, null, null, null, null],
				loyer_tranches_typo_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
				yanport_typo_ref: [null, null, null, null, null, null],
				yanport_typo_ref_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
				yanport_typo_prix: [null, null, null, null, null, null],
				yanport_typo_prix_geo : { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
				yanport_typo_graph_prix: [null, null, null, null, null, null],
				yanport_typo_graph_prix_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
				yanport_typo_jour: [null, null, null, null, null, null],
				yanport_typo_jour_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
				yanport_typo_graph_jour: [null, null, null, null, null, null],
				yanport_typo_graph_jour_geo: { irisIds : [null, null, null, null, null, null], cityIds: [null, null, null, null, null, null], agglomerationIds: [null, null, null, null, null, null] },
				loyer_yanport_geo: {
					irisIds : {
						appel_biens: false,
						id: '',
						type: '',
						type_label: '',
						label: false,
						values: false,
						duration_values: false,
						mediane: false,
						count: false,
						value: false,
					}, cityIds: {
						appel_biens: false,
						id: '',
						type: '',
						type_label: '',
						label: false,
						values: false,
						duration_values: false,
						mediane: false,
						count: false,
						value: false,
					}, agglomerationIds: {
						appel_biens: false,
						id: '',
						type: '',
						type_label: '',
						label: false,
						values: false,
						duration_values: false,
						mediane: false,
						count: false,
						value: false,
					}
				}
			}
		}
	},

	CHANGE_ONGLET: function(state, data) {
		state.onglet = data.onglet;
	},

	SET_TERRITOIRES_NEUF: function(state, data) {
		state.territoires_neuf = data.territoires_neuf;
	},

	ADD_SECTEURS: function(state, data) {
		if (!state.secteurs.includes(data.secteurs)) {
			state.secteurs.push(data.secteurs);
		}
		if (!state.secteurs_lib.includes(data.secteurs_lib)) {
			state.secteurs_lib.push(data.secteurs_lib);
		}
	},

	DEL_SECTEURS: function(state, data) {
		for (let index = 0; index < state.secteurs.length; index++) {
			if (state.secteurs[index] == data.secteurs) {
				state.secteurs.splice(index, 1);
				state.secteurs_lib.splice(index, 1);
			}
			
		}
	},

	SET_SECTEURS: function(state, data) {
		state.ref_secteurs = data.secteurs
		state.secteurs = data.secteurs
		state.secteurs_lib = data.secteurs_lib
	},
	
	SET_ACTIVESECTION2: function(state, data) {
		state.activeSection2 = data.section
	},
	
	NULL: function() {
		
	}, 
	SET_GEO_INIT: function(state, data) {
		state.geo_init = data
	}, 
	YANPORT_DATE: function(state, data) {
		state.loyer_yanport_date = []
		for (let index = 0; index < data.length; index++) {
			const element = data[index];
			state.loyer_yanport_date.push(element.toString())
		}
	},

	SET_YANPORT_DATE_REQUEST: function() {
		const today = new Date();
		const dayOfWeek = today.getDay(); // 0 = Dimanche, 1 = Lundi, etc.
		const daysSinceLastMonday = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;

		// Dernier lundi
		const lastMonday = new Date(today);
		lastMonday.setDate(today.getDate() - daysSinceLastMonday);

		// Dernier lundi moins 1 an
		const lastMondayMinusOneYear = new Date(lastMonday);
		lastMondayMinusOneYear.setFullYear(lastMonday.getFullYear() - 1);
		
		// Dernier lundi moins 3 an
		const lastMondayMinusThreeYears = new Date(lastMonday);
		lastMondayMinusThreeYears.setFullYear(lastMonday.getFullYear() - 3);
		
		// Dernier lundi moins 5 ans
		const lastMondayMinusFiveYears = new Date(lastMonday);
		lastMondayMinusFiveYears.setFullYear(lastMonday.getFullYear() - 5);
		
		state.lastMonday = lastMonday;
		state.lastMondayMinusOneYear = lastMondayMinusOneYear;
		state.lastMondayMinusThreeYears = lastMondayMinusThreeYears;
		state.lastMondayMinusFiveYears = lastMondayMinusFiveYears;
	},

	RESET_YANPORT_TIME: function(state) {
		state.loyer_yanport_time = 0
	},
	
	SET_YANPORT_TYPO_REFSURF: function(state, data) {
		if (data.geo_type) {
			state.locatif.yanport_typo_ref_geo[data.geo_type][data.typo] = data.data
		} else {
			state.locatif.yanport_typo_ref[data.typo] = data.data
		}
	},

	SET_YANPORT_TYPOTAB_REFSURF: function(state, data) {
		if (data.geo_type) {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_ref_geo[data.geo_type][index] = data.data[index];				
			}
		} else {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_ref[index] = data.data[index];				
			}
			state.loyer_yanport_time += 1
		}
	},

	SET_YANPORT_TYPOTAB_PRIX: function(state, data) {
		if (data.geo_type) {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_prix_geo[data.geo_type][index] = data.data[index];				
			}
		} else {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_prix[index] = data.data[index];				
			}
			state.loyer_yanport_time += 1
		}
	},

	SET_YANPORT_TYPO_PRIX: function(state, data) {
		if (data.geo_type) {
			state.locatif.yanport_typo_prix_geo[data.geo_type][data.typo]  = data.data
		} else {
			state.locatif.yanport_typo_prix[data.typo] = data.data
		}
	},

	SET_YANPORT_TYPOTAB_GRAPH_PRIX: function(state, data) {
		if (data.geo_type) {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_graph_prix_geo[data.geo_type][index] = data.data[index];				
			}
			state.yanport_typo_graph_prix_geo_time = _.now()
		} else {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_graph_prix[index] = data.data[index];				
			}
			state.loyer_yanport_time += 1
			state.yanport_typo_graph_prix_time = _.now()
		}
	},

	SET_YANPORT_TYPO_GRAPH_PRIX: function(state, data) {
		if (data.geo_type) {
			state.locatif.yanport_typo_graph_prix_geo[data.geo_type][data.typo]  = data.data
		} else {
			state.locatif.yanport_typo_graph_prix[data.typo] = data.data
		}
	},

	SET_YANPORT_TYPOTAB_JOUR: function(state, data) {
		if (data.geo_type) {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_jour_geo[data.geo_type][index] = data.data[index];				
			}
		} else {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_jour[index] = data.data[index];				
			}
			state.loyer_yanport_time += 1
		}
	},

	SET_YANPORT_TYPO_JOUR: function(state, data) {
		if (data.geo_type) {
			state.locatif.yanport_typo_jour_geo[data.geo_type][data.typo]  = data.data
		} else {
			state.locatif.yanport_typo_jour[data.typo] = data.data
		}
	},

	SET_YANPORT_TYPOTAB_GRAPH_JOUR: function(state, data) {
		if (data.geo_type) {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_graph_jour_geo[data.geo_type][index] = data.data[index];				
			}
			state.yanport_typo_graph_jour_geo_time = _.now()
		} else {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.yanport_typo_graph_jour[index] = data.data[index];				
			}
			state.loyer_yanport_time += 1
			state.yanport_typo_graph_jour_time = _.now()
		}
	},

	SET_YANPORT_TYPO_GRAPH_JOUR: function(state, data) {
		if (data.geo_type) {
			state.locatif.yanport_typo_graph_jour_geo[data.geo_type][data.typo]  = data.data
		} else {
			state.yanport_typo_graph_jour[data.typo] = data.data
		}
	},
	SET_MODULES_ADRESSE: function(state, data) {
		state.modules_adresse.adresse_services = data.adresse_services;
		state.modules_adresse.adresse_numerique = data.adresse_numerique;
		state.modules_adresse.adresse_loisirs = data.adresse_loisirs;
		state.modules_adresse.adresse_vie = data.adresse_vie;
		state.modules_adresse.adresse_commerces = data.adresse_commerces;
		state.modules_adresse.adresse_education = data.adresse_education;
		state.modules_adresse.adresse_transport = data.adresse_transport;
		
		state.modules_adresse.adresse_transport_bus = data.adresse_transport_bus;
		state.modules_adresse.adresse_transport_metro = data.adresse_transport_metro;
		state.modules_adresse.adresse_transport_tram = data.adresse_transport_tram;
		state.modules_adresse.adresse_transport_route_rapide = data.adresse_transport_route_rapide;
		state.modules_adresse.adresse_transport_parking = data.adresse_transport_parking;
		state.modules_adresse.adresse_transport_gare = data.adresse_transport_gare;
		state.modules_adresse.adresse_transport_aeroport = data.adresse_transport_aeroport;
		state.modules_adresse.adresse_transport_port = data.adresse_transport_port;
		state.modules_adresse.adresse_transport_velo = data.adresse_transport_velo;
		state.modules_adresse.adresse_transport_auto = data.adresse_transport_auto;
		state.modules_adresse.adresse_transport_borne = data.adresse_transport_borne;

		state.modules_adresse.adresse_ecole_creche = data.adresse_ecole_creche;
		state.modules_adresse.adresse_ecole_maternelle = data.adresse_ecole_maternelle;
		state.modules_adresse.adresse_ecole_elementaire = data.adresse_ecole_elementaire;
		state.modules_adresse.adresse_ecole_college = data.adresse_ecole_college;
		state.modules_adresse.adresse_ecole_lycee = data.adresse_ecole_lycee;
		state.modules_adresse.adresse_ecole_lycee_pro = data.adresse_ecole_lycee_pro;
		state.modules_adresse.adresse_ecole_universite = data.adresse_ecole_universite;
		state.modules_adresse.adresse_ecole_superieur = data.adresse_ecole_superieur;
		state.modules_adresse.adresse_ecole_formation = data.adresse_ecole_formation;
		
		state.modules_adresse.adresse_commerce_alimentation = data.adresse_commerce_alimentation;
		state.modules_adresse.adresse_commerce_bouche = data.adresse_commerce_bouche;
		state.modules_adresse.adresse_commerce_utilitaire = data.adresse_commerce_utilitaire;
		state.modules_adresse.adresse_commerce_shopping = data.adresse_commerce_shopping;
		state.modules_adresse.adresse_commerce_soin = data.adresse_commerce_soin;
		state.modules_adresse.adresse_commerce_logement = data.adresse_commerce_logement;
		state.modules_adresse.adresse_commerce_vehicule = data.adresse_commerce_vehicule;

		state.modules_adresse.adresse_sonore = data.adresse_sonore;
		state.modules_adresse.adresse_olfactive = data.adresse_olfactive;
		state.modules_adresse.adresse_saturation_population = data.adresse_saturation_population;
		state.modules_adresse.adresse_saturation_vehicule = data.adresse_saturation_vehicule;
		state.modules_adresse.adresse_air = data.adresse_air;
		state.modules_adresse.adresse_electromagnetique = data.adresse_electromagnetique;
		state.modules_adresse.adresse_radon = data.adresse_radon;

		state.modules_adresse.adresse_haut_debit = data.adresse_haut_debit;
		state.modules_adresse.adresse_fibre = data.adresse_fibre;
		state.modules_adresse.adresse_mobile_4G = data.adresse_mobile_4G;
		state.modules_adresse.adresse_mobile_3G = data.adresse_mobile_3G;

		state.modules_adresse.adresse_loisir_bibliotheque = data.adresse_loisir_bibliotheque;
		state.modules_adresse.adresse_loisir_theatre = data.adresse_loisir_theatre;
		state.modules_adresse.adresse_loisir_musee = data.adresse_loisir_musee;
		state.modules_adresse.adresse_loisir_cinema = data.adresse_loisir_cinema;
		state.modules_adresse.adresse_loisir_bar = data.adresse_loisir_bar;
		state.modules_adresse.adresse_loisir_restaurant = data.adresse_loisir_restaurant;
		state.modules_adresse.adresse_loisir_discotheque = data.adresse_loisir_discotheque;
		state.modules_adresse.adresse_loisir_jardin = data.adresse_loisir_jardin;
		state.modules_adresse.adresse_loisir_sport_collectif = data.adresse_loisir_sport_collectif;
		state.modules_adresse.adresse_loisir_sport_individuel = data.adresse_loisir_sport_individuel;
		state.modules_adresse.adresse_loisir_hotel = data.adresse_loisir_hotel;
		state.modules_adresse.adresse_loisir_hebergement = data.adresse_loisir_hebergement;

		state.modules_adresse.adresse_service_commissariat = data.adresse_service_commissariat;
		state.modules_adresse.adresse_service_gendarmerie = data.adresse_service_gendarmerie;
		state.modules_adresse.adresse_service_pompier = data.adresse_service_pompier;
		state.modules_adresse.adresse_service_hopital = data.adresse_service_hopital;
		state.modules_adresse.adresse_service_laboratoire = data.adresse_service_laboratoire;
		state.modules_adresse.adresse_service_agees = data.adresse_service_agees;
		state.modules_adresse.adresse_service_pharmacie = data.adresse_service_pharmacie;
		state.modules_adresse.adresse_service_medecin = data.adresse_service_medecin;
		state.modules_adresse.adresse_service_specialiste = data.adresse_service_specialiste;
		state.modules_adresse.adresse_service_poste = data.adresse_service_poste;
		state.modules_adresse.adresse_service_recyclage = data.adresse_service_recyclage;
		state.modules_adresse.adresse_service_dechet = data.adresse_service_dechet;
	},
	SET_TERRITOIRES_MODULE: function(state, data) {
		state.territoires_module = data.territoires_module
		state.loyer_yanport_time = _.now()
	},
	
	REFRESH_PROG: function(state, data) {
		state.refresh_prog = data.refresh
	},
	
	REFRESH_RS: function(state, data) {
		state.refresh_rs = data.refresh
	},
	
	REFRESH_ANNONCE: function(state, data) {
		state.refresh_annonce = data.refresh
	},
	
	REFRESH_OFFRE: function(state, data) {
		state.refresh_offre = data.refresh
	},

	REFRESH_OFFRE_LOCATIF: function(state, data) {
		state.refresh_offre_locatif = data.refresh
	},

	INIT_DATE_YANPORT: function(state) {
		let d = new Date()
		state._deleteDateMax = d.toISOString().substring(0, 10)
		state._deleteDateMin = d.getFullYear()-1 + d.toISOString().substring(4, 10)
	},
	
	ADD_NOUVEAUTE: function(state, data) {
		state.nouveaute.push(data.url)
	},
	
	SET_LISTEBIENSLOCATIFS: function(state, data) {
		state.parambienslocatifs = data.param
		state.liste_biens_locatifs = data.liste_biens_locatifs
		state.loyer_yanport.appel_biens = true
		for (let index = 0; index < state.liste_biens_locatifs.hits.length; index++) {
			if ((state.liste_biens_locatifs.hits[index].features.geometry.surface>=state.filtre_locatif.area_min)
			&& (state.liste_biens_locatifs.hits[index].features.geometry.surface<=state.filtre_locatif.area_max)
			&& (state.liste_biens_locatifs.hits[index].marketing.priceHC>=state.filtre_locatif.price_min)
			&& (state.liste_biens_locatifs.hits[index].marketing.priceHC<=state.filtre_locatif.price_max)
			)
			{
				if ((state.liste_biens_locatifs.hits[index].features.geometry.roomCount==1 & !(state.filtre_locatif.t1))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount==2 & !(state.filtre_locatif.t2))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount==3 & !(state.filtre_locatif.t3))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount==4 & !(state.filtre_locatif.t4))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount>4 & !(state.filtre_locatif.t5)))
				{
					state.liste_biens_locatifs.hits[index].filter = false
				} else {
					if (!((state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='A' & state.filtre_locatif.A)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='B' & state.filtre_locatif.B)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='C' & state.filtre_locatif.C)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='D' & state.filtre_locatif.D)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='E' & state.filtre_locatif.E)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='F' & state.filtre_locatif.F)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='G' & state.filtre_locatif.G)
					|| (((!(state.liste_biens_locatifs.hits[index].features.energy)) || (!(state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter)) ) & state.filtre_locatif.NC)))
					{
						state.liste_biens_locatifs.hits[index].filter = false
					} else {
						try {
							if (!((state.liste_biens_locatifs.hits[index].features.descriptive.equipments.FURNITURE & state.filtre_locatif.MeubleOui)
							|| (!state.liste_biens_locatifs.hits[index].features.descriptive.equipments.FURNITURE & state.filtre_locatif.MeubleNon)
							|| (((!(state.liste_biens_locatifs.hits[index].features.descriptive)) || (!(state.liste_biens_locatifs.hits[index].features.descriptive.equipments)) ) & state.filtre_locatif.MeubleNC)))
							{
								state.liste_biens_locatifs.hits[index].filter = false
							} else {
								state.liste_biens_locatifs.hits[index].filter = true
							}
						} catch (error) {
							if (state.filtre_locatif.MeubleNC) {
								state.liste_biens_locatifs.hits[index].filter = true
							} else {
								state.liste_biens_locatifs.hits[index].filter = false
							}
						}
					}
				}
			} else {
				state.liste_biens_locatifs.hits[index].filter = false
			}
		}
	},

	SET_BIENSLOCATIFS: function(state, data) {
		state.bienslocatifs = data.value
		if (state.bienslocatifs) gtag('event', 'filtre_locatif', {'event_category': 'filtre','event_label': 'filtre_locatif'});

	},

	SET_HISTO_LOYER_TRANCHES: function(state, data) {
		if (data.geo_type) {
			state.locatif.loyer_tranches_geo[data.geo_type] = data.tranches
		} else {
			state.loyer_tranches = data.tranches
		}
	},

	SET_HISTO_LOYER_TRANCHES_TYPO: function(state, data) {
		if (data.geo_type) {
			state.locatif.loyer_tranches_typo_geo[data.geo_type][data.typo]  = data.data
		} else {
			state.locatif.loyer_tranches_typo[data.typo] = data.data
		}
	},

	SET_HISTO_LOYER_TRANCHES_TYPOTAB: function(state, data) {
		if (data.geo_type) {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.loyer_tranches_typo_geo[data.geo_type][index] = data.data[index];				
			}
		} else {
			for (let index = 0; index < data.data.length; index++) {
				state.locatif.loyer_tranches_typo[index] = data.data[index];				
			}
		}
		state.loyer_tranches_typo_geo_time = _.now()
	},

	SET_HISTO_LOYER: function(state, data) {
		if (data.geo_type) {
			state.locatif.loyer_yanport_geo[data.geo_type].type_label = data.type_label
			state.locatif.loyer_yanport_geo[data.geo_type].label = data.label
			state.locatif.loyer_yanport_geo[data.geo_type].values = data.values
			state.locatif.loyer_yanport_geo[data.geo_type].count = data.count
			state.locatif.loyer_yanport_geo[data.geo_type].value = data.value
			state.locatif.loyer_yanport_geo[data.geo_type].id = data.id
			state.locatif.loyer_yanport_geo[data.geo_type].type =  data.loyer_zoneType
			state.locatif.loyer_yanport_geo[data.geo_type].appel_biens = false
		} else {
			state.loyer_yanport.type_label = data.type_label
			state.loyer_yanport.label = data.label
			state.loyer_yanport.values = data.values
			state.loyer_yanport.count = data.count
			state.loyer_yanport.value = data.value
			state.loyer_yanport.id = data.id
			state.loyer_yanport.type =  data.loyer_zoneType
			state.loyer_yanport.appel_biens = false
		}
	},

	SET_HISTO_LOYER_DURATION: function(state, data) {
		if (data.geo_type) state.locatif.loyer_yanport_geo[data.geo_type].duration_values = data.values
		else state.loyer_yanport.duration_values = data.values
	},

	SET_MEDIANE_LOYER: function(state, data) {
		if (data.geo_type) {
			state.locatif.loyer_yanport_geo[data.geo_type].mediane  = data.mediane
		} else {
			state.loyer_yanport.mediane = data.mediane
		}
	},

	SET_FILTERS_PROMOTION: function(state, data) {
		gtag('event', 'filtre_neuf', {'event_category': 'filtre','event_label': 'filtre_neuf'});
		state.filters_promotion = data.filters_promotion
		if (state.filters_promotion) {
			state.aide = false
			state.aide_live = false
			state.aide_prog = false
			state.aide_rs = false
			state.preferences_promotion = false
		}
	},

	SET_PREFERENCES_PROMOTION: function(state, data) {
		gtag('event', 'preferences_neuf', {'event_category': 'filtre','event_label': 'preferences_neuf'});
		state.preferences_promotion = data.preferences_promotion
		if (state.preferences_promotion) {
			state.aide = false
			state.aide_live = false
			state.aide_prog = false
			state.aide_rs = false
			state.filters_promotion = false
		}
	},

	SET_FILTERS_PROMOTION_PC: function(state, data) {
		gtag('event', 'filtre_pc', {'event_category': 'filtre','event_label': 'filtre_pc'});
		state.filters_promotion = data.filters_promotion
		if (state.filters_promotion) {
			state.aide = false
			state.aide_live = false
			state.aide_prog = false
			state.aide_rs = false
			state.preferences_promotion = false
		}
	},

	SET_FILTERS_RS: function(state, data) {
		gtag('event', 'filtre_rss', {'event_category': 'filtre','event_label': 'filtre_rss'});
		state.filters_rs = data.filters_rs
		if (state.filters_rs) {
			state.aide = false
			state.aide_live = false
			state.aide_prog = false
			state.aide_rs = false
			state.preferences_promotion = false
		}
	},

	SET_FILTERS_ANCIEN: function(state) {
		gtag('event', 'filtre_rss', {'event_category': 'filtre','event_label': 'filtre_ancien'});
		state.filters_ancien = !state.filters_ancien
		if (state.filters_ancien) {
			state.aide = false
			state.aide_live = false
			state.aide_prog = false
			state.aide_rs = false
			state.preferences_promotion = false
		}
	},

	SET_HELP: function(state, data) {
		state.aide = data.aide
		state.theme = data.theme
		if (state.aide) {
			state.aide_live = false
			state.aide_prog = false
			state.filters_promotion = false
			state.preferences_promotion = false
			state.filters_rs = false
		}
	},

	SET_HELP_PROG: function(state, data) {
		state.aide_prog = data.aide
		if (state.aide_prog) {
			state.aide_live = false
			state.aide = false
			state.filters_promotion = false
			state.preferences_promotion = false
			state.filters_rs = false
		}
	},

	SET_HELP_RS: function(state, data) {
		state.aide_rs = data.aide
		if (state.aide_rs) {
			state.aide_prog = false
			state.aide_live = false
			state.aide = false
			state.filters_promotion = false
			state.preferences_promotion = false
		}
	},

	SET_HELP_LIVE: function(state, data) {
		state.aide_live = data.aide
		if (state.aide_live) {
			state.aide_prog = false
			state.aide = false
			state.filters_promotion = false
			state.preferences_promotion = false
			state.filters_rs = false
		}
	},
	
	SET_OPTIMISATION: function(state, data) {
		state.optimisation.entree = data.entree
		state.optimisation.ryhtme = data.ryhtme
		state.optimisation.destination = data.destination
		state.optimisation.financement = data.financement
		state.optimisation.prix = data.prix		
	},

	SET_RSS_REFERENCES: function(state, data) {
		state.rss_references = data.references
	},

	SET_CONTOURS_PARAM: function(state, data) {
		state.cityscan.isochrone.transportType = data.transportType
		state.cityscan.isochrone.duration = data.duration
	},

	SET_CONTOURS_ISO_PARAM: function(state, data) {
		state.isochrone.transportType = data.transportType
		state.isochrone.duration = data.duration
	},

	SET_NBPROGSELECT: function(state, data) {
		state.nbprogselect = data.nb
	},

	SET_NBRPLSSELECT: function(state, data) {
		state.nbrplsselect = data.nb
	},

	SET_NBOFFRESELECT: function(state, data) {
		state.nboffreselect = data.nb
	},

	SET_NBPCSELECT: function(state, data) {
		state.nbpcselect = data.nb
	},

	INC_NBPROGSELECT: function(state) {
		state.nbprogselect += 1
	},

	DEC_NBPROGSELECT: function(state) {
		state.nbprogselect -= 1
	},
	
	INC_NBRPLSSELECT: function(state) {
		state.nbrplsselect += 1
	},

	INC_NBOFFRESELECT: function(state) {
		state.nboffreselect += 1
	},

	DEC_NBRPLSSELECT: function(state) {
		state.nbrplsselect -= 1
	},
	
	DEC_NBOFFRESELECT: function(state) {
		state.nboffreselect -= 1
	},
	
	INC_NBPCSELECT: function(state) {
		state.nbpcselect += 1
	},

	DEC_NBPCSELECT: function(state) {
		state.nbpcselect -= 1
	},
	
	SET_NBRESIDENCESELECT: function(state, data) {
		state.nbresidenceselect = data.nb
	},

	INC_NBRESIDENCESELECT: function(state) {
		state.nbresidenceselect += 1
	},

	DEC_NBRESIDENCESELECT: function(state) {
		state.nbresidenceselect -= 1
	},
	
	SET_LIVE_DATA: function(state, data) {
		state.livedata = data.livedata
	},
	
	SET_JWT: function(state, data) {
		state.jwt = data.jwt
		state.user_id = data.user_id
		state.HeaderEfocusBack['Authorization'] = 'Bearer ' + data.jwt
	},
	
	AJOUTE_COMMUNES: function(state, data) {
		state.communes_selectionnees.push(data.code)
		state.nbprog += data.nbp
	},
	
	SET_ETAPE: function(state, data) {
		state.etape_selection = data.etape
	},
	
	RAZ_SECTEURS: function(state) {
		state.secteurs = []
	},

	SET_LOADING_MUTATIONS: function(state, data) {
		try {
			state.loading_mutations = data.loading
		} catch (error) {
			//
		}
	},

	SET_LOADING_OFFRE: function(state, data) {
		try {
			state.loading_offre = data.loading
		} catch (error) {
			//
		}
	},

	SET_LOADING: function(state, data) {
		try {
			state.loading = data.loading
		} catch (error) {
			//
		}
	},
	
	SET_LOADING_PDF: function(state, data) {
		try {
			state.loading_pdf = data.loading_pdf
		} catch (error) {
			//
		}
	},
	
	SET_AUTOLOG: function(state, data) {
		state.autolog = data.autolog
	},
	
	SET_LOADING_CITYSCAN: function(state, data) {
		if (data.item) {
			state.loading_cityscan = data.loading
		} else {
			if (data.item=='') {
				state.loading_cityscan = data.loading
			} else {
				state.loading_cityscan_item[data.item] = data.loading
				if (!state.loading_cityscan_item._10 && !state.loading_cityscan_item._12 && !state.loading_cityscan_item._14 && !state.loading_cityscan_item._15
					&& !state.loading_cityscan_item._21 && !state.loading_cityscan_item._22 && !state.loading_cityscan_item._23) {
						state.loading_cityscan = false
					} else {
						state.loading_cityscan = true
					}
				}
			}
	},
		
	SET_LOADING_AVM: function(state, data) {
		state.loading_avm = data.loading
	},
	
	SET_PROGRAMS: function(state, data) {
		state.programs = data.programs
	},
	
	SET_PROGRAMS_FILTER: function(state, data) {
		state.programs_filter = data.programs
	},
	
	SET_RPLS_COM: function(state, data) {
		state.rpls_commune = data.rpls_commune
	},

	SET_RSS: function(state, data) {
		state.rss = data.rss
	},
	
	SET_RPLSS: function(state, data) {
		state.rplss = data.rplss
	},
	
	SET_OFFRE: function(state, data) {
		state.offre = data.offre
	},
	
	SET_OFFRE_LOCATIF: function(state, data) {
		state.offre_locatif = data.offre
	},
	
	SET_RSS_FILTER: function(state, data) {
		state.rss_filter = data.rss
	},
	
	SET_RPLSS_FILTER: function(state, data) {
		state.rplss_filter = data.rplss
	},
	
	SET_OFFRE_FILTER: function(state, data) {
		state.offre_filter = data.offre
	},
	
	SET_OFFRE_LOCATIF_FILTER: function(state, data) {
		state.offre_locatif_filter = data.offre
	},
	
	SET_COMMUNES: function(state, data) {
		state.communes = data.communes
		state.codecommunes = data.codecommunes
	},
	
	SET_RS_COMMUNES: function(state, data) {
		state.rs_communes = data.rs_communes
		state.rs_codecommunes = data.rs_codecommunes
	},
	
	SET_RPLS_COMMUNES: function(state, data) {
		state.rpls_communes = data.rpls_communes
		state.rpls_codecommunes = data.rpls_codecommunes
	},
	
	SET_OFFRE_COMMUNES: function(state, data) {
		state.offre_communes = data.offre_communes
		state.offre_codecommunes = data.offre_codecommunes
	},
	
	SET_COMMUNES_STAT: function(state, data) {
		state.stats = data.data
		state.dateheure_recharge = _.now()
	},
	
	ASSOCIATE_PROGRAMS_MARKERS: function(state, data) {
		for (let i in data.markers) {
			let program = data.markers[i].program
			program.marker = data.markers[i]._icon
		}
	},
	
	ASSOCIATE_RSS_MARKERS: function(state, data) {
		for (let i in data.markers) {
			let rs = data.markers[i].program
			rs.marker = data.markers[i]._icon
		}
	},
	
	ASSOCIATE_PARCELLES_MARKERS: function(state, data) {
		for (let i in data.markers) {
			let parcelle = data.markers[i].parcelle
			parcelle.marker = data.markers[i]._icon
		}
	},
	
	ASSOCIATE_OFFRE_LOCATIF_MARKERS: function(state, data) {
		for (let i in data.markers) {
			let offre_locatif = data.markers[i].offre
			offre_locatif.marker = data.markers[i]._icon
		}
	},
	
	ASSOCIATE_OFFRE_MARKERS: function(state, data) {
		for (let i in data.markers) {
			let offre = data.markers[i].offre
			offre.marker = data.markers[i]._icon
		}
	},
	
	ASSOCIATE_LOCATIF_MARKERS: function(state, data) {
		for (let i in data.markers) {
			let a = data.markers[i].annonce
			a.marker = data.markers[i]._icon
		}
	},
	
	EDIT_APP: function(state, data) {
		for (let i in data) {
			Vue.set(state, i, data[i])
		}
	},
	
	EDIT_API_CALLS: function(state, data) {
		for (let i in data) {
			Vue.set(state.api_calls, i, data[i])
		}
	},	
	
	SET_SOURCE_VIEW(state, data) {
		state.source_view = data.view
	},

	SET_UNIQUEMENT_SELECTION: function(state, data) {
		state.uniquementselection = data.value;
	},

	SET_VIEW: function(state, data) {
		state.notificationone = []
		state.aide_live = false
		state.aide_prog = false
		state.aide = false
		state.viewlayer = false
		state.bienslocatifs = false
		state.filters_promotion = false
		state.filters_rs = false
		state.filters_ancien = false
		state.view_old = state.view
		state.view = data.view
		let v = data.view
		if (v.trim() == "") {
			v = "neuf"
		}
		if (v.trim() == "home") {
			try {
				//
			} catch (error) {
				console.log(error)
			}
		}
		try {
			router.push({ name: v}).catch(()=>{});
		} catch (error) {
			// Erreur
		}
	},
	
	SET_VIEW_LAYER: function(state, data) {
		state.viewlayer = data.view	
		if (state.viewlayer == 'insee') {
			state.active_segmentation = false
			state.expanded_program = false
			//state.viewprog = false
			//state.viewlayer_promo = false
		}


	},
	
	SET_VIEW_LAYER_PROMO: function(state, data) {
		state.viewlayer_promo = data.view		
	},
	
	SET_VIEW_LAYER_PC: function(state, data) {
		state.viewlayer_pc = data.view		
	},
	
	SET_VIEW_LAYER_RS: function(state, data) {
		state.viewlayer_rs = data.view		
	},
	
	SET_VIEW_LAYER_RPLS: function(state, data) {
		state.viewlayer_rpls = data.view		
	},
	
	SET_VIEW_LAYER_OFFRE: function(state, data) {
		state.viewlayer_offre = data.view		
	},
	
	SET_VIEW_LAYER_POI: function(state, data) {
		state.viewlayer_poi = data.view		
	},
	
	SET_VIEW_PROG: function(state, data) {
		state.viewprog = data.view
	},
	
	SET_AUTHORIZATION: function(state, data) {
		state.authorized = data.authorized
	},
	
	SET_NOLIVE: function(state, data) {
		state.nolive = data.nolive
	},
	
	SET_MODULE_CITYSCAN: function(state, data) {
		state.module_cityscan = data.module_cityscan
	},
	
	SET_MODULE_FONCIER: function(state, data) {
		state.module_foncier = data.module_foncier
	},
	
	SET_MODULE_RS: function(state, data) {
		state.module_rs = data.module_rs
	},
	
	SET_MODULE_RPLS: function(state, data) {
		state.module_rpls = data.module_rpls
	},
	
	SET_MODULE_OFFRE: function(state, data) {
		state.module_offre = data.module_offre
	},
	
	ADD_TO_SELECTED_PROGRAMS: function(state, data) {
		if (data.program) {
			if (_.indexOf(state.selected_programs, data.program.id) === -1) {
				state.selected_programs.push(data.program.id)
				state.selected_programs_syno.push(data.program)
				Vue.set(data.program, 'selected', true)
			}
		}
		
		else if (data.programs) {
			for (let i in data.programs) {
				if (_.indexOf(state.selected_programs, data.programs[i].id) === -1) {
					state.selected_programs.push(data.programs[i].id)
					state.selected_programs_syno.push(data.programs[i])
					Vue.set(data.programs[i], 'selected', true)
				}
			}
		}
	},
	
	REMOVE_ALL_PROGRAMS: function(state) {
		state.dateheure_recharge= false
		state.selected_programs_syno = []
		state.selected_programs = []
	},
	
	REMOVE_ALL_RSS: function(state) {
		state.dateheure_recharge= false
		state.selected_rss_syno = []
		state.selected_rss = []
	},
	
	REMOVE_ALL_RPLS: function(state) {
		state.dateheure_recharge_rpls= false
		state.selected_rplss_syno = []
		state.selected_rplss = []
	},
	
	REMOVE_ALL_OFFRE: function(state) {
		state.dateheure_recharge_offre= false
		state.selected_offre_syno = []
		state.selected_offre = []
	},
	
	REMOVE_TO_SELECTED_PROGRAMS: function(state, data) {
		let index
		if (data.program) {
			index = _.indexOf(state.selected_programs, data.program.id)
			if (index > -1) {
				state.selected_programs.splice(index, 1)
				state.selected_programs_syno.splice(index, 1)
				Vue.set(data.program, 'selected', false)
			}
		}
		
		else if (data.programs) {
			for (let i in data.programs) {
				index = _.indexOf(state.selected_programs, data.programs[i].id)
				if (index > -1) {
					state.selected_programs.splice(index, 1)
					state.selected_programs_syno.splice(index, 1)
					Vue.set(data.programs[i], 'selected', false)
				}
			}
		}
	},	
	
	EDIT_FILTER: function(state, data) {
		if (data.filter) {
			for (let i in data) {
				if (i != 'filter') {
					Vue.set(state.filters[data.filter], i, data[i])
				}
			}
		}
		if (state.filters.forme.collectif && state.filters.forme.individuel) {
			state.forme_urbaine = 3
		} else {
			if (state.filters.forme.collectif && !state.filters.forme.individuel) {
				state.forme_urbaine = 2
			} else {
				if (!state.filters.forme.collectif && state.filters.forme.individuel) {
					state.forme_urbaine = 1
				} else {
					state.forme_urbaine = 0
				}
			}
		}
		
	},
	
	SET_FILTER_PC: function(state, data) {
		state.filters_pc.pc_promoteur = data.pc_promoteur
		state.filters_pc.pc_bailleur = data.pc_bailleur
		state.filters_pc.pc_epl = data.pc_epl
		state.filters_pc.pc_administration = data.pc_administration
		state.filters_pc.pc_autre = data.pc_autre
		state.filters_pc.pc_nc = data.pc_nc
		state.filters_pc.pc_autorise = data.pc_autorise
		state.filters_pc.pc_annule = data.pc_annule
		state.filters_pc.pc_commence = data.pc_commence
		state.filters_pc.pc_termine = data.pc_termine
		state.filters_pc.filter_date = data.filter_date
		state.filters_pc.filter_date_type = data.filter_date_type
		if (data.filter_date_date.length) {
			for (let index = 0; index < 2; index++) {
				if (data.filter_date_date[index]) {
					let date = new Date(data.filter_date_date[index]);
					let year = date.getFullYear();
					let month = date.getMonth() + 1;
					let day = date.getDate();
					
					// Formate le mois et le jour pour s'assurer qu'ils sont toujours en format 'MM' ou 'DD'
					month = month < 10 ? '0' + month : month;
					day = day < 10 ? '0' + day : day;			
					if (index == 1) day = '31'
					state.filters_pc.filter_date_date[index] = `${year}-${month}-${day}`;
				}
			}
		}
	},
	
	SET_FILTER_GISEMENT: function(state, data) {
		if (data.filtre_gisement) {
			state.filtre_gisement = data.filtre_gisement
		}
		state.filtre_gisement_time = _.now()
	},

	SET_FILTER: function(state, data) {
		//console.log('SET_FILTER')
		state.filters.termine = data.termine
		state.filters.actif = data.actif
		state.filters.projet = data.projet
		state.filters.col = data.col
		state.filters.ind = data.ind
		state.filters.nb_one = data.nb_one
		state.filters.nb_two = data.nb_two
		state.filters.nb_three = data.nb_three
		state.filters.nb_four = data.nb_four
		state.filters.prix.min = data.prixmin
		state.filters.prix.max = data.prixmax
		state.filters.tvap = data.tvap
		state.filters.tvar = data.tvar
		state.filters.psla = data.psla
		state.filters.lli = data.lli
		state.filters.brs = data.brs
		state.filters.anru = data.anru
		state.filters.aucun = data.aucun
		state.filters.autres = data.autres
		state.filters.annee_actif = data.annee_actif
		state.filters.veb_avec = data.veb_avec
		state.filters.veb_sans = data.veb_sans
	},

	SET_FILTER_PREFERENCES: function(state, data) {
		state.preferences.neuf.listing.etat = data.affichage_prix_etat
		state.preferences.neuf.listing.tva = data.affichage_prix_tva
		state.preferences.neuf.listing.parking = data.affichage_prix_pk
	},

	ADD_NOTIFICATION: function(state, data) {
		if (!data.notification.id) data.notification.id = _.uniqueId('notification-')
		state.notifications.push(data.notification)
	},
	
	REMOVE_NOTIFICATION: function(state, data) {
		let index = _.indexOf(state.notifications, data.notification)
		state.notifications.splice(index, 1)
	},
	
	ADD_NOTIFICATIONONE: function(state, data) {
		state.notificationone = []
		if (!data.notificationone.id) data.notificationone.id = _.uniqueId('notificationone-')
		state.notificationone.push(data.notificationone)
	},
	
	REMOVE_NOTIFICATIONONE: function(state) {
		state.notificationone = []
	},
	
	RAZ_SELECTED_SECTEUR: function(state) {
		state.selected_secteurs = []
	},
	
	RAZ_SELECTED_PROGRAMMES: function(state) {
		state.selected_programs = []
	},
	
	RAZ_COMMUNES_SELECTIONNEES: function(state) {
		state.communes_selectionnees = []
	},

	SET_FITBOUNDS: function(state, b) {
		state.fitBounds = b
	},

	SET_ZOOM: function(state, data) {
		state.zoom = data.zoom
	},

	SET_PIN_TYPE: function(state, data) {
		state.pin_type = data.pin_type
	},

	SET_REPORT_LIST: function(state, data) {
		state.ReportList = data.ReportList
	},

	SET_ECHELLE: function(state, data) {
		state.echelleprix_1 = data.echelleprix_1
		state.echelleprix_2 = data.echelleprix_2
	},

	SET_FOND: function(state, data) {
		state.fond_carte = data.fond
	},

	SET_FOND_LOYER: function(state, data) {
		state.fond_carte_loyer = data.fond_loyer
	},

	SET_CONTOURS_TIME: function(state) {
		state.contours_time = _.now()
	},

	SET_CONTOURS_ISO_MAP: function(state, data) {
		state.contour_iso_map = data.contours
	},

	SET_CONTOURS: function(state, data) {
		try {
			if (data.type=="commune") {
				state.contour_commune = data.contours
			}
			if (data.type=="zac") {
				state.contour_zac = data.contours
			}
			if (data.type=="qpv") {
				state.contour_qpv = data.contours
			}
			if (data.type=="npnru") {
				state.contour_npnru = data.contours
			}
			if (data.type=="pnru") {
				state.contour_pnru = data.contours
			}
			if (data.type=="qpv_trois") {
				state.contour_qpv_trois = data.contours
			}
			if (data.type=="metro") {
				state.contour_metro = data.contours
			}
			if (data.type=="tramway") {
				state.contour_tramway = data.contours
			}
			if (data.type=="train") {
				state.contour_train = data.contours
			}
			if (data.type=="poi") {
				state.contour_poi = data.contours
				if (state.contour_poi) {
					state.contour_metro = state.contour_poi.includes('Métro')
					state.contour_ligne_gpe = state.contour_poi.includes('GPE')
					state.contour_tramway = state.contour_poi.includes('Tramway')
					state.contour_train = state.contour_poi.includes('Gare')
				}
			}
			if (data.type=="ecole") {
				state.contour_ecole = data.contours
			}
			if (data.type=="iso") {
				state.contour_iso = data.contours
			}
			if (data.type=="transports") {
				state.contour_transports = data.contours
			}
			if (data.type=="education") {
				state.contour_education = data.contours
			}
			if (data.type=="commerces") {
				state.contour_commerces = data.contours
			}
			if (data.type=="services") {
				state.contour_services = data.contours
			}
			if (data.type=="loisirs") {
				state.contour_loisirs = data.contours
			}
			if (data.type=="loyer") {
				state.contour_loyer = data.contours
				state.contour_loyer_time = _.now()
			}
			if (data.type=="prix") {
				state.contour_prix = data.contours
			}
			if (data.type=="ligne_gpe") {
				state.contour_ligne_gpe = data.contours
			}

			if (data.type=="r_innondation") {
				state.contour_r_innondation = data.contours
			}
			if (data.type=="r_nappe_phreatique") {
				state.contour_r_nappe_phreatique = data.contours
			}
			if (data.type=="r_mouvement_argileux") {
				state.contour_r_mouvement_argileux = data.contours
			}
			if (data.type=="r_glissement_terrain") {
				state.contour_r_glissement_terrain = data.contours
			}
			if (data.type=="r_site_industriel") {
				state.contour_r_site_industriel = data.contours
			}
			if (data.type=="r_sol_pollue") {
				state.contour_r_sol_pollue = data.contours
			}
			if (data.type=="contour_parcelle") {
				state.contour_parcelle = data.contours
			}

		}
		catch (error) {
			console.error(error);
		}
	},

	SET_COMMUNE_ZOOM: function(state, data) {
		state.commune_zoom = data
	},

	SET_AVM_COMMUNE: function(state, data) {
		state.avm.commune.prix_min = data.prix_min
		state.avm.commune.prix_med = data.prix_med
		state.avm.commune.prix_max = data.prix_max
	},

	SET_AVM_COMMUNE_ALL: function(state, data) {
		state.avm.commune_ref_tous.prix_min = data.prix_min
		state.avm.commune_ref_tous.prix_med = data.prix_med
		state.avm.commune_ref_tous.prix_max = data.prix_max
	},

	SET_AVM_REF_T3: function(state, data) {
		state.avm.ref_t3.prix_min = data.prix_min
		state.avm.ref_t3.prix_med = data.prix_med
		state.avm.ref_t3.prix_max = data.prix_max
	},

	SET_AVM_REF_ALL: function(state, data) {
		state.avm.ref_tous.prix_min = data.prix_min
		state.avm.ref_tous.prix_med = data.prix_med
		state.avm.ref_tous.prix_max = data.prix_max
	},

	SET_AVM_HEATMAP: function(state, data) {
		state.avm.heatmap.data = data.data
		state.avm.heatmap.m = data.m
		state.avm.heatmap.diff = data.diff
		state.avm.heatmap.cpt = data.cpt
		state.avm.heatmap.price = data.price
		state.avm.heatmap.rayon = data.rayon
	},

	SET_AVM_MARCHE: function(state, data) {
		state.avm.prix_marche = data.prix_marche
		state.avm.prix_avenir = data.prix_avenir
		state.avm.prix_evol = data.prix_evol
	},

	SET_MARKER: function(state, data) {
		if (data) {
			state.mrk.lat = data.lat
			state.mrk.lng = data.lng
			this.map_osm.panTo(new L.LatLng(0, 0));
			this.map_osm.panTo(new L.LatLng(data.lat, data.lng));
		} else {
			state.mrk.lat = false
			state.mrk.lng = false
		}
		state.mrktime = _.now();
	},

	SET_MODULE_ACTIF: function(state, data) {
		state.module_actif = data.actif
	},
	
	SET_ADR_QUERY: function(state, data) {
		state.adr_query.data.name = data.data.name
		state.adr_query.data.postcode = data.data.postcode
		state.adr_query.data.city = data.data.city
		state.idf = state.module_cityscan
	},

	SET_ADR_INIT: function(state, data) {
		state.adr_init = data
		state.cityscan_scalesData = false;
	},

	SET_ADR_ZONE: function(state, data) {
		state.zonage = data.zonage
	},
	URL_REPORT_INIT: function(state, data) {
		state.url_report = data.url
	},

	URL_REPORT_DISPO: function(state, data) {
		state.report_dispo = data.dispo
	},

	CHANGE_PERIODE: function(state, data) {
		state.tab = data.periodicite
	},

	SET_ADDRESSID: function(state, data) {
		state.cityscan.addressId = data.id
		state.cityscan.lat = data.lat
		state.cityscan.lon = data.lon
	},
	
	SET_ACTIVATIONID: function(state, data) {
		state.cityscan.activationId = data.id
	},

	SET_CITYSCAN_SCALES: function(state, data) {
		state.cityscan_scalesData = data.scalesData
	},

	SET_EVAL_CITYSCAN: function(state, data) {
		state.cityscan.adresse.pm2 = data.content.estimation.surfacePrice
		state.cityscan.adresse.priceStandard = data.content.estimation.priceStandard
		state.cityscan.adresse.priceLow = data.content.estimation.priceLow
		state.cityscan.adresse.priceHigh = data.content.estimation.priceHigh
	},

	SET_EVAL_PRIX_CITYSCAN: function(state, data) {
		if (data.content.indicators && data.content.indicators.length) {
			try {
				state.cityscan.adresse.pm2_ = parseFloat(data.content.indicators[0].characteristics.priceMeanValue)
				state.cityscan.adresse.priceLow_ = parseFloat(data.content.indicators[0].characteristics.priceMinValue)
				state.cityscan.adresse.priceHigh_ = parseFloat(data.content.indicators[0].characteristics.priceMaxValue)

				let d0 = new Date();
				let cle0 = d0.toISOString().split('T')[0].substring(0, 8) + "01"
				while (!data.content.indicators[0].characteristics.priceTrends[cle0]) {
					d0.setMonth(d0.getMonth() - 1);
					cle0 = d0.toISOString().split('T')[0].substring(0, 8) + "01";
				}
				
				state.cityscan.adresse.priceTrends = []
				while (data.content.indicators[0].characteristics.priceTrends[cle0]) {
					const resultat = state.cityscan.adresse.priceTrends.find( p => p.date === cle0);
					if (!resultat) {
						state.cityscan.adresse.priceTrends.push({date : cle0, price: data.content.indicators[0].characteristics.priceTrends[cle0].value})
					}
					d0.setMonth(d0.getMonth() - 1);
					cle0 = d0.toISOString().split('T')[0].substring(0, 8) + "01";
				}
				d0 = new Date(state.cityscan.adresse.priceTrends[0].date);
				let d1 = new Date(state.cityscan.adresse.priceTrends[0].date);
				let d2 = new Date(state.cityscan.adresse.priceTrends[0].date);
				d1.setMonth(d1.getMonth() - 12);
				d2.setMonth(d2.getMonth() - 24);
				cle0 = d0.toISOString().split('T')[0].substring(0, 8) + "01"
				let cle1 = d1.toISOString().split('T')[0].substring(0, 8) + "01"
				let cle2 = d2.toISOString().split('T')[0].substring(0, 8) + "01"
				state.cityscan.adresse.pm2_0 = 0
				state.cityscan.adresse.pm2_12 = 0
				state.cityscan.adresse.pm2_24 = 0
				state.cityscan.adresse.pm2_36 = 0
				state.cityscan.adresse.pm2_48 = 0
				if (data.content.indicators[0].characteristics.priceTrends[cle0]) {
					state.cityscan.adresse.pm2_0 = data.content.indicators[0].characteristics.priceTrends[cle0].value
				}
				if (data.content.indicators[0].characteristics.priceTrends[cle1]) {
					state.cityscan.adresse.pm2_12 = data.content.indicators[0].characteristics.priceTrends[cle1].value
				}
				if (data.content.indicators[0].characteristics.priceTrends[cle2]) {
					state.cityscan.adresse.pm2_24 = data.content.indicators[0].characteristics.priceTrends[cle2].value
				}
				state.cityscanprixtime = _.now();
			} catch (error) {
				console.log(error)
			}
		}
	},

	SET_FILTER_LOCATIF: function(state, data) {
		if (data) {
			state.filtre_locatif.price_min = data.price_min
			state.filtre_locatif.price_max = data.price_max
			state.filtre_locatif.area_min = data.area_min
			state.filtre_locatif.area_max = data.area_max
			state.filtre_locatif.t1 = data.t1
			state.filtre_locatif.t2 = data.t2
			state.filtre_locatif.t3 = data.t3
			state.filtre_locatif.t4 = data.t4
			state.filtre_locatif.t5 = data.t5
			
			state.filtre_locatif.A = data.A
			state.filtre_locatif.B = data.B
			state.filtre_locatif.C = data.C
			state.filtre_locatif.D = data.D
			state.filtre_locatif.E = data.E
			state.filtre_locatif.F = data.F
			state.filtre_locatif.G = data.G
			state.filtre_locatif.NC = data.NC
			state.filtre_locatif.MeubleOui = data.MeubleOui
			state.filtre_locatif.MeubleNon = data.MeubleNon
			state.filtre_locatif.MeubleNC = data.MeubleNC
		}
	
		for (let index = 0; index < state.liste_biens_locatifs.hits.length; index++) {
			
			if ((state.liste_biens_locatifs.hits[index].features.geometry.surface>=state.filtre_locatif.area_min)
			&& (state.liste_biens_locatifs.hits[index].features.geometry.surface<=state.filtre_locatif.area_max)
			&& (state.liste_biens_locatifs.hits[index].marketing.priceHC>=state.filtre_locatif.price_min)
			&& (state.liste_biens_locatifs.hits[index].marketing.priceHC<=state.filtre_locatif.price_max)
			)
			{
				if ((state.liste_biens_locatifs.hits[index].features.geometry.roomCount==1 & !(state.filtre_locatif.t1))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount==2 & !(state.filtre_locatif.t2))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount==3 & !(state.filtre_locatif.t3))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount==4 & !(state.filtre_locatif.t4))
				|| (state.liste_biens_locatifs.hits[index].features.geometry.roomCount>4 & !(state.filtre_locatif.t5)))
				{
					state.liste_biens_locatifs.hits[index].filter = false
				} else {
					if (!((state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='A' & state.filtre_locatif.A)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='B' & state.filtre_locatif.B)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='C' & state.filtre_locatif.C)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='D' & state.filtre_locatif.D)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='E' & state.filtre_locatif.E)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='F' & state.filtre_locatif.F)
					|| (state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter=='G' & state.filtre_locatif.G)
					|| (((!(state.liste_biens_locatifs.hits[index].features.energy)) || (!(state.liste_biens_locatifs.hits[index].features.energy.consumptionLetter)) ) & state.filtre_locatif.NC)))
					{
						state.liste_biens_locatifs.hits[index].filter = false
					} else {
						try {
							if (!((state.liste_biens_locatifs.hits[index].features.descriptive.equipments.FURNITURE & state.filtre_locatif.MeubleOui)
							|| (!state.liste_biens_locatifs.hits[index].features.descriptive.equipments.FURNITURE & state.filtre_locatif.MeubleNon)
							|| (((!(state.liste_biens_locatifs.hits[index].features.descriptive)) || (!(state.liste_biens_locatifs.hits[index].features.descriptive.equipments)) ) & state.filtre_locatif.MeubleNC)))
							{
								state.liste_biens_locatifs.hits[index].filter = false
							} else {
								state.liste_biens_locatifs.hits[index].filter = true
							}
						} catch (error) {
							if (state.filtre_locatif.MeubleNC) {
								state.liste_biens_locatifs.hits[index].filter = true
							} else {
								state.liste_biens_locatifs.hits[index].filter = false
							}
						}
					}
				}
			} else {
				state.liste_biens_locatifs.hits[index].filter = false
			}
		}
		
		
		
		
	},
	
	SET_FILTER_RS: function(state, data) {
		if (data) {
			state.rss_filter = []
			state.filtre_rs.MeubleOui = data.MeubleOui
			state.filtre_rs.MeubleNon = data.MeubleNon
			state.filtre_rs.MeubleNC = data.MeubleNC
			state.filtre_rs.ServiceOui = data.ServiceOui
			state.filtre_rs.ServiceNon = data.ServiceNon
			state.filtre_rs.ServiceNC = data.ServiceNC
			state.filtre_rs.E1 = data.E1
			state.filtre_rs.E2 = data.E2
			state.filtre_rs.E3 = data.E3
			state.filtre_rs.E4 = data.E4
			state.filtre_rs.E5 = data.E5
			state.filtre_rs.ENC = data.ENC
			state.filtre_rs.etudiant = data.etudiant
			state.filtre_rs.senior = data.senior
			state.filtre_rs.jeune = data.jeune
			state.filtre_rs.inter = data.inter
			state.filtre_rs.social = data.social
			state.filtre_rs.touriste = data.touriste
			state.filtre_rs.tout = data.tout

			state.filtre_rs.nature.BEGUINAGE = data.BEGUINAGE
			state.filtre_rs.nature.CHRS = data.CHRS
			state.filtre_rs.nature.COPROPRIETE = data.COPROPRIETE
			state.filtre_rs.nature.EHPAD = data.EHPAD
			state.filtre_rs.nature.FJT = data.FJT
			state.filtre_rs.nature.REPOS = data.REPOS
			state.filtre_rs.nature.REPOS_SOINS = data.REPOS_SOINS
			state.filtre_rs.nature.AUTONOMIE = data.AUTONOMIE
			state.filtre_rs.nature.RSE_LIBRE = data.RSE_LIBRE
			state.filtre_rs.nature.RSE_MIXTE = data.RSE_MIXTE
			state.filtre_rs.nature.RSE_SOCIAL = data.RSE_SOCIAL
			state.filtre_rs.nature.RSS = data.RSS
			state.filtre_rs.nature.VILLAGE_PRIVE = data.VILLAGE_PRIVE
			state.filtre_rs.nature.VILLAGE_SOCIAL = data.VILLAGE_SOCIAL
			state.filtre_rs.nature.MARPA = data.MARPA
			state.filtre_rs.nature.HOTEL = data.HOTEL
			state.filtre_rs.nature.RESIDENCE_DE_TOURISME = data.RESIDENCE_DE_TOURISME
			state.filtre_rs.nature.HOTEL_ET_RÉSIDENCE = data.HOTEL_ET_RÉSIDENCE
			state.filtre_rs.nature.COLIVING = data.COLIVING
			state.filtre_rs.nature.COLIVING_HABITAT_PARTAGE = data.COLIVING_HABITAT_PARTAGE
			state.filtre_rs.nature.COLOCATION = data.COLOCATION

			state.filtre_rs.cible = data.cible
			state.filtre_rs.natures = data.natures

			for (let index = 0; index < state.rss.length; index++) {
				state.rss[index].filter = true
				if ((state.rss[index].cible=="SENIOR" & !(state.filtre_rs.senior))
				|| (state.rss[index].cible=="SOCIAL ADOMA" & !(state.filtre_rs.social))
				|| (state.rss[index].cible=="ADOMA" & !(state.filtre_rs.social))
				|| (state.rss[index].cible=="SOCIAL" & !(state.filtre_rs.social))
				|| (state.rss[index].cible=="TOURISTE" & !(state.filtre_rs.touriste))
				|| (state.rss[index].cible=="TOUT AGE" & !(state.filtre_rs.tout))
				|| (state.rss[index].cible=="JEUNES" & !(state.filtre_rs.jeune))
				|| (state.rss[index].cible=="INTERGENERATIONNEL" & !(state.filtre_rs.inter))
				|| (state.rss[index].cible=="ETUDIANT" & !(state.filtre_rs.etudiant))
				)
				{
					state.rss[index].filter = false
				} else {
					if ((state.rss[index].nature=="BEGUINAGE" & !(state.filtre_rs.nature.BEGUINAGE))
					|| (state.rss[index].nature=="RÉSIDENCE SERVICES SÉNIORS (RSS) LIBRE" & !(state.filtre_rs.nature.RSS))
					|| (state.rss[index].nature=="MAISONS DE REPOS ET DE SOINS" & !(state.filtre_rs.nature.REPOS_SOINS))
					|| (state.rss[index].nature=="RÉSIDENCE SERVICES ETUDIANTS (RSE) LIBRE" & !(state.filtre_rs.nature.RSE_LIBRE))
					|| (state.rss[index].nature=="EHPAD" & !(state.filtre_rs.nature.EHPAD))
					|| (state.rss[index].nature=="MAISON DE REPOS" & !(state.filtre_rs.nature.REPOS))
					|| (state.rss[index].nature=="VILLAGE SENIOR SOCIAL" & !(state.filtre_rs.nature.VILLAGE_SOCIAL))
					|| (state.rss[index].nature=="RÉSIDENCE SERVICES ETUDIANTS (RSE) MIXTE" & !(state.filtre_rs.nature.RSE_MIXTE))
					|| (state.rss[index].nature=="FOYER JEUNES TRAVAILLEURS (FJT)" & !(state.filtre_rs.nature.FJT))
					|| (state.rss[index].nature=="MARPA" & !(state.filtre_rs.nature.MARPA))
					|| (state.rss[index].nature=="VILLAGE SENIOR PRIVE" & !(state.filtre_rs.nature.VILLAGE_PRIVE))
					|| (state.rss[index].nature=="RÉSIDENCE SERVICES ETUDIANTS (RSE) SOCIALE" & !(state.filtre_rs.nature.RSE_SOCIAL))
					|| (state.rss[index].nature=="CHRS - Centre d'hébergement et de réinsertion sociale" & !(state.filtre_rs.nature.CHRS))
					|| (state.rss[index].nature=="RESIDENCE AUTONOMIE" & !(state.filtre_rs.nature.AUTONOMIE))
					|| ((state.rss[index].nature=="COPROPRIÉTÉ" || state.rss[index].nature=="RSS 1ère GENERATION") & !(state.filtre_rs.nature.COPROPRIETE))

					|| (state.rss[index].nature=="HÔTEL" & !(state.filtre_rs.nature.HOTEL))
					|| (state.rss[index].nature=="RÉSIDENCE DE TOURISME" & !(state.filtre_rs.nature.RESIDENCE_DE_TOURISME))
					|| (state.rss[index].nature=="HÔTEL ET RÉSIDENCE" & !(state.filtre_rs.nature.HOTEL_ET_RÉSIDENCE))
					|| (state.rss[index].nature=="COLIVING" & !(state.filtre_rs.nature.COLIVING))
					|| (state.rss[index].nature=="COLIVING - HABITAT PARTAGE" & !(state.filtre_rs.nature.COLIVING_HABITAT_PARTAGE))
					|| (state.rss[index].nature=="COLOCATION" & !(state.filtre_rs.nature.COLOCATION))
					)
					{
						state.rss[index].filter = false
					} else {
		
						if ((state.rss[index].etoiles=="1 étoile" & !(state.filtre_rs.E1))
						|| (state.rss[index].etoiles=="2 étoiles" & !(state.filtre_rs.E2))
						|| (state.rss[index].etoiles=="3 étoiles" & !(state.filtre_rs.E3))
						|| (state.rss[index].etoiles=="4 étoiles" & !(state.filtre_rs.E4))
						|| (state.rss[index].etoiles=="5 étoiles" & !(state.filtre_rs.E5))
						|| (state.rss[index].etoiles=="" & !(state.filtre_rs.ENC))
						)
						{
							state.rss[index].filter = false
						} else {
							try {
								if ((state.rss[index].meublee=="OUI" & !state.filtre_rs.MeubleOui)
								|| (state.rss[index].meublee=="NON" & !state.filtre_rs.MeubleNon)
								|| (state.rss[index].meublee=="" & !state.filtre_rs.MeubleNC))
								{
									state.rss[index].filter = false
								} else {
									if ((state.rss[index].services=="OUI" & !state.filtre_rs.ServiceOui)
									|| (state.rss[index].services=="NON" & !state.filtre_rs.ServiceNon)
									|| (state.rss[index].services=="" & !state.filtre_rs.ServiceNC))
									{
										state.rss[index].filter = false
									} else {
										state.rss[index].filter = true
										state.rss_filter.push(state.rss[index])
									}
								}
							} catch (error) {
								if (state.filtre_rs.MeubleNC) {
									state.rss[index].filter = true
								} else {
									state.rss[index].filter = false
								}
							}
						}
					}
				}
			}
		}
		
	},
	
	SET_FILTER_ANCIEN: function(state, data) {
		state.filter_ancien_time = _.now()
		if (data) {
			state.filtre_ancien.price_min = data.price_min
			state.filtre_ancien.price_max = data.price_max
			state.filtre_ancien.area_min = data.area_min
			state.filtre_ancien.area_max = data.area_max
			state.filtre_ancien.t1 = data.t1
			state.filtre_ancien.t2 = data.t2
			state.filtre_ancien.t3 = data.t3
			state.filtre_ancien.t4 = data.t4
			state.filtre_ancien.t5 = data.t5
			state.filtre_ancien.col = data.col
			state.filtre_ancien.ind = data.ind
			state.filtre_ancien.nbmois = data.nbmois
			state.filtre_ancien.distance = data.distance
			let currentDate = new Date();
			currentDate.setMonth(currentDate.getMonth() - state.filtre_ancien.nbmois);
			let year = currentDate.getFullYear();
			let month = currentDate.getMonth() + 1; // getMonth() renvoie un index à partir de 0
			let day = currentDate.getDate();
			// Formatez le mois et le jour pour qu'ils aient toujours deux chiffres
			month = month < 10 ? '0' + month : month;
			day = day < 10 ? '0' + day : day;
			// Concaténez pour obtenir le format final
			state.filtre_ancien.cdh = `${year}-${month}-${day}`;
		}

		for (let index = 0; index < state.cityscan.adresse.biens_comparables.length; index++) {
			if ((state.cityscan.adresse.biens_comparables[index].area>=state.filtre_ancien.area_min)
			&& (state.cityscan.adresse.biens_comparables[index].area<=state.filtre_ancien.area_max)
			&& (state.cityscan.adresse.biens_comparables[index].pricePerSquareMeter>=state.filtre_ancien.price_min)
			&& (state.cityscan.adresse.biens_comparables[index].pricePerSquareMeter<=state.filtre_ancien.price_max)
			)
			{
				if ((state.cityscan.adresse.biens_comparables[index].rooms==1 & state.filtre_ancien.t1)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==2 & state.filtre_ancien.t2)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==3 & state.filtre_ancien.t3)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==4 & state.filtre_ancien.t4)
				|| (state.cityscan.adresse.biens_comparables[index].rooms>4 & state.filtre_ancien.t5))
				{
					if (state.cityscan.adresse.biens_comparables[index].baseDate > (state.filtre_ancien.cdh)) {
						if (state.cityscan.adresse.biens_comparables[index].distance < state.filtre_ancien.distance) state.cityscan.adresse.biens_comparables[index].filter = true
						else state.cityscan.adresse.biens_comparables[index].filter = false
					}
					else state.cityscan.adresse.biens_comparables[index].filter = false
				}
				else {
					state.cityscan.adresse.biens_comparables[index].filter = false
				}
			} else {
				state.cityscan.adresse.biens_comparables[index].filter = false
			}
		}
	},

	SET_FILTER_RPLS: function(state, data) {
		if (data) {
			state.filtre_rpls.distance = data.distance
		}
		for (let index = 0; index < state.rplss.length; index++) {
			if (state.rplss[index].distance < state.filtre_rpls.distance) state.rplss[index].filter = true
			else state.rplss[index].filter = false
		}
		state.filter_rpls_time = _.now()
	},

	SET_FILTER_ANCIEN_OFFRE: function(state, data) {
		if (data) {
			state.filtre_ancien_offre.price_min = data.price_min
			state.filtre_ancien_offre.price_max = data.price_max
			state.filtre_ancien_offre.area_min = data.area_min
			state.filtre_ancien_offre.area_max = data.area_max
			state.filtre_ancien_offre.t1 = data.t1
			state.filtre_ancien_offre.t2 = data.t2
			state.filtre_ancien_offre.t3 = data.t3
			state.filtre_ancien_offre.t4 = data.t4
			state.filtre_ancien_offre.t5 = data.t5

			state.filtre_ancien_offre.appartement = data.appartement
			state.filtre_ancien_offre.maison = data.maison
			state.filtre_ancien_offre.A = data.A
			state.filtre_ancien_offre.B = data.B
			state.filtre_ancien_offre.C = data.C
			state.filtre_ancien_offre.D = data.D
			state.filtre_ancien_offre.E = data.E
			state.filtre_ancien_offre.F = data.F
			state.filtre_ancien_offre.G = data.G
			state.filtre_ancien_offre.NC = data.NC
			state.filtre_ancien_offre.distance = data.distance
		}


		for (let index = 0; index < state.offre.length; index++) {
			if ((state.offre[index].surfaceArea>=state.filtre_ancien_offre.area_min)
			&& (state.offre[index].surfaceArea<=state.filtre_ancien_offre.area_max)
			&& (state.offre[index].price>=state.filtre_ancien_offre.price_min)
			&& (state.offre[index].price<=state.filtre_ancien_offre.price_max)
			)
			{
				if ((state.offre[index].roomsQuantity==1 & state.filtre_ancien_offre.t1)
				|| (state.offre[index].roomsQuantity==2 & state.filtre_ancien_offre.t2)
				|| (state.offre[index].roomsQuantity==3 & state.filtre_ancien_offre.t3)
				|| (state.offre[index].roomsQuantity==4 & state.filtre_ancien_offre.t4)
				|| (state.offre[index].roomsQuantity>4 & state.filtre_ancien_offre.t5))
				{

					if ((state.offre[index].propertyType=="flat" & state.filtre_ancien_offre.appartement)
						|| (state.offre[index].propertyType!="flat" & state.filtre_ancien_offre.maison))
					{
						if ((state.offre[index].energyClassification=="A" & state.filtre_ancien_offre.A)
							|| (state.offre[index].energyClassification=="B" & state.filtre_ancien_offre.B)
							|| (state.offre[index].energyClassification=="C" & state.filtre_ancien_offre.C)
							|| (state.offre[index].energyClassification=="D" & state.filtre_ancien_offre.D)
							|| (state.offre[index].energyClassification=="E" & state.filtre_ancien_offre.E)
							|| (state.offre[index].energyClassification=="F" & state.filtre_ancien_offre.F)
							|| (state.offre[index].energyClassification=="G" & state.filtre_ancien_offre.G)
							|| ((!state.offre[index].energyClassification || state.offre[index].energyClassification=="") & state.filtre_ancien_offre.NC))
						{
							if (state.offre[index].distance < state.filtre_ancien_offre.distance) state.offre[index].filter = true
							else state.offre[index].filter = false
						} else {
							state.offre[index].filter = false
						}
					} else {
						state.offre[index].filter = false	
					}
				}
				else {
					state.offre[index].filter = false
				}
			} else {
				state.offre[index].filter = false
			}
		}
		state.filter_ancien_offre_time = _.now()
	},

	SET_FILTER_LOCATIF_OFFRE: function(state, data) {
		if (data) {
			state.filtre_offre_locatif.price_min = data.price_min
			state.filtre_offre_locatif.price_max = data.price_max
			state.filtre_offre_locatif.area_min = data.area_min
			state.filtre_offre_locatif.area_max = data.area_max
			state.filtre_offre_locatif.t1 = data.t1
			state.filtre_offre_locatif.t2 = data.t2
			state.filtre_offre_locatif.t3 = data.t3
			state.filtre_offre_locatif.t4 = data.t4
			state.filtre_offre_locatif.t5 = data.t5

			state.filtre_offre_locatif.appartement = data.appartement
			state.filtre_offre_locatif.maison = data.maison
			state.filtre_offre_locatif.A = data.A
			state.filtre_offre_locatif.B = data.B
			state.filtre_offre_locatif.C = data.C
			state.filtre_offre_locatif.D = data.D
			state.filtre_offre_locatif.E = data.E
			state.filtre_offre_locatif.F = data.F
			state.filtre_offre_locatif.G = data.G
			state.filtre_offre_locatif.NC = data.NC
			state.filtre_offre_locatif.distance = data.distance
		}

		state.filter_locatif_offre_time = _.now()
	},

	SET_BIENS_CITYSCAN: function(state, data) {
		state.cityscan.adresse.nb_biens_total = data.nbtotal
		state.cityscan.adresse.nb_biens = data.nb
		state.cityscan.adresse.biens_comparables = data.biens_comparables
		for (let index = 0; index < state.cityscan.adresse.biens_comparables.length; index++) {
			state.cityscan.adresse.biens_comparables[index].id = state.cityscan.adresse.biens_comparables[index].propertyId
			if ((state.cityscan.adresse.biens_comparables[index].area>=state.filtre_ancien.area_min)
			&& (state.cityscan.adresse.biens_comparables[index].area<=state.filtre_ancien.area_max)
			&& (state.cityscan.adresse.biens_comparables[index].pricePerSquareMeter>=state.filtre_ancien.price_min)
			&& (state.cityscan.adresse.biens_comparables[index].pricePerSquareMeter<=state.filtre_ancien.price_max)
			)
			{
				if ((state.cityscan.adresse.biens_comparables[index].rooms==1 & state.filtre_ancien.t1)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==2 & state.filtre_ancien.t2)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==3 & state.filtre_ancien.t3)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==4 & state.filtre_ancien.t4)
				|| (state.cityscan.adresse.biens_comparables[index].rooms>4 & state.filtre_ancien.t5))
				{
					if (state.cityscan.adresse.biens_comparables[index].baseDate > (state.filtre_ancien.cdh)) {
						if (state.cityscan.adresse.biens_comparables[index].distance < state.filtre_ancien.distance) state.cityscan.adresse.biens_comparables[index].filter = true
						else state.cityscan.adresse.biens_comparables[index].filter = false
					}
					else state.cityscan.adresse.biens_comparables[index].filter = false
				}
				else {
					state.cityscan.adresse.biens_comparables[index].filter = false
				}
			} else {
				state.cityscan.adresse.biens_comparables[index].filter = false
			}
			state.filter_ancien_time = _.now()
		}
		
		let t = []
		for (let n=0; n<state.cityscan.adresse.biens_comparables.length;n++) {
			if (state.cityscan.adresse.biens_comparables[n].propertyType !='industrial_commercial_premise') {
				t.push(state.cityscan.adresse.biens_comparables[n])
			}
		}
		state.cityscan.adresse.biens_comparables.sort(function compare(a, b) {
			if (a.baseDate > b.baseDate)
			return -1;
			if (a.baseDate < b.baseDate )
			return 1;
			return 0;
		});
		
	},

	SET_BIENS_DVF: function(state, data) {
		state.cityscan.adresse.nb_biens_total = data.nbtotal
		state.cityscan.adresse.nb_biens = data.nb
		state.cityscan.adresse.biens_comparables = []

		for (let index = 0; index < data.biens_comparables.length; index++) {
			const element = data.biens_comparables[index]._source;
			element.distance = data.biens_comparables[index].fields.distance
			element.location = {coordinates: [element.location.lat, element.location.lon]}
			element.id = element.propertyId
			state.cityscan.adresse.biens_comparables.push(element)
		}
		//state.cityscan.adresse.biens_comparables = data.biens_comparables
		/*
		for (let index = 0; index < state.cityscan.adresse.biens_comparables.length; index++) {
			if ((state.cityscan.adresse.biens_comparables[index].area>=state.filtre_ancien.area_min)
			&& (state.cityscan.adresse.biens_comparables[index].area<=state.filtre_ancien.area_max)
			&& (state.cityscan.adresse.biens_comparables[index].pricePerSquareMeter>=state.filtre_ancien.price_min)
			&& (state.cityscan.adresse.biens_comparables[index].pricePerSquareMeter<=state.filtre_ancien.price_max)
			)
			{
				if ((state.cityscan.adresse.biens_comparables[index].rooms==1 & state.filtre_ancien.t1)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==2 & state.filtre_ancien.t2)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==3 & state.filtre_ancien.t3)
				|| (state.cityscan.adresse.biens_comparables[index].rooms==4 & state.filtre_ancien.t4)
				|| (state.cityscan.adresse.biens_comparables[index].rooms>4 & state.filtre_ancien.t5))
				{
					if (state.cityscan.adresse.biens_comparables[index].baseDate > (state.filtre_ancien.cdh)) {
						if ((state.cityscan.adresse.biens_comparables[index].propertyType =='Appartement' & state.filtre_ancien.col) || (state.cityscan.adresse.biens_comparables[index].propertyType =='Maison' & state.filtre_ancien.ind)) {
							state.cityscan.adresse.biens_comparables[index].filter = true
						}
						else state.cityscan.adresse.biens_comparables[index].filter = false
					}
					else state.cityscan.adresse.biens_comparables[index].filter = false
				}
				else {
					state.cityscan.adresse.biens_comparables[index].filter = false
				}
			} else {
				state.cityscan.adresse.biens_comparables[index].filter = false
			}
		}
		*/
		state.cityscan.adresse.biens_comparables.sort(function compare(a, b) {
			if (a.baseDate > b.baseDate) return -1;
			if (a.baseDate < b.baseDate ) return 1;

			// Si baseDate est identique, comparer les ids
			if (a.id > b.id) return -1;
			if (a.id < b.id) return 1;

			return 0;
		});
		state.filter_ancien_time = _.now()
		state.loading_mutations = false
	},

	SET_MENU: function(state) {
		state.menuvisible = !state.menuvisible
	},

	SET_MENU_FALSE: function(state) {
		state.menuvisible = false
	},

	SET_USER: function(state, data) {		
		if (state.user) state.user.adequation = false
		state.user = data.user
		state.user.adequation = state.user.email.includes('@adequation-france.com')
		let array_po = ['s.dupont@adequation-france.com', 'j.roux@adequation-france.com', 'l.magnaldo@adequation-france.com', 's.guy@adequation-france.com', 'j.hanson@adequation-france.com', 'k.forel@adequation-france.com', 'n.guruphat@adequation-france.com']
		state.user.adequation_po = (array_po.indexOf(state.user.email) >= 0)
	},

	SET_REALTY: function(state, data) {
		
		state.cityscan.realty.name = data.realty.name
		state.cityscan.realty.typeId = data.realty.typeId
		state.cityscan.realty.rooms = data.realty.rooms
		state.cityscan.realty.buildingConstruction = data.realty.buildingConstruction
		state.cityscan.realty.condition = data.realty.condition
		state.cityscan.realty.parkingOpen = data.realty.parkingOpen
		state.cityscan.realty.area		 = data.realty.area
	},

	SET_RESULT_EVALUATION_ADRESSE: function(state, data) {
		state.evaluationAdresse = data
	},
	
	SET_MODULE_ADRESSE: function(state, data) {
		state.ModuleAdresse = data.actif
	},
	
	SET_SCORING_CITYSCAN: function(state, data) {
		if (data) {
			if (data.name!='') {
				try {
					state.cityscan.adresse[data.name].note = data.note
					state.cityscan.adresse[data.name].score = data.score
					state.cityscan.adresse[data.name].temps = data.temps
					state.cityscan.adresse[data.name].nb = data.nb
					state.cityscan.adresse[data.name].transport = data.transport
					state.cityscan.adresse[data.name].factors = data.factors
					state.cityscan.adresse[data.name].duration = data.duration
					state.cityscan.adresse[data.name].transportType = data.transportType
				} catch (error) {
					//	console.log(error)
				}
			}
		}
		
		switch (data.name) {
			case 'transport':
			state.cityscan.adresse.note_transports = data.note
			state.cityscan.adresse.score_transports = data.score
			break;
			case 'education':
			state.cityscan.adresse.note_education = data.note
			state.cityscan.adresse.score_education = data.score
			break;
			case 'commerce':
			state.cityscan.adresse.note_commerces = data.note
			state.cityscan.adresse.score_commerces = data.score
			break;
			case 'vie':
			state.cityscan.adresse.note_qualite = data.note
			state.cityscan.adresse.score_qualite = data.score
			break;
			case 'loisirs':
			state.cityscan.adresse.note_loisirs = data.note
			state.cityscan.adresse.score_loisirs = data.score
			break;
			case 'numerique':
			state.cityscan.adresse.note_numerique = data.note
			state.cityscan.adresse.score_numerique = data.score
			break;
			case 'services':
			state.cityscan.adresse.note_services = data.note
			state.cityscan.adresse.score_services = data.score
			break;
			
			default:
			break;
		}
	},
	
	SET_PROGRAMMES_PRIX: function(state, data) {
		state.program_prix.min = data.min
		state.program_prix.max = data.max
		state.program_prix.tab = data.tab
	},

	SET_NB_FILTRE: function(state, data) {
		state.filters.nb_filtre = data.nb
	},
	SET_LISTE_POI: function(state, data) {
		state.listepoi = data.listepoi
	},
	SET_LOADING_YANPORT: function(state, data) {
		
		state.loading_yanport += data.v
		state.progress_bar = (state.loadingAll || state.loading_yanport>0)
	},
	SET_LOADINGALL: function(state, data) {
		state.loadingAll = data.loadingAll
		state.progress_bar = (state.loadingAll || (state.loading_yanport<34 && state.loading_yanport>0))
		if (!state.progress_bar && state.loading_yanport==34) state.loading_yanport=0
	},
	SET_SIGNOUT: function(state) {
		state.loadingAll = false
		state.uniquementselection= false
		state.loyer_tranches= []
		state.geo_init= false
		state.activeSection2= ''
		state.viewlayer_promo= true
		state.viewlayer_rs= false
		state.viewlayer_rpls = false
		state.viewlayer_offre = false
		state.viewlayer_poi= false
		state.viewlayer_pc= true
		state.territoires_module=false
		state.module_actif= null
		state.refresh_prog= false
		state.refresh_rs= false
		state.refresh_offre = false
		state.ModuleAdresse= false
		state.nouveaute = []
		state.bienslocatifs= false
		state.parambienslocatifs= false
		state.filter_ancien_time= false
		state.loyer_yanport_date= []
		state._deleteDateMax= ""
		state._deleteDateMin= ""
		state.liste_biens_locatifs= false
		state.loyer_yanport_time=''
		state.active_segmentation= false
		state.gestionhistorique= true
		state.histo_program= false
		state.idf= false
		state.aide= false
		state.aide_rs= false
		state.aide_prog= false
		state.aide_live= false
		state.filters_promotion= false
		state.filters_rs= false
		state.filters_ancien= false
		state.theme=false
		state.autolog= false
		state.dateheure_recharge=false
		state.menuvisible= true
		state.loading_cityscan= false
		state.mrk.lat= false
		state.mrk.lng= false
		state.nolive= false
		state.livedata_id=0
		state.url_report = ''
		state.report_dispo = false
		state.pin_type= 'prix'
		state.livedata= false
		state.echelleprix_1 = 0
		state.echelleprix_2 = 0
		state.fitBounds= false
		state.map_osm= false
		state.select_parcelle= false
		state.zoom_default=16
		state.zoom_B= 14
		state.zoom= 16
		state.tab= 'trimestres'
		state.view= 'home' // home list report
		state.view_old= 'home' // home list report
		state.viewlayer= '' // home list report
		state.viewprog=''
		state.route= ''
		state.forme_urbaine= 2
		state.adr_init= ''
		state.zonage= ''
		state.enable_notification= true // active ou désactive l'affichage des notifications en haut à droite
		state.notifications= [] // Liste des objects "notification" à afficher en haut à droite
		state.notificationone= []
		state.obs= true
		state.listeville= []
		state.secteurs= []
		state.rs_secteurs= []
		state.programs= []
		state.rss= []
		state.communes= []
		state.codecommunes= []
		state.rs_communes= []
		state.rs_codecommunes= []
		state.selected_programs_syno= []
		state.selected_programs= []
		state.selected_secteurs= []
		state.selected_rss_syno= []
		state.selected_rss= []
		state.selected_rs_secteurs= []
		state.expanded_program= false
		state.expanded_rs= false
		state.expanded_rpls= false
		state.expanded_offre= false
		state.expanded_offre_locatif= false
		state.expanded_parcelle= false
		state.programs_filter = []
		state.rss_filter = []
		state.rplss_filter = []
		state.offre_filter = []
		state.loading= false
		state.loading_calc= false
		state.loading_avm= false
		state.print= false
		state.authorized= true
		state.jwt=""
		state.user_id=""
		state.region= ""
		state.departements= ""
		state.departement= ""
		state.FormeUrbaine=3
		state.etape_selection=0
		state.communes_selectionnees=[]
		state.nbprog= 0
		state.nbprogselect = 0
		state.nbrplsselect = 0
		state.nboffreselect = 0
		state.nbpcselect = 0
		state.nbresidenceselect = 0
		state.fond_carte= 0
		state.fond_carte_loyer=1
		state.contour_iso= true
		state.contour_commune= false
		state.contour_zac= false
		state.contour_qpv= false
		state.contour_pnru= false
		state.contour_npnru= false
		state.contour_qpv_trois= false
		state.contour_metro= false
		state.contour_tramway= false
		state.contour_train= false
		state.contour_poi= false
		state.contour_ecole= false
		state.contour_transports= false
		state.contour_education= false
		state.contour_commerces= false
		state.contour_services= false
		state.contour_loisirs= false
		state.commune_zoom= false
		state.contour_loyer= false
		state.contour_loyer_time= false
		state.contour_prix= false
		state.ReportList= false
		state.module_cityscan= false
		state.module_rs= false
		state.module_rpls= false
		state.module_offre= false
	},
	
	SET_EFOCUS_TYPE: function(state, data) {
		state.efocus_type = data.efocus_type
	},
		
	LIST_SECTEUR: function(state, data) {
		state.list_secteur = data.list_secteur
	},

	SET_INSEE: function(state, data) {
		state.insee = data.insee.insee
		state.insee_kpi = data.insee.insee_kpi
		state.insee_sitadel = data.insee.insee_sitadel
		state.insee_sne = data.insee.insee_sne
		state.insee_offre_locative = data.insee.insee_offre_locative
		state.insee_offre_vente = data.insee.insee_offre_vente
	},

	SET_IMG_STREETVIEW: function(state, data) {
		state.imggooglestreetview = data.url
	},
	SET_CHART_REF: function(state, data) {
		state[data.g] = data.r
	},
	
	SET_VALUE: function(state, data) {
		state[data.c] = data.v
	},
}


export default { state, getters, actions, mutations }
